module.exports = {
  "messages": {
    "EP_503_ERROR": "Offenbar haben wir gerade ein kleines Problem.",
    "EP_503_ERROR_SUBLINE": "Einen Moment Geduld bitte, wir arbeiten schon daran.",
    "EP_ABOUT_US_DESCRIPTION": "Über uns",
    "EP_ABOUT_US_DISCOVER_CTA": "Alle Infos ansehen",
    "EP_ABOUT_US_HEADLINE": "Über uns",
    "EP_ABOUT_US_NAVIGATION_TITLE": "Über uns",
    "EP_ABOUT_US_SUBPAGE_LINK": "Alle Infos ansehen",
    "EP_AFFILIATES": "Verbindungen zu anderen Unternehmen",
    "EP_ALERT_DIALOG_FOLLOW_BTN_CANCEL": "Abbrechen",
    "EP_ALERT_DIALOG_FOLLOW_BTN_CONFIRM": "Folgen",
    "EP_ALERT_DIALOG_FOLLOW_BTN_OK": "Alles klar",
    "EP_ALL_CONTACTS": "Alle Ansprechpersonen",
    "EP_AWARDS_HEADLINE": "Auszeichnungen",
    "EP_BENEFIT_ACCESSIBILITY": "Barrierefreiheit",
    "EP_BENEFIT_CANTEEN": "Kantine",
    "EP_BENEFIT_CAR_PARK": "Parkplatz",
    "EP_BENEFIT_CHILDCARE": "Kinderbetreuung",
    "EP_BENEFIT_COMPANY_CAR": "Firmenwagen",
    "EP_BENEFIT_COMPANY_DOCTOR": "Betriebsarzt",
    "EP_BENEFIT_COMPANY_PENSION": "Betriebliche Altersvorsorge",
    "EP_BENEFIT_CONVENIENT_TRANSPORT_LINKS": "Günstige Anbindung",
    "EP_BENEFIT_DISCOUNTS_SPECIAL_OFFERS": "Rabatte",
    "EP_BENEFIT_DOGS_WELCOME": "Hunde willkommen",
    "EP_BENEFIT_EVENTS_FOR_EMPLOYEES": "Veranstaltungen",
    "EP_BENEFIT_FLEXITIME": "Flexible Arbeitszeiten",
    "EP_BENEFIT_HEALTH_IN_THE_WORKPLACE": "Gesundheitsmaßnahmen",
    "EP_BENEFIT_HOME_OFFICE": "Home-Office",
    "EP_BENEFIT_MOBILE_DEVICE": "Smartphone",
    "EP_BENEFIT_PRIVATE_INTERNET_USE": "Privat das Internet nutzen",
    "EP_BENEFIT_PROFIT_SHARING": "Gewinnbeteiligung",
    "EP_BENEFIT_RESTAURANT_TICKETS": "Restaurant-Tickets",
    "EP_BENEFIT_TRAINING": "Training",
    "EP_CANCEL": "Abbrechen",
    "EP_CHOOSE_COVER_INFO_BANNER": "Tipps für ein gelungenes Titelbild",
    "EP_CHOOSE_COVER_INFO_BANNER_CTA": "Tipps lesen",
    "EP_CLEAR_ALL": "Filter entfernen",
    "EP_COMMBOX_POST": "Teilen",
    "EP_COMMBOX_POSTING_SUCCESSFUL_MESSAGE": "Beitrag geteilt",
    "EP_COMPANY_ABOUT_US_FACTS": "Steckbrief",
    "EP_COMPANY_ABOUT_US_INDUSTRY": "Branche",
    "EP_CONTACTS_DESCRIPTION": "Ansprechpersonen bei",
    "EP_CONTACTS_MODULE_TITLE": "Ansprechpersonen",
    "EP_CONTACTS_NAVIGATION_TITLE": "Kontakt",
    "EP_DISCUSSION_COMMBOX_BLOCKED_BANNER": "Du wurdest blockiert und kannst zur Zeit nicht an der Gruppen-Diskussion teilnehmen. Wende Dich bitte an das Moderations-Team.",
    "EP_DISCUSSION_EMPTY_STATE_BODY": "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    "EP_DISCUSSION_EMPTY_STATE_BODY_LO": "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    "EP_DISCUSSION_EMPTY_STATE_HEADLINE": "Hier gibt's noch keine Beiträge.",
    "EP_DISCUSSION_EMPTY_STATE_HEADLINE_LO": "Hier gibt's noch keine Beiträge.",
    "EP_DISCUSSION_EMPTY_STATE_MODERATOR_BODY": "Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.",
    "EP_DISCUSSION_EMPTY_STATE_MODERATOR_HEADLINE": "Schreib Deinen ersten Gruppen-Beitrag.",
    "EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_BODY": "Ausgeblendete Beiträge sind nur für das Moderations-Team sichtbar, erscheinen aber nicht in der Gruppe. Klick auf das kleine Auge neben einem Beitrag, um ihn auszublenden. ",
    "EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_HEADLINE": "Es gibt momentan keine ausgeblendeten Beiträge.",
    "EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_BODY": "Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.",
    "EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_HEADLINE": "Veröffentliche Deinen ersten Gruppen-Beitrag.",
    "EP_DISCUSSIONS_DELETE_POST": "Diesen Beitrag löschen?",
    "EP_DISCUSSIONS_DELETE_POST_POPUP_BODY": "Dies kann nicht mehr rückgängig gemacht werden.",
    "EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_CANCEL": "Abbrechen",
    "EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_DELETE": "Löschen",
    "EP_DISCUSSIONS_DESCRIPTION": "Diskussionen",
    "EP_DISCUSSIONS_HIDE_POST": "Beitrag ausblenden",
    "EP_DISCUSSIONS_HIDE_POST_ERROR": "Das hat leider gerade nicht geklappt. Versuch es bitte noch einmal.",
    "EP_DISCUSSIONS_HIDE_POST_POPUP_BODY": "Dann ist er für die Gruppe nicht mehr sichtbar.",
    "EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_CANCEL": "Abbrechen",
    "EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_HIDE": "Ausblenden",
    "EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_UNHIDE": "Wieder einblenden",
    "EP_DISCUSSIONS_HIDE_POST_POPUP_HEADLINE": "Beitrag ausblenden?",
    "EP_DISCUSSIONS_MARK_POST": "Beitrag oben anpinnen",
    "EP_DISCUSSIONS_NAVIGATION_TITLE": "Diskussionen",
    "EP_DISCUSSIONS_REPORT_POST": "Beitrag melden",
    "EP_DISCUSSIONS_UNHIDE_POST": "Wieder einblenden",
    "EP_DISCUSSIONS_UNHIDE_POST_POPUP_BODY": "Der Beitrag ist dann wieder unter \"Diskussionen\" in Deiner Gruppe sichtbar.",
    "EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_CANCEL": "Abbrechen",
    "EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_HIDE": "Wieder einblenden",
    "EP_DISCUSSIONS_UNHIDE_POST_POPUP_HEADLINE": "Diesen Beitrag wieder einblenden?",
    "EP_DOCUMENTS_HEADLINE": "Dokumente",
    "EP_EDIT_ABOUTUS_HINT": "<b>Tipp:</b> Nenne hier Eure wichtigsten Produkte bzw. Dienstleistungen. Benutze dabei Begriffe, die Eure Zielgruppe auch benutzt. Dadurch ist die Seite nämlich bei Google & Co. besser auffindbar.\nDu kannst hier eine Kurz- und eine Detailbeschreibung eingeben – oder nur eine Detailbeschreibung: Dann werden deren erste Sätze als Kurzbeschreibung angezeigt.",
    "EP_EDIT_COMPANY_FACTS_TITLE": "Steckbrief",
    "EP_EMPLOYEES": "Mitarbeitende",
    "EP_EMPLOYEES_BUTTON_ADD_CONTACT": "Hinzufügen",
    "EP_EMPLOYEES_BUTTON_SEND_MESSAGE": "Nachricht",
    "EP_EMPLOYEES_DESCRIPTION": "Mitarbeitende",
    "EP_EMPLOYEES_FEEDBACK_ERROR": "Das hat gerade leider nicht geklappt. Versuch's bitte nochmal.",
    "EP_EMPLOYEES_HEADLINE": "Mitarbeitende",
    "EP_EMPLOYEES_NAVIGATION_TITLE": "Mitarbeitende",
    "EP_ERROR_HEADER": "Warum ist hier denn nichts zu sehen?",
    "EP_ERROR_RELOAD_CTA": "Aktualisieren",
    "EP_FOLLOW": "Folgen",
    "EP_FOLLOWERS.one": "Follower",
    "EP_FOLLOWERS.other": "Follower",
    "EP_FOLLOWERS.zero": "Follower",
    "EP_FOLLOWING": "Folgst Du",
    "EP_GENERAL_FEEDBACK_ERROR": "Das hat leider nicht geklappt – einfach nochmal versuchen.",
    "EP_GM_IMAGE_INFO_BANNER": "So wählst Du ideale Bilder aus:",
    "EP_GM_IMAGE_INFO_BANNER_CTA": "Tipps lesen",
    "EP_GO_HOME": "Zur Startseite",
    "EP_GROUP_RULES_TITLE": "Gruppenregeln",
    "EP_IDEAL_EMPLOYER_ADD": "Als Wunsch-Arbeitgeber hinzufügen",
    "EP_IDEAL_EMPLOYER_ADD_CONFIDENTIALLY": "Füg dieses Unternehmen einfach als Wunsch-Arbeitgeber hinzu, um es vertraulich über Dein Interesse zu informieren.",
    "EP_IDEAL_EMPLOYER_ADDED": "Als Wunsch-Arbeitgeber hinzugefügt",
    "EP_IDEAL_EMPLOYER_CONFIDENTIAL_INFO": "Außer dem Arbeitgeber erfährt niemand davon – es sei denn, Du hast andere in Deinen Job-Wünschen dafür freigeschaltet.",
    "EP_IDEAL_EMPLOYER_HEADLINE": "Wunsch-Arbeitgeber",
    "EP_IDEAL_EMPLOYER_NAVIGATION_TITLE": "Wunsch-Arbeitgeber",
    "EP_IDEAL_EMPLOYER_REMOVE": "Doch kein Wunsch-Arbeitgeber?",
    "EP_IDEAL_EMPLOYER_WORK": "Würdest Du hier gern arbeiten?",
    "EP_JOB_JOBBOX": "Gemerkte Jobs ansehen",
    "EP_JOBS_CAREER_LEVEL": "Karriere-Stufe",
    "EP_JOBS_DESCRIPTION": "Jobs",
    "EP_JOBS_DISCIPLINE": "Tätigkeitsfeld",
    "EP_JOBS_EMPTYSTATE_BODY": "Dann schalte doch gleich mal eine Stellenanzeige.",
    "EP_JOBS_EMPTYSTATE_HEADER": "Seid Ihr auf der Suche nach Fachkräften?",
    "EP_JOBS_FILTER_ALL": "Alle",
    "EP_JOBS_HEADLINE": "Jobs",
    "EP_JOBS_LOCATIONS": "Arbeitsorte",
    "EP_JOBS_NAVIGATION_TITLE": "Jobs",
    "EP_JOBS_PUBLIC_EMPTYSTATE_BODY": "Dann guck Dir mal unsere Empfehlungen an und entdecke neue Jobs.",
    "EP_JOBS_PUBLIC_EMPTYSTATE_CTA": "Zu den Empfehlungen",
    "EP_JOBS_PUBLIC_EMPTYSTATE_HEADER": "Bist Du auf Job-Suche?",
    "EP_JOBS_SEARCH_PLACEHOLDER": "Job-Titel oder Stichwort eingeben",
    "EP_JOIN_GROUP_CTA": "Beitreten",
    "EP_KUNUNU_BENEFITS_TITLE": "Vorteile für Mitarbeitende",
    "EP_KUNUNU_HEADLINE": "Bewertungen & Kultur",
    "EP_KUNUNU_NAVIGATION_TITLE": "Bewertungen & Kultur",
    "EP_KUNUNU_RATE_COMPANY": "Arbeitest Du hier – oder hast mal hier gearbeitet?",
    "EP_KUNUNU_RATE_COMPANY_BUTTON": "Arbeitgeber bewerten",
    "EP_KUNUNU_RATING": "Bewertung auf kununu",
    "EP_KUNUNU_RECOMMENDATION": "empfehlen diesen Arbeitgeber",
    "EP_KUNUNU_REVIEW_TITLE": "Zitate von Mitarbeitenden",
    "EP_KUNUNU_REVIEWER_CURRENT_JOB": "Arbeitet hier",
    "EP_KUNUNU_REVIEWER_FORMER_JOB": "Hat hier gearbeitet",
    "EP_KUNUNU_REVIEWER_INTERNSHIP_JOB": "Praktikum",
    "EP_KUNUNU_REVIEWER_NS_JOB": "Keine Angabe",
    "EP_LEGAL_NOTICE": "Impressum",
    "EP_LOAD_MORE_CTA": "Mehr anzeigen",
    "EP_LOCATIONS_HEADLINE": "Standort",
    "EP_LOCATIONS_NAVIGATION_TITLE": "Ort",
    "EP_LOCATIONS_OPEN_MAP": "Größere Karte",
    "EP_MEDIA_HEADLINE": "Impressionen",
    "EP_MEMBERS_DESCRIPTION": "Mitglieder",
    "EP_MEMBERS_NAVIGATION_TITLE": "Mitglieder",
    "EP_META_DISCUSSIONS_DESCRIPTION": "✅  Aktuelle Themen und Diskussionen der Gruppe {pageTitle}.",
    "EP_META_DISCUSSIONS_TITLE": "{pageTitle}: Diskussionen | XING",
    "EP_META_MEMBERS_DESCRIPTION": "✅ Schau nach, wer schon dabei ist, und erweiter Dein Netzwerk.",
    "EP_META_MEMBERS_TITLE": "Mitglieder der Gruppe {pageTitle} | XING",
    "EP_MODULE_DISCUSSION_EDITOR_TAB_HIDDEN": "Ausgeblendet",
    "EP_MODULE_DISCUSSION_EDITOR_TAB_PUBLISHED": "Veröffentlicht",
    "EP_MODULE_DISCUSSION_SHOW_MORE": "Mehr anzeigen",
    "EP_MODULE_DISCUSSION_TITLE": "Diskussionen",
    "EP_MODULE_DISCUSSIONS_ALL_LINK": "Alle Beiträge",
    "EP_NEWS_DESCRIPTION": "Neuigkeiten",
    "EP_NEWS_HEADLINE": "Neuigkeiten",
    "EP_NEWS_NAVIGATION_TITLE": "Neuigkeiten",
    "EP_NEWS_SHOW_ALL": "Alle Neuigkeiten",
    "EP_ON_XING": "auf XING",
    "EP_PENDING_GROUP_JOIN_INFO": "Zu bestätigen",
    "EP_REPORT_PAGE": "Seite melden",
    "EP_SEE_ALL_AWARDS": "Alle Auszeichnungen",
    "EP_SHARE_PAGE": "Seite teilen",
    "EP_SLOGAN_EDIT_HEADLINE_INFO": "Füg hier Euren Slogan hinzu – oder die Essenz Eurer Seite in wenigen Worten.",
    "EP_UNFOLLOW": "Nicht mehr folgen",
    "EP_UPDATES_EDIT_EMPTY_STATE_DESCRIPTION": "Mit jedem neuen Beitrag machst Du XING Mitglieder auf Deine Seite aufmerksam.",
    "EP_UPDATES_EDIT_EMPTY_STATE_HEADLINE": "Füg hier Deinen ersten Artikel hinzu.",
    "EP_UPDATES_PUBLIC_EMPTY_STATE_DESCRIPTION": "Folge der Seite einfach, um keine Neuigkeiten mehr zu verpassen.\t",
    "EP_UPDATES_PUBLIC_EMPTY_STATE_HEADLINE": "Sobald es Neuigkeiten gibt, siehst Du sie hier.",
    "EP_UPLOAD_LOGO_EDIT_INFO": "Tipps für ein perfektes Logo auf Deiner XING Seite gefällig?",
    "EP_UPLOAD_LOGO_EDIT_INFO_CTA": "Tipps lesen",
    "EP_VISIT_WEBSITE": "Website",
    "COMMBOX_IMAGE_BUTTON_LABEL": "Bild hinzufügen",
    "COMPANY_BENEFIT_ACCESSIBILITY": "Barrierefreiheit",
    "COMPANY_BENEFIT_CANTEEN": "Kantine",
    "COMPANY_BENEFIT_CHILDCARE": "Kinderbetreuung",
    "COMPANY_BENEFIT_COMPANY_CAR": "Firmenwagen",
    "COMPANY_BENEFIT_COMPANY_DOCTOR": "Betriebsarzt",
    "COMPANY_BENEFIT_COMPANY_PENSION": "Betriebliche Altersvorsorge",
    "COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS": "Günstige Anbindung",
    "COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS": "Vorteile für Mitarbeitende",
    "COMPANY_BENEFIT_DOGS_WELCOME": "Hunde willkommen",
    "COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES": "Veranstaltungen",
    "COMPANY_BENEFIT_FLEXITIME": "Flexible Arbeitszeiten",
    "COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE": "Gesundheitsmaßnahmen",
    "COMPANY_BENEFIT_HOME_OFFICE": "Home-Office",
    "COMPANY_BENEFIT_MOBILE_DEVICE": "Smartphone",
    "COMPANY_BENEFIT_PRIVATE_INTERNET_USE": "Privat das Internet nutzen",
    "COMPANY_BENEFIT_PROFIT_SHARING": "Gewinnbeteiligung",
    "COMPANY_BENEFIT_RESTAURANT_TICKETS": "Restaurant-Tickets",
    "COMPANY_BENEFIT_TRAINING": "Training",
    "CP_KUNUNU_RATED_BY": "{kununu_ratings_num} Arbeitgeber-Bewertungen auf",
    "CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US": "Ähnliche Unternehmen",
    "EP_404_ERROR": "Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.",
    "EP_404_ERROR_SUBLINE": "Aber hier gibt's garantiert was zu entdecken",
    "EP_500_ERROR": "Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen.",
    "EP_500_ERROR_SUBLINE": "Komm bitte in ein paar Minuten nochmal wieder. Wir arbeiten daran. ",
    "EP_ABOUT_US_SUBPAGE_EDIT_DESCRIPTION": "Titel und Beschreibung bearbeiten",
    "EP_ADD_CONTACTS_SEARCH_LABEL": "Ansprechperson hinzufügen",
    "EP_ADD_CTA": "Hinzufügen",
    "EP_ADD_IMAGE": "Bild hinzufügen",
    "EP_ADD_MORE_COMPANIES": "Verbindung hinzufügen",
    "EP_ADD_VIDEO": "Video hinzufügen",
    "EP_ADMINISTRATE_PAGE": "Seite verwalten",
    "EP_AFFILIATES_CATEGORY_ASSOCIATE": "Schwester",
    "EP_AFFILIATES_CATEGORY_CLIENT": "Kunde",
    "EP_AFFILIATES_CATEGORY_FRANCHISE": "Franchise",
    "EP_AFFILIATES_CATEGORY_JOINT_VENTURE": "Joint Venture",
    "EP_AFFILIATES_CATEGORY_PARENT": "Mutter",
    "EP_AFFILIATES_CATEGORY_PARTNER": "Geschäftspartner",
    "EP_AFFILIATES_CATEGORY_REGIONAL_BRANCH": "Niederlassung",
    "EP_AFFILIATES_CATEGORY_SERVICE_PROVIDER": "Dienstleister",
    "EP_AFFILIATES_CATEGORY_SUBSIDIARY": "Tochter",
    "EP_AFFILIATES_FEEDBACK_ERROR": "Das hat leider nicht geklappt.",
    "EP_AFFILIATES_NO_DATA_DESCRIPTION": "Also z. B. andere Firmen Eurer Unternehmensgruppe, Eure Dienstleister, Eure Kunden usw.",
    "EP_AFFILIATES_NO_DATA_HEADER": "Hier steht, mit welchen Unternehmen Ihr eine Verbindung habt.",
    "EP_AFFILIATES_UPSELL_BODY": "Verlinke auf XING Seiten von Unternehmen, die mit Deinem eigenen Unternehmen verbunden sind, und stell Eure Marke so umfassend dar.",
    "EP_AFFILIATES_UPSELL_HEADLINE": "Partnerprofile verknüpfen",
    "EP_AFFILIATES_VALIDATION_NO_NAME_ERROR": "Hier bitte das Unternehmen eingeben",
    "EP_AFFILIATION_TYPE": "Art der Verbindung",
    "EP_ALERT_DIALOG_FOLLOW_INFORMATION_WEB": "Gute Nachricht: Du folgst {page} schon.",
    "EP_ALERT_DIALOG_FOLLOW_QUESTION_WEB": "Du siehst die neuesten Beiträge von {page} dann immer automatisch unter Insights.",
    "EP_ALERT_DIALOG_FOLLOW_TITLE_WEB": "{page} folgen?",
    "EP_AMOUNT_EMPLOYEES": "Mitarbeitende",
    "EP_AND": "und",
    "EP_ARMSTRONG_CREATE": "Erstellen",
    "EP_ARMSTRONG_CREATE_POST": "Beitrag",
    "EP_AWARDS_EDIT_HINT": "Hier werden alle Auszeichnungen gelistet, die in Eurem kununu-Profil hinterlegt sind.",
    "EP_BACK_TO_OVERVIEW": "Zurück zur Übersicht",
    "EP_BANNER_ROLLOUT_AUTOMATIC_ROLLOUT": "Am 30. Nov. 2020 werden wir alle Arbeitgeberprofile ins neue Design konvertieren und alle bisherigen Daten für Euch übernehmen. Schließ die Migration bereits jetzt selbst ab, um sicherzustellen, dass sich Deine Arbeitgebermarke optimal präsentiert. Bitte beachte, dass Du nicht auf das alte Design zurück wechseln kannst.",
    "EP_CHANGE_IMAGE_CTA": "Bild ändern",
    "EP_CHANGE_TITLE_INFO": "Möchtest Du den Titel Eurer Seite ändern? Dann schreib uns gern: <a href=\"mailto:customer.support@xing.com\">customer.support@xing.com</a>",
    "EP_CHANGE_TITLE_INFO_FREE": "Möchtest Du den Titel Eurer Seite ändern? Dann schreib uns gern: <a href=\"mailto:arbeitgeberprofil@xing.com\">arbeitgeberprofil@xing.com</a>",
    "EP_CHANGE_TITLE_INFO_FREE_V2": "Möchtest Du den Titel Eurer Seite ändern? Dann schreib uns gern: <a>arbeitgeberprofil@xing.com</a>",
    "EP_CHANGE_TITLE_INFO_V2": "Möchtest Du den Titel Eurer Seite ändern? Dann schreib uns gern: <a>customer.support@xing.com</a>",
    "EP_CHOOSE_ACTION": "Was möchtest Du tun?",
    "EP_CHOOSE_COVER": "Titelbild auswählen",
    "EP_CHOOSE_LOGO": "Füg hier Euer Logo hinzu: Dann ist auf einen Blick klar, um wessen XING Seite es sich handelt.",
    "EP_CHOOSE_SECTION": "Änder hier den Ausschnitt:",
    "EP_COMMBOX_ERROR": "Das hat leider nicht geklappt – versuch's bitte nochmal.",
    "EP_COMMBOX_PLACEHOLDER": "Gibt's was, das Du mit anderen teilen möchtest?",
    "EP_COMPANIES_AUTOMIGRATION_BANNER_CONTACT_SUPPORT": "Hast Du Fragen dazu? Wir helfen Dir gern:\n<br/>\nE-Mail: <a href=\"mailto:customer.support@xing.com\">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131-778\n",
    "EP_COMPANIES_AUTOMIGRATION_BANNER_REDIRECT_ADVISE": "Wenn der Link zu Eurem alten Arbeitgeberprofil aufgerufen wird, leiten wir automatisch zur neuen XING Seite weiter.",
    "EP_COMPANIES_AUTOMIGRATION_BANNER_TITLE": "Frischer Wind für Euer Arbeitgeberprofil",
    "EP_COMPANIES_AUTOMIGRATION_BANNER_UPDATED_URL": "Der Link Eurer XING Seite ist jetzt <strong>www.xing.com/pages/{slug}</strong>.",
    "EP_COMPANIES_FEEDBACK_BANNER": "Dein Feedback hilft uns, das XING Employer Branding Profil für Dich zu optimieren! ",
    "EP_COMPANIES_FEEDBACK_BANNER_BUTTON": "Hier geht's zur Umfrage",
    "EP_COMPANY_INDUSTRY": "Branche",
    "EP_COMPANY_NAME": "Unternehmensname",
    "EP_COMPANY_NAME_VALIDATION_ERROR": "2-64 Zeichen kann man hier eingeben.",
    "EP_COMPANY_NOT_FOUND": "Unternehmen nicht gefunden",
    "EP_COMPANY_PAGE_CREATION_ERROR": "Das hat leider nicht geklappt – versuch's bitte nochmal.",
    "EP_COMPANY_PAGE_CREATION_INVALID_CHARACTERS_ERROR": "Bitte gib hier nur Buchstaben und Ziffern ein, keine Sonderzeichen.",
    "EP_COMPANY_PAGE_CREATION_NAME_ALREADY_USED_ERROR": "Für diesen Namen gibt's schon eine XING Seite. War da vielleicht jemand schneller? Kontaktier uns gern, wenn Du dazu noch Fragen hast.",
    "EP_COMPANY_PAGE_CREATION_NAME_HAS_ONLY_NUMBERS_ERROR": "Dieser Name enthält leider nur Zahlen. Bitte verwende auch Buchstaben.",
    "EP_COMPANY_PAGE_CREATION_NAME_TOO_LONG_ERROR": "Dieser Name ist leider zu lang: Bis zu 80 Zeichen sind möglich.",
    "EP_COMPANY_PAGE_CREATION_NAME_TOO_SHORT_ERROR": "Dieser Name ist leider zu kurz: Mindestens zwei Zeichen sind notwendig.",
    "EP_COMPANY_PAGE_CREATION_STEP_1": "Basis-Infos",
    "EP_COMPANY_PAGE_CREATION_STEP_2": "Kontaktdaten",
    "EP_COMPANY_PAGE_CREATION_STEP_3": "Unternehmenslogo",
    "EP_COMPANY_PAGE_CREATION_STEP_4": "Kurzbeschreibung",
    "EP_COMPANY_RECOMMENDATIONS_HEADLINE": "Empfehlenswerte Unternehmen",
    "EP_COMPANY_RECOMMENDATIONS_NAVIGATION_TITLE": "Ähnliche Unternehmen",
    "EP_COMPANY_SOCIAL_PROOF.one": "{username} arbeitet hier.",
    "EP_COMPANY_SOCIAL_PROOF.other": "{numberOfContacts} Deiner Kontakte arbeiten hier.",
    "EP_COMPANY_SUMMARY": "Steckbrief",
    "EP_CONFIRMATION_LAST_STEP_CREATE_PAGE": "– Sobald die Seite freigeschaltet ist, sagen wir Dir per E-Mail Bescheid (innerhalb von 72 Stunden).",
    "EP_CONTACT_EDIT_LABEL": "Beschreibung der Ansprechperson",
    "EP_CONTACT_FOLLOWING": "folgt dieser Seite.",
    "EP_CONTACT_WORK": "arbeitet hier.",
    "EP_CONTACTS_CHANGE_OWNER_INFO": "Wenn Du den Eigentümer dieser Seite ändern möchtest, schreib uns bitte: <a href=\"mailto:{cs_email}\">{cs_email}</a>",
    "EP_CONTACTS_CHANGE_OWNER_INFO_V2": "Wenn Du den Eigentümer dieser Seite ändern möchtest, schreib uns bitte: <a>{cs_email}</a>",
    "EP_CONTACTS_EDIT_CTA": "Ansprechpersonen bearbeiten",
    "EP_CONTACTS_EDIT_TITLE": "Ansprechpersonen bearbeiten",
    "EP_CONTACTS_EMPTY_LIST": "Wer steht Besuchern Eurer XING Seite für Fragen, Anregungen und Anliegen zur Verfügung? Trag diese Personen hier ein.",
    "EP_CONTACTS_FOLLOWING": "folgen dieser Seite.",
    "EP_CONTACTS_HEADLINE": "Ansprechpersonen",
    "EP_CONTACTS_HIGHLIGHT_INFO": "Die ersten zwei Ansprechpersonen erscheinen auf der Startseite. Alle Ansprechpersonen im Überblick sind in der Rubrik \"Kontakt\" aufgelistet.",
    "EP_CONTACTS_MESSENGER_INFO": "Bevor Du jemanden als Ansprechperson hinzufügst: Stell bitte sicher, dass diese Person damit einverstanden ist. Wenn die Seite veröffentlicht wird, werden alle Ansprechpersonen darüber benachrichtigt.",
    "EP_CONTACTS_SEARCH_INPUT_ERROR": "Das hat leider nicht geklappt – versuch's einfach nochmal.",
    "EP_CONTACTS_SEARCH_NO_RESULTS": "Diesen Namen haben wir leider nicht gefunden.",
    "EP_CONTACTS_SEARCH_PLACEHOLDER": "Namen eingeben",
    "EP_CONTACTS_SUBPAGE_DESCRIPTION": "Alle Ansprechpersonen von {pageTitle} auf einen Blick",
    "EP_CONTACTS_WORK": "arbeiten hier.",
    "EP_COVER_CROP_DESCRIPTION": "<b>Wichtig:</b> Bei einigen Bildschirmgrößen (z. B. auf Smartphones) ist nur die Mitte des Titelbilds sichtbar. Wähl deshalb ein Bild, bei dem sich die wichtigsten Elemente innerhalb der gestrichelten Linien befinden: Dieser Bereich ist nämlich immer zu sehen.",
    "EP_CREATE_COMPANY_PAGE_MOBILE_INFO": "Bitte nutze zur Erstellung Eurer XING Seite einen <span>großen Bildschirm</span>.",
    "EP_DELETE_COVER": "Titelbild löschen",
    "EP_DELETE_COVER_DIALOG": "Möchtest Du das Titelbild wirklich löschen?",
    "EP_DELETE_COVER_DIALOG_CONFIRM": "Löschen",
    "EP_DELETE_COVER_DIALOG_HEADLINE": "Titelbild löschen?",
    "EP_DELETE_COVER_DIALOG_KEEP": "Behalten",
    "EP_DELETE_DOCUMENT_DIALOG": "Möchtest Du dieses Dokument wirklich löschen?",
    "EP_DELETE_DOCUMENT_DIALOG_CANCEL": "Abbrechen",
    "EP_DELETE_DOCUMENT_DIALOG_CONFIRM": "Ja, löschen",
    "EP_DELETE_DOCUMENT_DIALOG_HEADLINE": "Dokument löschen?",
    "EP_DELETE_IMAGE_GM_DIALOG": "Das Bild und Deine Eingaben dazu werden dann gelöscht.",
    "EP_DELETE_IMAGE_GM_DIALOG_CANCEL": "Abbrechen",
    "EP_DELETE_IMAGE_GM_DIALOG_CONFIRM": "Ja, löschen",
    "EP_DELETE_IMAGE_GM_DIALOG_HEADLINE": "Alles löschen?",
    "EP_DELETE_VIDEO_DIALOG_CANCEL": "Nicht löschen",
    "EP_DELETE_VIDEO_DIALOG_CONFIRM": "Ja, löschen",
    "EP_DELETE_VIDEO_DIALOG_HEADLINE": "Video löschen?",
    "EP_DELETE_VIDEO_DIALOG_HEADLINE (Copy)": "Video löschen?",
    "EP_DELETE_VIDEO_DIALOG_TEXT": "Dies kann nicht mehr rückgängig gemacht werden.",
    "EP_DIALOG_PAGE_CREATION_CLOSE": "Nicht beenden",
    "EP_DIALOG_PAGE_CREATION_CONFIRM": "Prozess beenden",
    "EP_DISCARD_CTA": "Verwerfen",
    "EP_DISCARD_DIALOG_CANCEL": "Abbrechen",
    "EP_DISCARD_DIALOG_CONFIRM": "Verwerfen",
    "EP_DISCARD_DIALOG_HEADLINE": "Änderungen verwerfen?",
    "EP_DISCARD_DIALOG_TEXT": "Deine Änderungen gehen dadurch verloren.",
    "EP_DISCOVER_ABOUT_US": "Alle Infos über uns",
    "EP_DISCUSSIONS_EDIT_ALL": "Alle Beiträge",
    "EP_DISCUSSIONS_EDIT_ALL (Copy)": "Alle Beiträge",
    "EP_DISCUSSIONS_HEADLINE": "Diskussionen",
    "EP_DOCUMENT_TITLE_EDIT_ERROR": "Bitte hier den Titel des Dokumentes eingeben",
    "EP_DOCUMENT_TITLE_EDIT_HINT": "Füg hier den Titel des Dokuments hinzu.",
    "EP_DOCUMENT_TITLE_EDIT_LABEL": "Titel des Dokuments",
    "EP_DONE_CTA": "Fertig",
    "EP_DRAFT_LAST_STEP_CREATE_PAGE": "– Bitte beachte, dass sich Deine XING Seite bis zur Genehmigung im Entwurfsmodus befindet und deshalb noch nicht veröffentlicht ist.",
    "EP_DRAFT_REPUBLISH_CTA": "Veröffentlichen",
    "EP_DRAFT_REPUBLISH_DESCRIPTION": "Die Beschwerde über diese Seite wurde zurückgewiesen – sie kann also wieder veröffentlicht werden.",
    "EP_DUMMY_COMMBOX_PLACEHOLDER": "Etwas mit anderen teilen…",
    "EP_EDIT_ABOUT_DATA_TITLE": "Eingaben bearbeiten",
    "EP_EDIT_ABOUTMETA_CTA": "Infos bearbeiten",
    "EP_EDIT_ABOUTUS_COPY_TO_INTRO": "Als Kurzbeschreibung die ersten Zeilen der ausführlichen Beschreibung anzeigen",
    "EP_EDIT_ABOUTUS_DESCRIPTION": "Kurzbeschreibung",
    "EP_EDIT_ABOUTUS_DESCRIPTION_DISCARD": "Abbrechen",
    "EP_EDIT_ABOUTUS_DESCRIPTION_PUBLISH": "Speichern",
    "EP_EDIT_ABOUTUS_DETAILED_REQUIRED": "Bitte füg jetzt noch den Text der \"Über uns\"-Rubrik hinzu.",
    "EP_EDIT_ABOUTUS_EXTERNALVIDEO_INFO": "Videos, die per Link eingebunden sind, können bald nicht mehr angezeigt werden. Lad die Videos deshalb jetzt direkt auf XING hoch – und füg auf Wunsch auch Untertitel und Vorschaubilder hinzu.",
    "EP_EDIT_ABOUTUS_INDUSTRIES_INTRO": "Zu welcher Branche gehört Euer Unternehmen? Gib hier bis zu 5 passende Branchen ein, damit die Seite besser gefunden wird und wir sie den richtigen Mitgliedern vorschlagen können.",
    "EP_EDIT_ABOUTUS_INTRO_DESCRIPTION": "Kurzbeschreibung",
    "EP_EDIT_ABOUTUS_INTRO_DESCRIPTION_LABEL": "Kurzbeschreibung",
    "EP_EDIT_ABOUTUS_INTRO_INFO_TEXT": "Diese Kurzbeschreibung erscheint in der Übersicht unter \"Über uns\" – und auch bei Google & Co. in den Suchergebnissen.",
    "EP_EDIT_ABOUTUS_INTRO_TITLE": "Überschrift",
    "EP_EDIT_ABOUTUS_INTRO_TITLE_LABEL": "Überschrift",
    "EP_EDIT_ABOUTUS_NAV_DESCRIPTION": "Ausführliche Beschreibung",
    "EP_EDIT_ABOUTUS_NAV_FACTS": "Steckbrief",
    "EP_EDIT_ABOUTUS_NAV_INDUSTRIES": "Branchen",
    "EP_EDIT_ABOUTUS_NAV_INTRO": "Kurzbeschreibung",
    "EP_EDIT_ABOUTUS_SUMMARY": "Über uns: Eckdaten",
    "EP_EDIT_ACTION_DISCARD": "Abbrechen",
    "EP_EDIT_ACTION_POST": "Beitrag schreiben",
    "EP_EDIT_ACTION_PROMOTE": "Seite bewerben",
    "EP_EDIT_ACTION_PUBLISH": "Fertig",
    "EP_EDIT_ACTION_SET_EDIT_MODE_OFF": "Zur Besucheransicht",
    "EP_EDIT_ACTION_SET_EDIT_MODE_ON": "Seite bearbeiten",
    "EP_EDIT_ACTION_WRITE_ARTICLE": "Artikel schreiben",
    "EP_EDIT_AFFILIATES": "Verbindungen bearbeiten",
    "EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY": "Möchtest Du \"{companyName}\" als verbundenes Unternehmen entfernen?",
    "EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY_MARKUP": "Möchtest Du <strong>\"{companyName}\"</strong> als verbundenes Unternehmen entfernen?",
    "EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CANCEL": "Abbrechen",
    "EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CONFIRM": "Ja, entfernen",
    "EP_EDIT_AFFILIATES_DESCRIPTION": "Füg hier verwandte Unternehmen sowie Kunden, Dienstleister usw. hinzu. Voraussetzung ist, dass diese Unternehmen ebenfalls eine XING Seite haben. Wir empfehlen zudem, sich ihrer Zustimmung zu versichern, hier als \"verbundenes Unternehmen\" zu erscheinen.",
    "EP_EDIT_AFFILIATES_INFO": "Füg hier z. B. Tochter- oder Schwesterunternehmen hinzu – aber auch Kunden, Dienstleister usw. Wichtig: Diese Unternehmen müssen ebenfalls eine XING Seite haben und sollten der Verknüpfung vorher zugestimmt haben.",
    "EP_EDIT_BACK_GALLERY": "Zur Galerie",
    "EP_EDIT_COMPANYSIZEID": "Mitarbeitende",
    "EP_EDIT_COMPANYSIZEID_FIELD_LABEL": "Mitarbeitende",
    "EP_EDIT_CONTACTS": "Kontakt bearbeiten",
    "EP_EDIT_CONTACTS_DELETE": "Möchtest Du diese Ansprechperson wirklich entfernen?",
    "EP_EDIT_CONTACTS_DELETE_CANCEL_CONFIRM": "Entfernen",
    "EP_EDIT_CONTACTS_DELETE_CANCEL_CTA": "Abbrechen",
    "EP_EDIT_CONTACTS_DELETED": "Ansprechperson entfernt",
    "EP_EDIT_CONTACTS_DESCRIPTION_INPUT_FIELD": "Tipp: Gib hier an, für welche Themen diese Ansprechperson zuständig ist.",
    "EP_EDIT_CONTACTS_FREE_INFO": "Trag hier ein, an wen man sich bei Fragen oder Anliegen wenden kann. Wenn Du diese Ansprechperson ändern möchtest, füge einfach eine neue Person hinzu: Die bisherige wird dann automatisch entfernt. (Bei einer kostenlosen XING Seite kann man leider nur eine Ansprechperson eintragen.)",
    "EP_EDIT_CONTACTS_NAV_CONTACTS": "Kontakt",
    "EP_EDIT_CONTACTS_NAV_LOCATION": "Standort",
    "EP_EDIT_CONTACTS_PAID_INFO": "Trag hier ein, an wen man sich bei Fragen oder Anliegen wenden kann.  Die ersten beiden Ansprechpersonen in dieser Liste erscheinen nicht nur auf der Detailseite \"Ansprechpersonen\", sondern auch auf der Übersicht der XING Seite.",
    "EP_EDIT_DOCUMENTS": "Dokumente bearbeiten",
    "EP_EDIT_EVENT_ALL_LINK": "Alle Events",
    "EP_EDIT_EVENT_COPY_EVENT": "Event kopieren",
    "EP_EDIT_EVENT_DRAFT_MESSAGE_BODY": "Sobald Du bereit bist, kannst Du's veröffentlichen und die ersten Gäste dazu einladen. Dadurch finden auch neue Leute in Deine Gruppe.",
    "EP_EDIT_EVENT_DRAFT_MESSAGE_CTA": "Zum Event-Entwurf",
    "EP_EDIT_EVENT_DRAFT_MESSAGE_HEADLINE": "Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ",
    "EP_EDIT_EVENT_EDIT_EVENTS": "Events bearbeiten",
    "EP_EDIT_EVENT_EMPTY_STATE_BODY": "Events zum Kennenlernen und Austauschen helfen Dir beim Aufbau Deiner Gruppe und Deinen Mitgliedern dabei, sich zu vernetzen und wirklich etwas für sich mitzunehmen.",
    "EP_EDIT_EVENT_EMPTY_STATE_CTA": "Event organisieren",
    "EP_EDIT_EVENT_EMPTY_STATE_FAQ_LINK": "Hier findest Du Tipps für Dein Gruppen-Event.",
    "EP_EDIT_EVENT_EMPTY_STATE_HEADLINE": "Versammle Deine Gruppe und finde neue Mitglieder – online und vor Ort.",
    "EP_EDIT_EVENT_ORGANISE_CTA": "Event organisieren",
    "EP_EDIT_EVENT_PAST_EMPTY_STATE_BODY": "Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.",
    "EP_EDIT_EVENT_PAST_EMPTY_STATE_CTA": "Event kopieren",
    "EP_EDIT_EVENT_PAST_EMPTY_STATE_HEADLINE": "Zeit fürs nächste Gruppen-Event?",
    "EP_EDIT_EVENT_PAST_EMPTY_STATE_TIP": "Tipp: Spar Zeit, indem Du Dein letztes Event kopierst.",
    "EP_EDIT_EVENT_PAST_TITLE.one": "Vergangene Events",
    "EP_EDIT_EVENT_PAST_TITLE.other": "Vergangene Events",
    "EP_EDIT_EVENT_PAST_TITLE.zero": "Vergangene Events",
    "EP_EDIT_EVENT_SUBPAGE_BACK_LINK": "Zurück zur Übersicht",
    "EP_EDIT_EVENT_SUBPAGE_COPY_EVENT_BUTTON": "Event kopieren",
    "EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_BODY": "Bei Events gilt: Je eher Du sie veröffentlichst, desto mehr Leute werden darauf aufmerksam und können sich den Termin freihalten.",
    "EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.one": "Erinnerung: Du hast einen unveröffentlichten Event-Entwurf.",
    "EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.other": "Erinnerung: Du hast unveröffentlichte Event-Entwürfe.",
    "EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.zero": "Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ",
    "EP_EDIT_EVENT_SUBPAGE_DRAFT_TAB": "Entwürfe",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_HELP_BODY": "Hier findest Du <a>Tipps für Dein Gruppen-Event</a>.",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_TITLE_HELP": "Noch Fragen?",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BODY": "Bei einem Event kommt Deine Gruppe zusammen, die Mitglieder lernen sich kennen und tauschen sich aus. Dadurch entsteht erst ein Gemeinschaftsgefühl und Du erweckst die Gruppe zum Leben. ",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_BODY": "Zuallererst solltest Du festlegen: Wann findet das Event statt? Trefft Ihr Euch online oder vor Ort? Und worum soll es gehen? Mit diesen Infos kannst Du Dein Event erstellen.",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_TITLE": "1. Die Eckdaten",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_BODY": "Kümmer Dich als nächstes um die Details: Wie ist der Ablauf, gibt es Vorträge oder eine Networking-Runde und wie sehen die Online-Anmeldung oder der Einlass aus?",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_TITLE": "2. Der Feinschliff",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_BODY": "Sobald die Eventseite steht, lad Deine Gruppe und Leute aus Deinem Netzwerk oder Deiner Branche ein. Dadurch werden auch andere XING Mitglieder auf Dein Event aufmerksam. ",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_TITLE": "3. Die Gäste",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_HEADLINE": "So gehst Du vor:",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_CTA": "Event organisieren",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_FAQ_LINK": "Hier findest Du Tipps für Dein Gruppen-Event.",
    "EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_HEADLINE": "Plan Dein nächstes Event.",
    "EP_EDIT_EVENT_SUBPAGE_LIVE_TAB": "Veröffentlicht",
    "EP_EDIT_EVENT_SUBPAGE_MORE_BUTTON": "Mehr anzeigen",
    "EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_BODY": "Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.",
    "EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_HEADLINE": "Zeit fürs nächste Gruppen-Event?",
    "EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_TIP": "Tipp: Spar Zeit, indem Du Dein letztes Gruppen-Event kopierst.",
    "EP_EDIT_EVENT_SUBPAGE_PAST_TAB": "Archiv",
    "EP_EDIT_EVENT_UPCOMING_TITLE.one": "Anstehendes Event",
    "EP_EDIT_EVENT_UPCOMING_TITLE.other": "Anstehende Events",
    "EP_EDIT_EVENT_UPCOMING_TITLE.zero": "Anstehende Events",
    "EP_EDIT_FOUNDINGYEAR": "Gründungsjahr",
    "EP_EDIT_FOUNDINGYEAR_FIELD_LABEL": "Gründungsjahr",
    "EP_EDIT_GALLERY": "Galerie bearbeiten",
    "EP_EDIT_GALLERY_EMPTY_STATE_BODY": "Mit Bildern und Videos wird Eure Seite lebendiger und eindrucksvoller. Hier ist Platz dafür.",
    "EP_EDIT_GALLERY_EMPTY_STATE_CTA_IMAGE": "Bild hinzufügen",
    "EP_EDIT_GALLERY_EMPTY_STATE_CTA_VIDEO": "Video hinzufügen ",
    "EP_EDIT_GALLERY_EMPTY_STATE_HEADER": "Sehenswert: Eure XING Seite.",
    "EP_EDIT_GROUP_RULES": "Gruppenregeln bearbeiten",
    "EP_EDIT_IMPRINT": "Impressum",
    "EP_EDIT_IMPRINT_FIELD_LABEL": "Impressum",
    "EP_EDIT_INDUSTRY": "Branche",
    "EP_EDIT_INDUSTRY_FIELD_LABEL": "Branche",
    "EP_EDIT_INDUSTRYSEGMENT": "Bereich",
    "EP_EDIT_INDUSTRYSEGMENT_FIELD_LABEL": "Bereich",
    "EP_EDIT_INFO_EDIT_VIEW": "Bearbeitungs-Ansicht",
    "EP_EDIT_INFO_MOBILE": "Bitte nutz zur Bearbeitung einen <span>großen Bildschirm</span>.",
    "EP_EDIT_INFO_MOBILE_EDITABLE": "Leider lassen sich noch nicht alle Bereiche am kleinen Bildschirm bearbeiten. Wir arbeiten aber dran.",
    "EP_EDIT_INFO_VISITOR_VIEW": "Besucheransicht",
    "EP_EDIT_LOCATION_ADDRESS": "Straße und Hausnr.",
    "EP_EDIT_LOCATION_ADDRESSSUFFIX": "Adresszusatz",
    "EP_EDIT_LOCATION_CITY": "Ort",
    "EP_EDIT_LOCATION_COUNTRY": "Land",
    "EP_EDIT_LOCATION_EMAIL": "E-Mail",
    "EP_EDIT_LOCATION_FAXNUMBER": "Fax",
    "EP_EDIT_LOCATION_FAXNUMBERCOUNTRYCODE": "Landesvorwahl",
    "EP_EDIT_LOCATION_LABEL": "Standort",
    "EP_EDIT_LOCATION_PHONENUMBER": "Telefon",
    "EP_EDIT_LOCATION_PHONENUMBERCOUNTRYCODE": "Landesvorwahl",
    "EP_EDIT_LOCATION_POSTCODE": "PLZ",
    "EP_EDIT_LOCATION_WEBSITEURL": "Website",
    "EP_EDIT_PAGEINFO_COMPANY_BANNER": "Möchtest Du den Namen der Seite ändern? Kontaktier uns dafür bitte.",
    "EP_EDIT_SECTION": "Ausschnitt ändern",
    "EP_EDIT_SELECTION": "Einträge bearbeiten",
    "EP_EDIT_SUBPAGE_LINK": "Detailseite bearbeiten",
    "EP_EDIT_WEBSITEURL": "Website",
    "EP_EDIT_WEBSITEURL_FIELD_LABEL": "Website",
    "EP_EDITBAR_MANAGE_UPDATES": "Neuigkeiten verwalten",
    "EP_EDITOR_BODY_PLACEHOLDER": "Füge eine Beschreibung über Euer Unternehmen hinzu.",
    "EP_EDITOR_TITLE_PLACEHOLDER": "Gib einen Titel an, z. B. „Wer wir sind“.\t",
    "EP_EMPLOYEE": "Mitarbeitende·r",
    "EP_EMPLOYEE_CARD_SHARED_CONTACTS": "{sharedContactsNumber} gemeinsame Kontakte",
    "EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.one": "{value} gemeinsamer Kontakt",
    "EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.other": "{value} gemeinsame Kontakte",
    "EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.zero": "Keine gemeinsamen Kontakte",
    "EP_EMPLOYEE_FENCED": "Logg Dich ein, um alle {total} Mitarbeitenden auf XING zu sehen – und Deine persönliche Verbindung zum Unternehmen.",
    "EP_EMPLOYEES_BUTTON_REGISTER_NOW": "Registrieren",
    "EP_EMPLOYEES_BUTTON_SIGN_IN": "Einloggen",
    "EP_EMPLOYEES_COUNT": "{employeesNumber} Mitarbeitende",
    "EP_EMPLOYEES_EDIT_HINT": "Hier erscheinen alle XING Mitglieder, die Dein Unternehmen als Arbeitgeber angegeben haben.",
    "EP_EMPLOYEES_EMPTY_STATE": "Bisher hat noch kein Mitglied dieses Unternehmen als Arbeitgeber angegeben.",
    "EP_EMPLOYEES_LINK": "Alle {number} Mitarbeitenden",
    "EP_EMPLOYEES_LOAD_MORE_CTA": "Weitere Mitarbeitende",
    "EP_EMPLOYEES_NUMBER_EMPTY_STATE": "Unternehmensgröße",
    "EP_EMPLOYEES_OR": "oder",
    "EP_EMPLOYEES_SIGNIN": "Einloggen",
    "EP_EMPLOYEES_SUBPAGE_DESCRIPTION": "Auf einen Blick: Alle Mitarbeitenden von {pageTitle}, die bei XING sind.",
    "EP_EMPLOYEES_TEXT_CTA_REGISTER_TO_SEE": "Registrier Dich, um alle {employeesNumber} Mitarbeitenden zu sehen.",
    "EP_EMPLOYEES_TEXT_PROFILE_IMAGE_ALT": "Profilbild von {profileName}",
    "EP_EMPLOYEES_VIEW_PROFILE": "Profil ansehen",
    "EP_ERROR": "Warum ist hier denn nichts zu sehen?",
    "EP_ERROR_BODY": "Vielleicht klappt's wieder, wenn Du auf \"Aktualisieren\" klickst.",
    "EP_EVENT_ALL_CTA": "Alle Events",
    "EP_EVENT_ALL_LINK": "Alle Events",
    "EP_EVENT_DELETE_ERROR": "Das hat gerade leider nicht geklappt. Versuch's bitte nochmal.",
    "EP_EVENT_EMPTY_STATE_BODY": "Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.",
    "EP_EVENT_EMPTY_STATE_HEADLINE": "In dieser Gruppe haben noch keine Events stattgefunden.",
    "EP_EVENT_PAST_TITLE": "Vergangenes Event",
    "EP_EVENT_SUBPAGE_BACK_LINK": "Zurück zur Übersicht",
    "EP_EVENT_SUBPAGE_EMPTY_STATE_PAST": "In dieser Gruppe haben noch keine Events stattgefunden.",
    "EP_EVENT_SUBPAGE_EMPTY_STATE_PAST_BODY": "Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.",
    "EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING": "Zurzeit stehen keine Gruppen-Events an.",
    "EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING_BODY": "Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.",
    "EP_EVENT_SUBPAGE_MORE_CTA": "Mehr anzeigen",
    "EP_EVENT_SUBPAGE_PAST_TAB": "Vergangene Events",
    "EP_EVENT_SUBPAGE_UPCOMING_TAB": "Anstehende Events",
    "EP_EVENT_UPCOMING_TITLE.one": "Anstehendes Event",
    "EP_EVENT_UPCOMING_TITLE.other": "Anstehende Events",
    "EP_EVENT_UPCOMING_TITLE.zero": "Anstehende Events",
    "EP_EVENTS_DESCRIPTION": "Events",
    "EP_EVENTS_HEADLINE": "Events",
    "EP_EVENTS_NAVIGATION_TITLE": "Events",
    "EP_EXISTING_COMPANY_NAME": "Es gibt schon eine XING Seite mit diesem Namen – war da vielleicht jemand schneller?",
    "EP_FAX": "Fax",
    "EP_FEEDBACK_BUTTON": "Feedback?",
    "EP_FIELD_EMPTY_OR_MIN_CHARACTERS_ERROR": "Gib hier bitte nichts oder mind. {value} Zeichen ein.",
    "EP_FIELD_MAX_CHARACTERS_ERROR": "Hier bitte max. {value} Zeichen eingeben",
    "EP_FIELD_REQUIRED_ERROR": "Kannst Du dieses Feld bitte noch ausfüllen?",
    "EP_FILE_SIZE_FORMAT_ERROR": "Bitte wähl ein PDF-Dokument, das max. 100 MB groß ist.",
    "EP_FIND_US_HERE": "Hier findest Du uns:",
    "EP_FLAG_EMPLOYER_BRANDING_PROFILE": "Employer Branding Profil",
    "EP_FOLLOWERS_COUNT_WEB.one": "{value} Follower",
    "EP_FOLLOWERS_COUNT_WEB.other": "{value} Follower",
    "EP_FOLLOWERS_COUNT_WEB.zero": "Keine Follower",
    "EP_FOLLOWERS_SOCIAL_PROOF.one": "{username} folgt dieser Seite.",
    "EP_FOLLOWERS_SOCIAL_PROOF.other": "{numberOfContacts} Deiner Kontakte folgen dieser Seite.",
    "EP_FORMATTEDTIMESTAMP_DAYSAGO": "Vor {number} Tagen",
    "EP_FORMATTEDTIMESTAMP_DAYSAGO_SHORT": "{number} Tage",
    "EP_FORMATTEDTIMESTAMP_TODAY": "Heute",
    "EP_FORMATTEDTIMESTAMP_YESTERDAY": "Gestern",
    "EP_FOUNDING_YEAR": "{foundingYear} gegründet",
    "EP_FOUNDING_YEAR_EMPTY_STATE": "Gründungsjahr",
    "EP_FREE_ADD_CONTACT_INFO": "Auf der kostenlosen XING Seite kann man nur eine Ansprechperson angeben. Deshalb haben wir Eure bisherige Ansprechperson ersetzt.",
    "EP_FREE_CONTACTS_PROBLEM": "Leider ist die Ansprechperson gerade nicht änderbar. Bitte versuch's später nochmal.",
    "EP_GALLERY_MANAGER_INFO": "Hier kannst Du Bilder und Videos verschieben, bearbeiten und löschen. Übrigens: Die obersten vier Bilder / Videos erscheinen im Modul \"Impressionen\" auf der Übersicht der XING Seite.",
    "EP_GENERIC_FEEDBACK_ERROR": "Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen. Versuch's bitte nochmal.",
    "EP_GM_IMAGE_CAPTION_HINT": "Was soll unter dem Bild stehen?",
    "EP_GM_IMAGE_CAPTION_LABEL": "Bildunterschrift",
    "EP_GM_IMAGE_WILL_BE_DELETED": "Bild gelöscht",
    "EP_GM_NO_MEDIA": "Starte hier Eure Galerie: mit eindrucksvollen Bildern und Videos.",
    "EP_GM_NO_MEDIA_HEADLINE": "Sehenswert: Eure XING Seite.",
    "EP_GM_VIDEO_ENCODING": "Das Video <span>“{video_name}“</span> wird aufbereitet.",
    "EP_GM_VIDEO_ENCODING_FAILED_INFO": "Dieses Video kann leider nicht abgespielt werden und wird deshalb entfernt. So sollte das Video sein: Eine Datei im Format .avi .mov oder .mp4, im Verhältnis 16: 9 und max. 5 GB groß.",
    "EP_GM_VIDEO_ENCODING_FAILED_TITLE": "Videokodierung für <span>“{video_name}“</span> fehlgeschlagen",
    "EP_GM_VIDEO_ENCODING_MESSAGE": "Wir schicken Dir eine E-Mail, sobald es fertig und veröffentlicht ist.",
    "EP_GM_VIDEO_WILL_BE_DELETED": "Video gelöscht",
    "EP_GROUP_ABOUT_LEGAL_NOTICE": "Impressum",
    "EP_GROUP_ABOUT_US_BOX_CATEGORIES_TITLE": "Thema",
    "EP_GROUP_ABOUT_US_BOX_HEADLINE": "Infos",
    "EP_GROUP_ABOUT_US_CATEGORY": "Thema",
    "EP_GROUP_ABOUT_US_EVENTS.one": "{amount} Event",
    "EP_GROUP_ABOUT_US_EVENTS.other": "{amount} Events",
    "EP_GROUP_ABOUT_US_EVENTS.zero": "Keine Events",
    "EP_GROUP_ABOUT_US_FACTS": "Infos",
    "EP_GROUP_ABOUT_US_MEMBERS.one": "{amount} Mitglied",
    "EP_GROUP_ABOUT_US_MEMBERS.other": "{amount} Mitglieder",
    "EP_GROUP_ABOUT_US_MEMBERS.zero": "Keine Mitglieder",
    "EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_BODY": "Leg hier fest, wie Mitglieder sich verhalten sollen. ",
    "EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_CTA": "Hinzufügen",
    "EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_EDIT": "Bearbeiten",
    "EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HEADER": "Was geht – und was nicht?",
    "EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HELP_TEXT": "Erklär, wie sich Gruppen-Mitglieder verhalten sollen, z. B. …\n<ul>\n <li>welche Beiträge relevant sind und wie die Gruppe zu Spam steht und</li>\n <li>dass der Umgangston bei einer Diskussion wertschätzend bleiben sollte.</li>\n</ul>\n Die Regeln sollten übrigens gut leserlich sein, z. B. durch Stichpunkte.",
    "EP_GROUP_ABOUT_US_RULES_PLACEHOLDER": "Leg hier fest, was erlaubt ist – und was nicht.",
    "EP_GROUP_ABOUT_US_TITLE": "Dürfen wir uns vorstellen?",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS.one": "%,d anstehendes Event",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS.other": "%,d anstehende Events",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS.zero": "Keine anstehenden Events",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS_NONE": "Keine anstehenden Events",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.one": "{amount} anstehendes Event",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.other": "{amount} anstehende Events",
    "EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.zero": "Keine anstehenden Events",
    "EP_GROUP_ABOUT_US_VISIBILITY_PRIVATE": "Privat",
    "EP_GROUP_ABOUT_US_VISIBILITY_PUBLIC": "Öffentlich",
    "EP_GROUP_CREATION_CANCEL_CTA": "Gruppe verwerfen",
    "EP_GROUP_CREATION_CANCEL_KEEP_CTA": "Nein, behalten",
    "EP_GROUP_CREATION_CANCEL_TEXT": "Deine Eingaben auf dieser Seite gehen dann verloren.",
    "EP_GROUP_CREATION_CANCEL_TITLE": "Möchtest Du Deine Gruppe wirklich verwerfen?",
    "EP_GROUP_CREATION_PROGRESS_BAR_TITLE_1": "Name & Einstellungen",
    "EP_GROUP_CREATION_PROGRESS_BAR_TITLE_2": "Thema",
    "EP_GROUP_CREATION_PROGRESS_BAR_TITLE_3": "Beschreibung",
    "EP_GROUP_CREATION_PROGRESS_BAR_TITLE_4": "Logo",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_1": "förderst Du den Netzwerk-Gedanken und machst die Mitglieder miteinander bekannt.",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2\n": "unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2": "unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_3": "organisierst Du regelmäßig Events (z. B. Workshops, Meetups oder Feierabend-Treffs).",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL": "Ja, ich akzeptiere den {link}.",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL_LINK": "Verhaltenskodex für die Moderation",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_FEMALE": "Als Moderatorin einer Gruppe …",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_MALE": "Als Moderator einer Gruppe …",
    "EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_OTHER": "Als Moderatx einer Gruppe …",
    "EP_GROUP_CREATION_STEP_1_LOCATION_HELP_TEXT": "Wenn Du eine Stadt auswählst, empfehlen wir Deine Gruppe Mitgliedern, die von dort kommen oder dort arbeiten, auf deren Gruppen-Startseite. Es können aber auch andere Deiner Gruppe beitreten.",
    "EP_GROUP_CREATION_STEP_1_LOCATION_OPTIONAL": "(Optional)",
    "EP_GROUP_CREATION_STEP_1_LOCATION_TITLE": "Wähl hier Deine Stadt für eine lokale Gruppe aus. Sie wird dadurch Leuten aus der Gegend angezeigt.",
    "EP_GROUP_CREATION_STEP_1_NAME_HEADER": "Wie soll Deine Gruppe heißen?",
    "EP_GROUP_CREATION_STEP_1_NAME_HELP_TEXT": "Der Gruppenname ist das Erste, was Deine neuen Mitglieder sehen. Wähl deshalb einen Namen, der auf den Punkt bringt, worum's geht.",
    "EP_GROUP_CREATION_STEP_1_NAME_PLACEHOLDER": "Z. B. \"Marketing {city}\"",
    "EP_GROUP_CREATION_STEP_1_TITLE": "Name & Einstellungen",
    "EP_GROUP_CREATION_STEP_1_VISIBILITY_HELP_TEXT": "Bei öffentlichen Gruppen können alle XING Mitglieder sehen, wer in der Gruppe ist, und Beiträge lesen. <br>\nWenn die Gruppe privat ist, können das nur Gruppen-Mitglieder. <br>\nDie Privatsphäre-Einstellungen für Events gelten unabhängig von denen der Gruppe: Öffentliche Gruppen können auch private Events veranstalten und umgekehrt.",
    "EP_GROUP_CREATION_STEP_1_VISIBILITY_PRIVATE": "Privat (nicht nachträglich änderbar)",
    "EP_GROUP_CREATION_STEP_1_VISIBILITY_PUBLIC": "Öffentlich",
    "EP_GROUP_CREATION_STEP_1_VISIBILITY_TITLE": "Ist Deine Gruppe privat oder öffentlich?",
    "EP_GROUP_CREATION_STEP_2_CATEGORY_HEADER": "Wähle Themen aus, die zu Deiner Gruppe passen.",
    "EP_GROUP_CREATION_STEP_2_CATEGORY_HELPTEXT": "Füge hier bis zu 20 Themen hinzu. Dadurch können Interessenten Deine Gruppe bei der Suche nach diesen Themen finden und beitreten oder an Deinen Events teilnehmen.",
    "EP_GROUP_CREATION_STEP_2_CATEGORY_PLACEHODER": "Z. B. \"Marketing\" oder \"Projektmanagement\"\n",
    "EP_GROUP_CREATION_STEP_3_DESCRIPTION_HEADER": "Worum geht's in Deiner Gruppe?",
    "EP_GROUP_CREATION_STEP_3_DESCRIPTION_HELP": "Beantworte z. B. diese Fragen:\n <ul>\n  <li>Für wen könnte die Gruppe interessant sein?</li>\n  <li>Was macht sie aus?</li>\n  <li>Wie oft finden Gruppen-Events statt und wie laufen die ab?</li>\n</ul> \n\nDu kannst übrigens {min}-{max} Zeichen verwenden und den Text auch formatieren.",
    "EP_GROUP_CREATION_STEP_3_DESCRIPTION_PLACEHOLDER": "Z. B. \"Bei uns lernt Ihr andere aus der Branche kennen und tauscht Euch über Erfolge, Fehlschläge, Tipps und Neuigkeiten aus.\"\n",
    "EP_GROUP_CREATION_STEP_4_CTA_CREATE_GROUP": "Gruppe beantragen",
    "EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_CTA": "Datei auswählen",
    "EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_HINT": "JPG, BMP oder PNG (max. 20 MB) im Format 16:9",
    "EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_TITLE": "Logo hierher ziehen oder auswählen",
    "EP_GROUP_CREATION_SUCCESS_BULLET_1": "Wir schauen sie uns gleich an. Du bekommst dann eine E-Mail, sobald Deine Gruppe freigegeben wird. Das kann bis zu 48 Stunden dauern.",
    "EP_GROUP_CREATION_SUCCESS_BULLET_2": "In der Zwischenzeit kannst Du ein Banner, Bilder oder ein Video hochladen. (Nutz dazu bitte einen Desktop-PC.)",
    "EP_GROUP_CREATION_SUCCESS_BULLET_3": "Oder Du schreibst einen Willkommens-Beitrag. Neue Mitglieder sehen diesen, sobald die Gruppe freigegeben wurde.",
    "EP_GROUP_CREATION_SUCCESS_CTA_BACK": "Zur Gruppen-Übersicht",
    "EP_GROUP_CREATION_SUCCESS_HEADLINE": "Deine neue Gruppe \"<name>\" ist da.",
    "EP_GROUP_CREATION_SUCCESS_LARGE_SCREEN_CTA": "Zur Gruppe",
    "EP_GROUP_CREATION_SUCCESS_SMALL_SCREEN_CTA": "Zur Gruppe",
    "EP_GROUP_DELETION_CTA": "Jetzt löschen",
    "EP_GROUP_DELETION_ERROR": "Deine Gruppe konnte gerade leider nicht gelöscht werden. Versuch's bitte nochmal.",
    "EP_GROUP_DELETION_KEEP_CTA": "Gruppe behalten",
    "EP_GROUP_DELETION_SUCCESS": "Deine Gruppe wurde gelöscht.",
    "EP_GROUP_DELETION_TITLE": "Möchtest Du Deine Gruppe wirklich löschen?",
    "EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR": "Wir können gerade keine Beiträge erstellen. Bitte lad diese Seite neu.",
    "EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR_CTA": "Seite neu laden",
    "EP_GROUP_DISCUSSIONS_LOAD_MORE_ERROR": "Wir können gerade keine weiteren Beiträge anzeigen. Bitte versuch's gleich nochmal.",
    "EP_GROUP_HEADER_MEMBERS.one": "Mitglied",
    "EP_GROUP_HEADER_MEMBERS.other": "Mitglieder",
    "EP_GROUP_HEADER_MEMBERS.zero": "Mitglieder",
    "EP_GROUP_HEADER_VISIBILITY_PRIVATE": "Privat",
    "EP_GROUP_HEADER_VISIBILITY_PUBLIC": "Öffentlich",
    "EP_GROUP_INFO_BLOCKED": "Blockiert",
    "EP_GROUP_LEAVE_OWNER_ERROR_POP_UP": "Bitte übertrag die Moderation jemand anderem, bevor Du sie verlässt.\nKontaktier dafür unseren Kundenservice.",
    "EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CLOSE_CTA": "Jetzt nicht",
    "EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CONTACT_CTA": "Kontaktieren",
    "EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_TITLE": "Diese Gruppe gehört Dir.",
    "EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_EMAIL_ADDRESS": "de-support@xing.com",
    "EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_SUBJECT": "Gruppen-Verantwortlichkeit abgeben",
    "EP_GROUP_LOCATION_TITLE": "Ort",
    "EP_GROUP_MEMBER_ADD_CONTACT": "Vernetzen",
    "EP_GROUP_MEMBER_ADD_CONTACT_ERROR": "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    "EP_GROUP_MEMBER_ALL_LINK": "Alle Mitglieder sehen",
    "EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.one": "%d gemeinsamer Kontakt",
    "EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.other": "%d gemeinsame Kontakte",
    "EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.zero": "%d shared contacts",
    "EP_GROUP_MEMBER_EDIT": "Bearbeiten",
    "EP_GROUP_MEMBER_INVITE_CTA": "Mitglieder einladen",
    "EP_GROUP_MEMBER_INVITE_PLACEHOLDER": "Hallo,\nich möchte Dich gerne in die Gruppe \"{group_name}\" einladen und freue mich, Dich bald dort zu sehen!\n\nViele Grüße\n{invitor_name}",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_BODY": "Alle Mitglieder haben Zugriff auf diese Gruppe und können Beiträge schreiben, lesen und kommentieren.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_TITLE": "Niemand ist zur Zeit blockiert.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SINCE": "Blockiert seit {date}",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SWITCHER": "Blockiert",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_BODY": "Ausgeschlossene Personen verlieren ihre Mitgliedsrechte und können erst wieder beitreten, wenn Du den Ausschluss aufhebst.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_TITLE": "Niemand ist zur Zeit ausgeschlossen.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SINCE": "Ausgeschlossen seit {date}",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SWITCHER": "Ausgeschlossen",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_MEMBERS_SWITCHER": "Mitglieder",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_BODY": "Sobald jemand dieser Gruppe beitreten möchte, sieht Du die Mitgliedsanfrage hier.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_TITLE": "Zur Zeit gibt es keine neuen Mitgliedsanfragen.",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SINCE": "Mitgliedsanfrage vom {date}",
    "EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SWITCHER": "Anfragen",
    "EP_GROUP_MEMBER_POP_UP_BODY_LO": "Registrier Dich kostenlos oder logg Dich ein, um alle {count} Mitglieder zu sehen.",
    "EP_GROUP_MEMBER_REGISTER_LO": "Jetzt registrieren",
    "EP_GROUP_MEMBER_SEARCH_EMPTY_BODY": "Wird die Person vielleicht anders geschrieben? Versuch's einfach nochmal oder mit einem anderen Wort.",
    "EP_GROUP_MEMBER_SEARCH_EMPTY_HEADLINE": "Mit diesem Namen haben wir leider niemanden gefunden.",
    "EP_GROUP_MEMBER_SIGN_IN_LO": "Einloggen",
    "EP_GROUP_MEMBER_SUBPAGE_MORE_CTA": "Mehr anzeigen",
    "EP_GROUP_MEMBER_TITLE": "Mitglieder",
    "EP_GROUP_MEMBER_VIEW_PROFILE_LO": "Profil ansehen",
    "EP_GROUP_MEMBER_WRITE_MESSAGE": "Nachricht",
    "EP_GROUP_MEMBERS_ADD_AS_MODERATOR": "Ins Moderations-Team holen",
    "EP_GROUP_MEMBERS_ADD_AS_MODERATOR_SUCCESS": "Du hast {name} ins Moderations-Team Deiner Gruppe geholt.",
    "EP_GROUP_MEMBERS_BLOCK_MEMBER": "Mitglied blockieren",
    "EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP": "{first_name} kann dann solange keine Beiträge oder Kommentare veröffentlichen, bis Du die Blockierung aufhebst.",
    "EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_HEADLINE": "{name} blockieren?",
    "EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_YES": "Ja, blockieren",
    "EP_GROUP_MEMBERS_BLOCK_MEMBER_SUCCESS": "{name} ist jetzt blockiert.",
    "EP_GROUP_MEMBERS_BLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL": "Abbrechen",
    "EP_GROUP_MEMBERS_CHANGE_ROLE_ERROR": "Das hat leider nicht geklappt. Kannst Du es bitte noch einmal versuchen?",
    "EP_GROUP_MEMBERS_CHANGE_STATUS_POP_UP_CANCEL": "Abbrechen",
    "EP_GROUP_MEMBERS_CONFIRM_MEMBER_SUCCESS": "{first_name} ist jetzt auch ein Mitglied dieser Gruppe.",
    "EP_GROUP_MEMBERS_DECLINE_MEMBER_SUCCESS": "Du hast die Mitgliedsanfrage von {name} abgelehnt.",
    "EP_GROUP_MEMBERS_GROUP_OWNER_INFO": "Hat die Gruppe am {date} gegründet",
    "EP_GROUP_MEMBERS_GROUP_PENDING_OWNER_INFO": "Sobald Deine Gruppe freigegeben wird, kannst Du Leute dazu einladen.",
    "EP_GROUP_MEMBERS_LOAD_MORE_ERROR": "Wir können gerade keine weiteren Mitglieder anzeigen. Bitte versuch's gleich nochmal.",
    "EP_GROUP_MEMBERS_MEMBERSHIP_ACTION_ERROR": "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    "EP_GROUP_MEMBERS_MEMBERSHIP_INFO": "Mitglied seit dem {date}",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS.one": "{number} offene Mitgliedsanfrage",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS.other": "{number} offene Mitgliedsanfragen",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS.zero": "{number} pending membership requests",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.one": "Soll Deine Gruppe wachsen? Nimm die Anfrage an und heiß Dein neues Mitglied willkommen, oder lehn sie ab.",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.other": "Soll Deine Gruppe wachsen? Nimm die Anfragen an und heiß Deine neuen Mitglieder willkommen, oder lehn sie ab.",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.zero": "Do you want your group to grow? Accept the request to welcome your new member or decline it.",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.one": "Mitgliedsanfrage ansehen",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.other": "Mitgliedsanfragen ansehen",
    "EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.zero": "View pending requests",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP": "Ausschluss aufheben",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_BODY": "Ausschluss aufheben? ",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_CANCEL": "Abbrechen",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_YES": "Ausschluss aufheben",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_SUCCESS": "{name} kann jetzt eine neue Mitgliedsanfrage stellen.",
    "EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_TEXT": "{name} ist dann nicht mehr ausgeschlossen, aber auch noch nicht wieder Mitglied dieser Gruppe. Dafür braucht es eine erneute Mitgliedsanfrage.",
    "EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR": "Moderationsstatus aufheben",
    "EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP": "{name} aus dem Moderations-Team entfernen?",
    "EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_CONTENT": "Dadurch verliert {first_name} den Moderations-Status und ist wieder normales Mitglied.",
    "EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_YES": "Ja, entfernen",
    "EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_SUCCESS": "Du hast {name} aus dem Moderations-Team entfernt.",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP": "Aus der Gruppe ausschließen",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_HEADLINE": "{name} aus der Gruppe ausschließen?",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP": "{first_name} ist dann kein Mitglied mehr und kann der Gruppe so lange nicht wieder beitreten, bis Du den Ausschluss aufhebst.",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_CANCEL": "Abbrechen",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_YES": "Ausschließen",
    "EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_SUCCESS": "{name} ist jetzt aus der Gruppe ausgeschlossen.",
    "EP_GROUP_MEMBERS_SEARCH_BAR": "Z. B. \"Max Mustermann\"",
    "EP_GROUP_MEMBERS_SEARCH_BAR_MOBILE": "Z. B. \"Max Mustermann\"",
    "EP_GROUP_MEMBERS_SEARCH_BUTTON": "Mitglieder durchsuchen",
    "EP_GROUP_MEMBERS_TOTAL.one": "Eine Person",
    "EP_GROUP_MEMBERS_TOTAL.other": "{value} Personen",
    "EP_GROUP_MEMBERS_TOTAL.zero": "Niemand",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBER": "Blockierung aufheben",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBER_POP_UP": "{first_name} kann dann wieder Beiträge und Kommentare in dieser Gruppe schreiben.",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBER_SUCCESS": "Die Blockierung ist jetzt aufgehoben. {name} kann wieder was veröffentlichen.",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL": "Abbrechen",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_YES": "Blockierung aufheben",
    "EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_HEADLINE": "{name} nicht mehr blockieren?",
    "EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_BODY": "Bestimmt gibt's in Deinem persönlichen Netzwerk spannende Leute, die Deiner Gruppe beitreten und an Deinen Events teilnehmen möchten.",
    "EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_CTA": "Leute einladen",
    "EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_HEADLINE": "Wen suchst Du für Deine Gruppe?",
    "EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_BODY": "Kennst Du Leute, die zu dieser Gruppe passen? Oder daran interessiert sind, Gruppen-Mitglieder kennenzulernen? Lad sie ein, beizutreten.",
    "EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_CTA": "Kontakte einladen",
    "EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_HEADLINE": "Wer sollte dieser Gruppe noch beitreten?",
    "EP_GROUP_OWNER_DRAFT_BANNER_BODY": "Es fehlen nur noch ein paar Infos. Und sobald sie veröffentlicht ist, kannst Du Leute in Deine Gruppe einladen.",
    "EP_GROUP_OWNER_DRAFT_BANNER_DELETE_CTA": "Gruppe verwerfen",
    "EP_GROUP_OWNER_DRAFT_BANNER_FINISH_CTA": "Jetzt fertigstellen",
    "EP_GROUP_OWNER_DRAFT_BANNER_TITLE": "Deine Gruppe <b>%group_name</b> ist fast fertig …",
    "EP_GROUP_OWNER_YOUR_GROUPS_PENDING_INFO": "Wird gerade geprüft (Antrag vom {date})",
    "EP_GROUP_ROLE_INFO_MEMBER": "Mitglied",
    "EP_GROUP_ROLE_INFO_MODERATOR": "Moderation",
    "EP_GROUP_SOCIAL_PROOF.one": "{username} ist schon dabei.",
    "EP_GROUP_SOCIAL_PROOF.other": "{numberOfContacts} Deiner Kontakte sind schon dabei.",
    "EP_GROUP_START_PAGE_BODY": "Gruppen sind dazu da, Leute kennenzulernen, die in derselben Situation sind, wie Du. Oder Persönlichkeiten der Branche. Z. B. bei Meetups zu einem bestimmten Thema oder beim Netzwerken.",
    "EP_GROUP_START_PAGE_CREATE_GROUP_CTA": "Gruppe starten",
    "EP_GROUP_START_PAGE_HEADER": "Entdecke echte Leute in Gruppen, die zu Dir passen!",
    "EP_GROUP_START_PAGE_NEW_GROUPS_HEADER": "Deine Gruppen mit neuem Design",
    "EP_GROUP_START_PAGE_NEW_GROUPS_INFO_BODY": "Das haben wir auch gefragt. Aber das Team meinte, dass es noch 4 Wochen dauert, bis alle umgestellt sind. Dann haben wir uns doch entschieden, Dir Deine ersten Gruppen im neuen Design gleich zu zeigen.",
    "EP_GROUP_START_PAGE_NEW_GROUPS_INFO_TITLE": "Warum sind manche Gruppen im neuen und manche im alten Design?",
    "EP_GROUP_START_PAGE_NEW_GROUPS_MEMBER_BODY": "Ganz neu und aufgehübscht. Und auf Deinem Smartphone oder Tablet sehen sie jetzt auch besser aus. Die restlichen Gruppen folgen übrigens bald.",
    "EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY": "Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. Dadurch kannst Du Deine Gruppen besser verwalten. Und auf dem Smartphone oder Tablet sehen sie jetzt auch besser aus. <a href=“https://faq.xing.com/node/68236”>Was ist neu?</a>",
    "EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_ANDROID": "Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>",
    "EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_IOS": "Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>",
    "EP_GROUP_START_PAGE_OLD_GROUPS_HEADER": "Deine Gruppen mit bestehendem Design",
    "EP_GROUP_START_PAGE_OLD_GROUPS_MEMBER_BODY": "Diese Gruppen sehen noch so aus wie vorher, werden aber auch bald im neuen Design erstrahlen.",
    "EP_GROUP_START_PAGE_SEARCH_GROUP_CTA": "Nach Gruppen suchen",
    "EP_GROUP_START_PAGE_TAB_EMPTY_STATE_BODY": "Finde jetzt Deine Gruppe und lern neue Leute kennen.",
    "EP_GROUP_START_PAGE_TAB_EMPTY_STATE_CTA": "Spannende Gruppen entdecken",
    "EP_GROUP_START_PAGE_TAB_EMPTY_STATE_TITLE": "Alle Deine Gruppen siehst Du hier.",
    "EP_GROUP_XBM_ENTRY_BODY": "Möchtest Du wissen, wie sich Deine Mitgliederzahlen entwickeln oder wie oft Deine Gruppe gefunden wird? ",
    "EP_GROUP_XBM_ENTRY_CTA": "Zur Gruppen-Analyse",
    "EP_HEADER_IMAGE_BANNER_BODY": "Gerade kannst Du das Titelbild als <strong>Entwurf speichern</strong> und es ist <strong>nur für Dich sichtbar</strong>. <br />\nMöchtest Du, dass andere Dein Titelbild auch sehen? Dann hole Dir das <strong>Upgrade</strong> und <strong>veröffentliche Dein Bild</strong> danach.",
    "EP_HEADER_IMAGE_BANNER_DRAFT_BUTTON": "Titelbild erstmal als Entwurf speichern",
    "EP_HEADER_IMAGE_BANNER_HEADER": "Upgrade sichern und Titelbild veröffentlichen",
    "EP_HEADER_IMAGE_BANNER_PUBLISH_BUTTON": "Upgrade sichern",
    "EP_HEADER_LAST_STEP_CREATE_PAGE": "Glückwunsch, die XING Seite {companyName} ist fast fertig!",
    "EP_HELP_CENTER": "Hilfebereich\n",
    "EP_IDEAL_EMPLOYER_ADMIN_ADAPT": "Das geht direkt im BrandManager.",
    "EP_IDEAL_EMPLOYER_ADMIN_GO_BM": "BrandManager öffnen",
    "EP_IDEAL_EMPLOYER_ADMIN_LAPTOP": "Das geht direkt im BrandManager (am besten mit etwas größerem Bildschirm). ",
    "EP_IDEAL_EMPLOYER_ADMIN_POSITION": " \"Wunsch-Arbeitgeber\"-Modul bearbeiten",
    "EP_IDEAL_EMPLOYER_EDIT_HINT": "Im BrandManager siehst Du, wie viele Mitglieder Dein Unternehmen derzeit als Wunsch-Arbeitgeber angeben.",
    "EP_IDEAL_EMPLOYER_EDIT_HINT_CTA": "Zum BrandManager",
    "EP_IDEAL_EMPLOYER_EI_CONFIDENTIAL": "Außer dem Arbeitgeber erfährt niemand davon – es sei denn, Du hast andere in Deinen Job-Wünschen dafür freigeschaltet.",
    "EP_IDEAL_EMPLOYER_EI_HOW": "Wie funktioniert das?",
    "EP_IDEAL_EMPLOYER_EI_NON_COMMITTAL": "Wir sagen dem Arbeitgeber Bescheid, dass Du gerne dort arbeiten würdest. ",
    "EP_IDEAL_EMPLOYER_EI_POTENTIAL": "Dadurch erhöhst Du Deine Chance, von diesem Arbeitgeber kontaktiert zu werden.",
    "EP_IDEAL_EMPLOYER_EI_UPTO_30": "Du kannst bis zu 30 Wunsch-Arbeitgeber eintragen.",
    "EP_IDEAL_EMPLOYER_MAX": "Du hast jetzt 30 Wunsch-Arbeitgeber eingetragen – mehr geht leider nicht. ",
    "EP_IMAGE_UPLOAD_SIZE_FORMAT_ERROR": "Dieses Bild geht leider nicht: Mögliche Formate sind JPG, JPEG oder PNG, die Maximalgröße beträgt 5 MB.",
    "EP_INDUSTRY_SUBCATEGORY": "Unterbereich",
    "EP_INFO_LAST_STEP_CREATE_PAGE": "– In der Zwischenzeit kannst Du schon weitere Inhalte zur Seite hinzufügen.",
    "EP_INPUT_CHARS_LEFT": "Noch {charactersNumber} Zeichen\n",
    "EP_INVALID_COMPANY_NAME": "Eine XING Seite mit diesem Namen gibt's schon. War da vielleicht jemand schneller?",
    "EP_JOB_ADS_FOUND": "{total} Stellenangebote gefunden",
    "EP_JOB_LOOKING": "Auf Job-Suche?",
    "EP_JOB_NO_VACANCIES": "Im Moment gibt's keine Job-Angebote.",
    "EP_JOBS_DAYSAGO": "Vor {number} Tagen ",
    "EP_JOBS_EDIT_HINT": "Hier werden alle Stellenanzeigen angezeigt, die Dein Unternehmen bei XING geschaltet hat. ",
    "EP_JOBS_EDITSWITCH_CTA": "Zum XING JobManager",
    "EP_JOBS_EDITSWITCH_DISCRIPTION": "… kannst Du direkt im {jobManager}.\nDas geht übrigens am besten am großen Bildschirm.",
    "EP_JOBS_EDITSWITCH_DISCRIPTION_INNER": "XING JobManager",
    "EP_JOBS_EDITSWITCH_HEADLINE": "Stellenanzeigen schalten und verwalten",
    "EP_JOBS_EMPTYSTATE_CTA": "Neues Jobangebot hinzufügen",
    "EP_JOBS_FEEDBACK_ERROR": "Das hat leider nicht geklappt",
    "EP_JOBS_LINK": "Alle {number} Jobs ",
    "EP_JOBS_MATCH": "{number} % Übereinstimmung ",
    "EP_JOBS_RECOMMENDATION": "Job-Vorschläge ansehen",
    "EP_JOBS_SUBPAGE_DESCRIPTION": "Alle Jobangebote von {pageTitle} auf einen Blick",
    "EP_JOBS_TODAY": "Heute",
    "EP_JOBS_YESTERDAY": "Gestern",
    "EP_KUNUNU_ALL_BENEFITS": "Alle Vorteile",
    "EP_KUNUNU_ALL_REVIEWS": "Alle {number} Bewertungen auf kununu",
    "EP_KUNUNU_BENEFITS_CONFIRMATION": "In {total} von {totalReviews} Bewertungen bestätigt",
    "EP_KUNUNU_CULTURE_BUTTON": "Unternehmenskultur anzeigen",
    "EP_KUNUNU_DISCOVER_REVIEWS": "Erfahre noch mehr über diesen Arbeitgeber:",
    "EP_KUNUNU_DISCOVER_REVIEWS_CULTURE": "Lerne das Unternehmen kennen und erfahre mehr über seine Kultur.",
    "EP_KUNUNU_EDIT_HINT": "Diese Bewertungen kommen direkt von Eurem kununu-Profil.",
    "EP_KUNUNU_EDIT_HINT_CTA": "Zum kununu-Profil",
    "EP_KUNUNU_RATING_VALUE": "{value} / {fullValue}",
    "EP_KUNUNU_READ_REVIEW": "Bewertung lesen",
    "EP_KUNUNU_SHARE_BUTTON": "Diesen Arbeitgeber bewerten",
    "EP_KUNUNU_SHARE_DETAIL": "Teil Deine Erfahrungen mit anderen, natürlich anonym. ",
    "EP_KUNUNU_SHARE_TITLE": "Hast Du für {company} gearbeitet?",
    "EP_KUNUNU_WHAT_SAY_BUTTON": "Profil auf kununu ansehen",
    "EP_LEARN_MORE_ABOUT_US": "Alle Infos über uns",
    "EP_LEGAL_NOTICE_EMPTY_STATE": "Impressum",
    "EP_LOCATION_ADDRESS_ERROR": "Diese Anschrift haben wir nicht gefunden – kannst Du Dir das nochmal anschauen?",
    "EP_LOCATION_CITY_ERROR": "Diesen Ort haben wir nicht gefunden – kannst Du Dir das nochmal anschauen?",
    "EP_LOCATION_EMAIL_ERROR": "Dies scheint keine E-Mail-Adresse zu sein … vielleicht vertippt?",
    "EP_LOCATION_EMPTY_STATE_BUTTON": "Kontaktdaten eingeben",
    "EP_LOCATION_EMPTY_STATE_TEXT": "Bitte gib noch Eure Anschrift und Kontaktdaten an. Danach kannst Du die Seite veröffentlichen.",
    "EP_LOCATION_EMPTY_STATE_TITLE": "Wo seid Ihr zu finden? Und wie erreichbar?",
    "EP_LOCATION_FAXNUMBER_ERROR": "Bitte gib hier nur Ziffern ein (mind. 5).",
    "EP_LOCATION_LABEL_ERROR": "Diesen Ort haben wir nicht erkannt – kannst Du Dir das nochmal anschauen?",
    "EP_LOCATION_PHONENUMBER_ERROR": "Bitte gib hier nur Ziffern ein (mind. 5).",
    "EP_LOCATION_POSTCODE_ERROR": "Bitte gib hier keine Sonderzeichen ein.",
    "EP_LOCATION_WEBSITE_ERROR": "Diese Web-Adresse haben wir nicht gefunden … vielleicht vertippt?",
    "EP_LOCATIONS_EDIT_TITLE": "Standort bearbeiten",
    "EP_MAIL_LAST_STEP_CREATE_PAGE": "– Wir senden die Bestätigungs-Mail an die folgende E-Mail-Adresse: {mail}",
    "EP_MANAGE_CONTENT": "Medien verwalten",
    "EP_MAX": "Max.",
    "EP_MEMBERS_BLOCKED_MEMBER_LEAVE_BODY": "Du bist dann kein Mitglied mehr und kannst der Gruppe auch nicht wieder beitreten.",
    "EP_MEMBERS_BLOCKED_MEMBER_LEAVE_HEADLINE": "Möchtest Du die Gruppe verlassen?",
    "EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.one": "{value} gemeinsamer Kontakt",
    "EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.other": "{value} gemeinsame Kontakte",
    "EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.zero": "Keine gemeinsamen Kontakte",
    "EP_MEMBERS_FEEDBACK_ERROR": "Das hat gerade leider nicht geklappt. Versuch's bitte gleich nochmal.",
    "EP_MEMBERS_HEADLINE": "Mitglieder",
    "EP_MEMBERS_LEAVE_GROUP_NO": "Abbrechen",
    "EP_MEMBERS_LEAVE_GROUP_YES": "Gruppe verlassen",
    "EP_MEMBERS_MEMBER_LEAVE_BODY": "Du bist dann kein Mitglied mehr, kannst der Gruppe später aber wieder beitreten.",
    "EP_MEMBERS_MEMBER_LEAVE_HEADLINE": "Möchtest Du die Gruppe verlassen?",
    "EP_MEMBERS_MODERATOR_LEAVE_BODY": "Du bist dann kein Mitglied mehr und verlierst alle Moderations-Rechte, kannst der Gruppe später aber wieder beitreten.",
    "EP_MEMBERS_MODERATOR_LEAVE_HEADLINE": "Möchtest Du die Gruppe verlassen?",
    "EP_MEMBERS_OR": "oder",
    "EP_META_ABOUT_US_DESCRIPTION": "► Was zeichnet {pageTitle} als Arbeitgeber aus? Wie ist es, dort zu arbeiten? Das Unternehmen stellt sich Dir vor.",
    "EP_META_ABOUT_US_TITLE": "Über {pageTitle} | XING",
    "EP_META_COMPANY_DESCRIPTION": "► Alles über {pageTitle} als Arbeitgeber: Informationen, Neuigkeiten, offene Stellen, Ansprechpersonen, Standorte und mehr",
    "EP_META_CONTACTS_DESCRIPTION": "Ansprechpersonen für alle Anliegen an den Arbeitgeber {pageTitle}",
    "EP_META_CONTACTS_TITLE": "Ansprechpersonen von {pageTitle} | XING",
    "EP_META_DESCRIPTION_COMPANY_PAGES": "Was zeichnet {pageTitle} als Arbeitgeber aus? Hier erfährst Du's.",
    "EP_META_DESCRIPTION_DEFAULT": "Infos, aktuelle Neuigkeiten und offene Jobs von {pageTitle} – direkt auf XING.",
    "EP_META_DESCRIPTION_PUBLISHER_PAGES": "Die besten Artikel von {pageTitle} – einfach folgen, direkt auf XING.",
    "EP_META_DESCRIPTION_TOPIC_PAGES": "Das Neueste zum Thema {pageTitle} – einfach folgen, direkt auf XING.",
    "EP_META_EMPLOYEES_DESCRIPTION": "► Mitarbeitende von {pageTitle} bei XING. Wenn kennst Du schon – und seid Ihr schon vernetzt? Wenn nicht, lernt Euch kennen und tauscht Euch zu gemeinsamen Themen aus.",
    "EP_META_EMPLOYEES_TITLE": "Mitarbeitende von {pageTitle} | XING",
    "EP_META_EVENTS_DESCRIPTION": "✅ Tausch Dich aus, vernetz Dich oder lern andere Mitglieder kennen.",
    "EP_META_EVENTS_TITLE": "Events von {pageTitle} | XING",
    "EP_META_JOBS_DESCRIPTION": "✅ Auf Job-Suche? Hier siehst Du aktuelle Stellenangebote von {pageTitle}. Informier Dich auch über Vorteile für Mitarbeitende und bewirb Dich direkt.",
    "EP_META_JOBS_TITLE": "Offene Stellen bei {pageTitle} | XING",
    "EP_META_NEWS_DESCRIPTION": "► Was gibt's Neues und Interessantes bei {pageTitle}? Hier erfährst Du's – aus erster Hand. Folge jetzt der XING Seite von {pageTitle}.",
    "EP_META_NEWS_TITLE": "Neuigkeiten und Infos von {pageTitle} | XING",
    "EP_META_PAGE_TITLE": "{pageTitle}: Informationen und Neuigkeiten | XING",
    "EP_META_WEBSITE_ERROR": "Dies scheint keine Website zu sein … vielleicht vertippt?",
    "EP_META_YEAR_LABEL_ERROR": "Dies scheint kein Jahr zu sein … vielleicht vertippt?",
    "EP_MIN": "Mind.",
    "EP_MODULE_ERROR_SUBLINE": "Bitte versuch es nochmal oder geh zur {overview} zurück.",
    "EP_MODULE_ERROR_SUBLINE_INNER": "{entityPage} Überblick",
    "EP_NA": "Keine Angabe",
    "EP_NAVIGATION_EDIT_HINT": "Die Sichtbarkeit und Reihenfolge der Tabs kannst Du im BrandManager ändern.",
    "EP_NAVIGATION_EDIT_HINT_CTA": "BrandManager öffnen",
    "EP_NEW_PAGE_CREATED_DRAFT": "Dieses Arbeitgeberprofil befindet sich im Entwurfsmodus und ist noch nicht veröffentlicht.",
    "EP_NEWS_ACTION_TYPE_ARTICLE": "hat diesen Artikel geteilt.",
    "EP_NEWS_ACTION_TYPE_IMAGE": "hat dieses Bild geteilt.",
    "EP_NEWS_ACTION_TYPE_LINK": "hat diesen Link geteilt.",
    "EP_NEWS_ACTION_TYPE_TEXT": "hat einen Beitrag geschrieben.",
    "EP_NEWS_ACTION_TYPE_VIDEO": "hat dieses Video geteilt.",
    "EP_NEWS_SUBPAGE_DESCRIPTION": "Alle Neuigkeiten von {pageTitle} auf einen Blick",
    "EP_NEWS_UPSELL_POPOVER_BODY": "Ein angehefteter Artikel erscheint immer an oberster Stelle aller Neuigkeiten. Damit hebst Du Beiträge hervor, die besondere Aufmerksamkeit verdienen.",
    "EP_NEWS_UPSELL_POPOVER_BUTTON": "Alle Vorteile entdecken",
    "EP_NEWS_UPSELL_POPOVER_HEADER": "Top-Artikel anheften",
    "EP_NEXT_BUTTON_LAST_STEP_CREATE_PAGE": "Arbeitgeberprofil weiter bearbeiten",
    "EP_NO_DOCUMENTS": "Biete Deinen Seitenbesuchern hier z. B. Produkt-Infos, Jahresberichte oder Firmen-Zeitschriften.",
    "EP_NO_DOCUMENTS_HEADLINE": "Hier ist Platz für Eure PDF-Dokumente.",
    "EP_OF_CONTACTS": "Deiner Kontakte",
    "EP_OPTIONAL_FIELD_HINT": "Optional",
    "EP_OPTIONS": "Was möchtest Du tun?",
    "EP_PAGE_CREATION_ABOUT_US_SUBHEADER": "Titel und Beschreibung erscheinen auf Eurem Arbeitgeberprofil unter „Über uns“. Beides ist notwendig für die Freigabe, aber kann in Eurem Profil natürlich noch angepasst werden.",
    "EP_PAGE_CREATION_BACK_TO_COMPANIES": "Zurück zur Übersicht",
    "EP_PAGE_CREATION_CLOSE": "Ja, löschen",
    "EP_PAGE_CREATION_CLOSE_PROCESS": "Möchtest Du die Seite {name} wirklich löschen?",
    "EP_PAGE_CREATION_COMPANY_NAME_HELPER": "Bitte achte hier auf die richtige Schreibweise, weil Du diese Eingabe nicht mehr korrigieren kannst.",
    "EP_PAGE_CREATION_CONDITIONS": "Ich bin berechtigt, diese XING Seite zu erstellen, und akzeptiere die <a href=\"https://www.xing.com/terms/employer-branding-profil\" target=\"_blank\">AGB für XING Unternehmensprofile</a>.",
    "EP_PAGE_CREATION_CONTACTS_INFO": "Diese Kontaktdaten werden auf der XING Seite veröffentlicht. ",
    "EP_PAGE_CREATION_DELETE_PROFILE": "Profilentwurf löschen",
    "EP_PAGE_CREATION_DIALOG_CLOSE": "Prozess beenden",
    "EP_PAGE_CREATION_DIALOG_TEXT": "Möchtest Du den Prozess wirklich beenden? Deine Eingaben auf dieser Seite gehen dann verloren.",
    "EP_PAGE_CREATION_DO_NOT_CLOSE": "Abbrechen",
    "EP_PAGE_CREATION_FORM_1_TITLE": "Das Wichtigste zu Deinem Unternehmen",
    "EP_PAGE_CREATION_RESUME_OR_DELETE": "Schließ bitte die Erstellung der XING Seite ab, damit wir Deine Eingaben prüfen können. Wenn Du nochmal von vorne anfangen willst, kannst Du die Seite auch löschen.",
    "EP_PAGE_CREATION_SAVE_NEXT": "Speichern und weiter",
    "EP_PAGE_CREATION_SEND_FOR_APPROVAL": "Freigabe beantragen",
    "EP_PAGE_INFO_HELP_BODY": "Im Hilfebereich findest Du viele hilfreiche Tipps zum Einrichten der XING Seite.",
    "EP_PAGE_INFO_HELP_CTA": "Zum Hilfebereich",
    "EP_PAGE_INFO_HELP_TITLE": "Fragen?",
    "EP_PAGE_INFO_MANAGE_BODY": "Im BrandManager kannst Du Module hinzufügen, ausblenden oder umsortieren.",
    "EP_PAGE_INFO_MANAGE_CTA": "BrandManager öffnen",
    "EP_PAGE_INFO_MANAGE_TITLE": "Module verwalten",
    "EP_PAGE_INFO_PAGE_TYPE_FREE": "Gratisprofil",
    "EP_PAGE_INFO_PAGE_TYPE_LABEL": "Seitentyp",
    "EP_PAGE_INFO_PAGE_TYPE_PAID": "Employer Branding Page",
    "EP_PAGE_INFO_PAGE_TYPE_PAID_PLUS": "Employer Branding Page Professional",
    "EP_PAGE_INFO_ROLE_ADMINISTRATOR": "Admin",
    "EP_PAGE_INFO_ROLE_EDITOR": "Editor",
    "EP_PAGE_INFO_ROLE_LABEL": "Deine Rolle:",
    "EP_PAGE_INFO_ROLE_OWNER": "Eigentümer",
    "EP_PAGE_INFO_TITLE": "Infos zur Seite",
    "EP_PAGE_OWNER": "Seiten-Editor ",
    "EP_PARAMS_INCORRECT_ERROR": "Bitte gib noch den Titel und die Beschreibung ein (jeweils mind. 4 Zeichen).",
    "EP_PROMOTE_PAGE": "Seite bewerben",
    "EP_PUBLISH_CTA": "Speichern",
    "EP_READ_LESS": "Weniger anzeigen",
    "EP_READ_MORE": "Weiterlesen",
    "EP_READ_MORE_CTA": "Weiterlesen",
    "EP_REPORT_NEWS_ITEM": "Melden",
    "EP_REQUIRED_FIELD": "Pflichtfeld",
    "EP_RESTORE_CTA": "Wiederherstellen",
    "EP_RESULT_LIST_CONTACT": "War die richtige Ansprechperson nicht dabei? Wir helfen Dir gerne weiter:  <a href=\"mailto:customer.support@xing.com\">customer.support@xing.com</a>",
    "EP_RESULT_LIST_CONTACT_V2": "War die richtige Ansprechperson nicht dabei? Wir helfen Dir gerne weiter:  <a>customer.support@xing.com</a>",
    "EP_RESULT_LIST_HEADLINE": "Ansprechperson auswählen",
    "EP_ROLLOUT_BANNER_ADD_LEGAL_NOTICE": "Euer Impressum",
    "EP_ROLLOUT_BANNER_CONFIRM_BUTTON": "Zum neuen Design wechseln ",
    "EP_ROLLOUT_BANNER_CONTACT_DETAILS": "Eure Kontaktdaten",
    "EP_ROLLOUT_BANNER_CONTACT_DETAILS_DESCRIPTION": "Bitte gib hier die Adresse sowie Telefonnummer des Unternehmens an.",
    "EP_ROLLOUT_BANNER_DESCRIPTION": "Eure neue XING Seite steht in den Startlöchern.\nSchau doch mal, ob alle Angaben so richtig und vollständig sind. Wenn nicht, kannst Du sie noch ändern:",
    "EP_ROLLOUT_BANNER_LEGAL_ADVICE_DESCRIPTION": "Bitte gib hier den Link zum Impressum Eurer Unternehmens-Website an oder trag das Impressum manuell ein.",
    "EP_ROLLOUT_BANNER_MOBILE_INFO": "Öffne die XING Seite bitte auf einem PC, um zum neuen Design zu wechseln.",
    "EP_ROLLOUT_BANNER_OLD_URL": "Besucher Eures alten Arbeitgeberprofils werden zukünftig umgeleitet.",
    "EP_ROLLOUT_BANNER_PROFILE_UPDATED": "Willkommen auf Eurer neuen XING Seite!",
    "EP_ROLLOUT_BANNER_PUBLISH_INFO": "Alles geprüft? Prima, dann kannst Du zum neuen Design wechseln:",
    "EP_ROLLOUT_BANNER_TEXT_EMAIL": "Hast Du Fragen? Wir helfen Dir gerne weiter:\n<br/>\nE-Mail: <a href=\"mailto:customer.support@xing.com\">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131 778",
    "EP_ROLLOUT_BANNER_TITLE": "Fast geschafft!",
    "EP_ROLLOUT_BANNER_UPDATED_URL": "Der Link zu Eurer XING Seite ist jetzt <strong>www.xing.com/pages/{slug}</strong>.",
    "EP_ROLLOUT_BANNER_WEBINAR_LINK": "https://attendee.gotowebinar.com/rt/2071891534032487180",
    "EP_ROLLOUT_PUBLISH_ERROR_ABOUT_US": "Bitte füg jetzt noch Deine ausführliche Beschreibung für die Rubrik \"Über uns\" hinzu.",
    "EP_ROLLOUT_PUBLISH_ERROR_LOCATION": "Bitte füge noch die Kontaktdaten Deines Unternehmens hinzu.",
    "EP_ROLLOUT_WEBINAR_TEXT_1": "Lust auf einen Rundgang durch die neue XING Seite? Oder hast Du bestimmte Fragen? Dann registriere Dich gern für eines unserer",
    "EP_ROLLOUT_WEBINAR_TEXT_2": "Registriere Dich für eines unserer",
    "EP_ROLLOUT_WEBINAR_TEXT_LINK": "Live-Webinare",
    "EP_SELECT_NONE": "Nichts davon",
    "EP_SHOW_ALL_RESULTS": "Alle Ergebnisse",
    "EP_SHOW_MORE_RESULTS": "Weitere Ergebnisse ",
    "EP_SLOGAN_EDIT_HEADLINE": "Slogan bearbeiten",
    "EP_SLOGAN_EDIT_HINT": "Hier steht der Slogan Eurer Seite.",
    "EP_SLOGAN_EDIT_LABEL": "Slogan der Seite",
    "EP_SUBPAGE_BACK": "Zur Übersicht",
    "EP_TELEPHONE": "Telefon",
    "EP_TITLE_EDIT_HINT": "Als Seitentitel eignet sich oft der Firmen-Name.",
    "EP_TITLE_EDIT_LABEL": "Titel der Seite",
    "EP_UPLOAD_COVER": "Titelbild auswählen",
    "EP_UPLOAD_COVER_LABEL": "Wähle ein eindrucksvolles Titelbild für Deine XING Seite.",
    "EP_UPLOAD_DOCUMENT": "PDF hinzufügen",
    "EP_UPLOAD_IMAGE_DRAG_LABEL": "Logo-Datei hier ablegen",
    "EP_UPLOAD_IMAGE_HINT": "JPG, BMP oder PNG (max. 5 MB) im Format 16:9",
    "EP_UPLOAD_IMAGE_LABEL": "Datei hierher ziehen oder auswählen",
    "EP_UPLOAD_LOGO": "Neues Logo hinzufügen",
    "EP_UPLOAD_LOGO_DRAG_LABEL": "Du kannst das Logo hier ablegen.",
    "EP_UPLOAD_LOGO_HINT": "JPG, BMP oder PNG (max. 5 MB), Format: Quadrat",
    "EP_UPLOAD_LOGO_LABEL": "Datei hierher ziehen oder auswählen",
    "EP_UPSELL_BANNER_CONTAINER_DISCARD_BUTTON": "Verwerfen",
    "EP_UPSELL_BANNER_CONTAINER_PUBLISH_BUTTON": "Weiter",
    "EP_UPSELL_BODY_TOP_HEADER": "Mach Deine Seite einzigartig: mit einem eigenen Titelbild und Slogan. ",
    "EP_UPSELL_COMPANY_RECOMMENDED_BODY": "Mit dem Employer Branding Profil erscheinen hier keine Empfehlungen für fremde Unternehmen mehr. So liegt der Fokus allein auf dieser Seite.",
    "EP_UPSELL_COMPANY_RECOMMENDED_HEADER": "Weniger ist mehr!",
    "EP_UPSELL_CONTACT_BODY": "Füg der Seite mehrere Ansprechpersonen hinzu, damit Interessierte immer den richtigen Kontakt für ihre Anfragen finden.",
    "EP_UPSELL_CONTACT_HEADER": "Immer die richtige Ansprechperson",
    "EP_UPSELL_DOCUMENTS": "Mit nützlichen Dokumenten –  z. B. offiziellen Firmenpräsentationen, Tipps, Handbüchern – wird Eure XING Seite für Interessierte ein zentraler Ort für relevante Informationen.",
    "EP_UPSELL_DOCUMENTS_HEADER": "Alle relevanten Infos an einem zentralen Ort",
    "EP_UPSELL_DOCUMENTS_HEADLINE": "Dokumente hinzufügen",
    "EP_UPSELL_EMPLOYER_FLAG_BUTTON": "Employer Branding Profil",
    "EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY": "Diesen und mehr Vorteile gibt’s beim Employer Branding Profil. <br / >\nMit Klick auf den Stift <strong>Bild wählen</strong> und in die <strong>richtige Position</strong> rücken. Mit einem Upgrade kannst Du’s veröffentlichen.",
    "EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY_WITH_IMAGE": "Aktuell ist es aber nur für Dich sichtbar – eigentlich schade, oder? <br />\nSicher Dir das Upgrade, damit auch andere es sehen können.",
    "EP_UPSELL_EMPLOYER_FLAG_CONTENT_BUTTON": "Upgrade",
    "EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER": "Hier ist Platz für ein Titelbild!",
    "EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER_WITH_IMAGE": "Dein Titelbild sieht gut aus!",
    "EP_UPSELL_GALLERY_ABOUT_US": "Gestalte Eure Seite interessant und einzigartig: mit Bildern und Videos aus dem Unternehmen, von Eurem Team oder von Euren Produkten.",
    "EP_UPSELL_GALLERY_ABOUT_US_HEADER": "Sichtbar beeindruckend.",
    "EP_UPSELL_GALLERY_BUTTON": "Vorteile entdecken",
    "EP_UPSELL_HEADER_TOP_HEADER": "Mit Titelbild & Slogan neue Talente gewinnen",
    "EP_UPSELL_PROFILE_MULTIMEDIA_BODY": "Gestalte Eure Seite interessant und einzigartig: mit Bildern und Videos aus dem Unternehmen, von Eurem Team oder von Euren Produkten.",
    "EP_UPSELL_PROFILE_MULTIMEDIA_HEADER": "Eigene Videos und Bilder",
    "EP_VISIT_WEBSITE_EMPTY_STATE": "Webseite",
    "EP_WHO_TO_CONTACT": "Unsere Ansprechpersonen",
    "FEEDY_CARD_VERB_CONTENT_PAGE_ARTICLE_POST": "hat einen Artikel veröffentlicht",
    "FEEDY_CARD_VERB_IMAGE_POST": "hat dieses Bild geteilt",
    "FEEDY_CARD_VERB_LINK_POST": "hat diesen Link geteilt",
    "FEEDY_CARD_VERB_STATUS_POST": "hat einen Beitrag geschrieben",
    "INDUSTRY": "Branche",
    "NEWS_MODULE_DELETE_LABEL": "Löschen",
    "NEWS_MODULE_DIALOG_DELETE_HEADLINE": "Artikel löschen?",
    "NEWS_MODULE_DIALOG_DELETE_NO": "Nein",
    "NEWS_MODULE_DIALOG_DELETE_TEXT": "Soll dieser Artikel wirklich für immer gelöscht werden?",
    "NEWS_MODULE_DIALOG_DELETE_YES": "Ja, löschen",
    "NEWS_MODULE_DIALOG_HIDE_HEADLINE": "Artikel ausblenden?",
    "NEWS_MODULE_DIALOG_HIDE_NO": "Nein",
    "NEWS_MODULE_DIALOG_HIDE_TEXT": "Er ist dann auf XING nicht mehr auffindbar.",
    "NEWS_MODULE_DIALOG_HIDE_YES": "Ja, ausblenden",
    "NEWS_MODULE_DIALOG_PIN_HEADLINE": "Top-Artikel anheften?",
    "NEWS_MODULE_DIALOG_PIN_NO": "Nein",
    "NEWS_MODULE_DIALOG_PIN_TEXT": "Soll dieser Artikel immer an oberster Postion erscheinen?",
    "NEWS_MODULE_DIALOG_PIN_YES": "Ja, ab nach oben ",
    "NEWS_MODULE_DIALOG_UNPIN_HEADLINE": "Nicht mehr anheften?",
    "NEWS_MODULE_DIALOG_UNPIN_NO": "Oben belassen",
    "NEWS_MODULE_DIALOG_UNPIN_TEXT": "Möchtest Du diesen Artikel wieder abheften?",
    "NEWS_MODULE_DIALOG_UNPIN_YES": "Ja, entfernen",
    "NEWS_MODULE_DRAFT_LABEL": "Entwurf",
    "NEWS_MODULE_DRAFT_TAB": "Entwürfe",
    "NEWS_MODULE_EDIT_ALL": "Alle Neuigkeiten bearbeiten",
    "NEWS_MODULE_EDIT_LABEL": "Bearbeiten",
    "NEWS_MODULE_EMPTY_STATE_DESCRIPTION": "Du kannst der Seite einfach folgen, um keine zukünftigen Updates zu verpassen.\t",
    "NEWS_MODULE_EMPTY_STATE_TITLE": "Hier findest Du Deine wichtigsten Neuigkeiten.",
    "NEWS_MODULE_EMPTYSTATE_DESCRIPTION": "Dieses Modul ist für andere sichtbar, sobald mindestens einen Artikel oder Beitrag veröffentlicht wurde. ",
    "NEWS_MODULE_EMPTYSTATE_TITLE": "Füg hier Euren ersten Artikel hinzu.",
    "NEWS_MODULE_HIDDEN_LABEL": "Ausgeblendet",
    "NEWS_MODULE_HIDDEN_TAB": "Ausgeblendet",
    "NEWS_MODULE_HIDE_BUTTON": "Ausblenden",
    "NEWS_MODULE_PIN_BUTTON": "Anheften",
    "NEWS_MODULE_PINNED_LABEL": "Angeheftet",
    "NEWS_MODULE_PROMOTE_BUTTON": "Bewerben",
    "NEWS_MODULE_PROMOTE_LABEL": "Gesponsert",
    "NEWS_MODULE_PUBLISH_FIRST_ARTICLE_BODY": "Dieses Modul wird dann für Seitenbesucher sichtbar.",
    "NEWS_MODULE_PUBLISH_FIRST_ARTICLE_TITLE": "Veröffentliche jetzt Euren ersten Artikel.",
    "NEWS_MODULE_PUBLISHED_STORY_LABEL": "Veröffentlicht",
    "NEWS_MODULE_PUBLISHED_TAB": "Veröffentlicht",
    "NEWS_MODULE_SCHEDULE_LABEL": "Geplant",
    "NEWS_MODULE_SCHEDULED_TAB": "Terminiert",
    "NEWS_MODULE_SHOW_BUTTON": "Einblenden",
    "NEWS_MODULE_SHOW_STATISTICS": "Statistiken ansehen",
    "NEWS_MODULE_TOP_AREA_CTA": "Einen Artikel auswählen",
    "NEWS_MODULE_TOP_AREA_HEADLINE": "Welche Beiträge sind Eure Top-Artikel?",
    "NEWS_MODULE_TOP_AREA_SUB": "Per Klick auf das Sternsymbol kannst Du einen Artikel aus Eurer Sammlung hier prominent hervorheben.",
    "NEWS_MODULE_TOP_LABEL": "Top-Artikel",
    "NEWS_MODULE_UNPIN_BUTTON": "Nicht mehr anheften",
    "NEWS_MODULE_UNPIN_LABEL": "Nicht mehr anheften",
    "SHARED_BUTTON_CONTINUE": "Weiter",
    "TOP_ARTICLE_PAID_COPY": "Hefte Deine Top-Artikel an und wechsel sie beliebig oft aus, sodass der aktuell wichtigste Beitrag immer an oberster Stelle der Neuigkeiten erscheint.",
    "TOP_ARTICLE_PAID_CTA": "Alle Vorteile entdecken",
    "TOP_ARTICLE_PAID_FLAG": "Employer Branding Profil",
    "TOP_ARTICLE_PAID_HEADLINE": "Was steht für Dich an erster Stelle?",
    "A11Y_ADVERTISEMENT_FRAME_TITLE": "Anzeige",
    "A11Y_LOGO": "Zur XING Startseite",
    "A11Y_SETTINGS_DROPDOWN_LABEL": "Einstellungen verwalten",
    "ACTIVE_LANGUAGE": "Deutsch",
    "ADVERTISEMENT_LABEL": "Anzeige",
    "BENEFIT_OVERVIEW_BASIC": "Basis",
    "BENEFIT_OVERVIEW_RECRUITER": "Recruiter",
    "BENEFIT_OVERVIEW_SALES": "Sales",
    "BUTTON_BACK": "Zurück",
    "BUTTON_CANCEL": "Abbrechen",
    "BUTTON_CLOSEWINDOW": "Fenster schließen",
    "BUTTON_CONTINUE": "OK",
    "CAL_DATE_FORMAT": "DD.MM.YYYY",
    "CAL_DATE_FORMAT_HINT": "TT.MM.JJJJ",
    "DAY_NAMES_SHORT": "Mo,Di,Mi,Do,Fr,Sa,So",
    "ERROR_SOMETHING_WENT_WRONG": "Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.",
    "FLMP_MENU_CREATE_PROJECT": "Projekt einstellen",
    "FLMP_MENU_FIND_PROJECT": "Projekte finden",
    "FLMP_MENU_OVERVIEW": "Übersicht Projekte",
    "FLMP_MENU_YOUR_SPACE": "Projekte verwalten",
    "FOOTER_ABOUT_XING": "Über XING",
    "FOOTER_ADVERTISE": "Werben",
    "FOOTER_AMIANDO_2": "Event-Ticketing",
    "FOOTER_BEWERBUNG": "Bewerbungsratgeber",
    "FOOTER_BLOG": "Blog",
    "FOOTER_COMMUNITY": "Community",
    "FOOTER_DATA_PROTECTION": "Datenschutz",
    "FOOTER_DEVELOPER_PORTAL": "Entwickler",
    "FOOTER_IMPRINT": "Impressum",
    "FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "FOOTER_INVITE_TO_XING": "Zu XING einladen",
    "FOOTER_JOBS": "Karriere bei XING",
    "FOOTER_KUNUNU": "Arbeitgeber",
    "FOOTER_LANGUAGES": "Sprache",
    "FOOTER_LEBENSLAUF": "Lebenslauf-Editor",
    "FOOTER_LOGINWXING": "Mit XING einloggen",
    "FOOTER_MEMBERSHIP_AND_PARTNER": "Produkte & Angebote",
    "FOOTER_MOBILE": "Mobil",
    "FOOTER_PEOPLE_DIRECTORY": "Mitgliederverzeichnis",
    "FOOTER_PRESS": "Presse",
    "FOOTER_PROJOBS_UPSELL_BTN": "Zu XING ProJobs",
    "FOOTER_SECURITY": "Sicherheit",
    "FOOTER_TALENT_MANAGER2": "Personalbeschaffung mit XING",
    "FOOTER_TANDC": "AGB",
    "FOOTER_TOPICPAGES": "Themenseiten",
    "FOOTER_TOP_DEALS": "Vorteilsprogramm",
    "FOOTER_USEFUL": "Nützliches",
    "FOOTER_XAS": "Werbeanzeige erstellen",
    "FOOTER_XING_AG": "New Work SE",
    "FOOTER_XING_SEMINARS": "Seminare",
    "FOOTER_YOUR_XING": "Hauptbereiche",
    "FRAME_HEADER_UPSELL_PREMIUM": "Premium werden",
    "FRAME_HEADER_UPSELL_PROJOBS": "ProJobs entdecken",
    "FRAME_NAVIGATION_PROJOBS_UPSELL": "ProJobs werden",
    "FRAME_NAVIGATION_YOUR_PREMIUM": "Dein Premium",
    "FRAME_NAVIGATION_YOUR_PROJOBS": "Dein ProJobs",
    "GLOBAL_SCROLL_TOP": "Nach oben",
    "GROUPS_NAV_OVERVIEW": "Übersicht",
    "HEADER_LOGIN_BUTTON": "Einloggen",
    "HEADER_LOGIN_EMAIL_PHONE": "E-Mail / Handynummer",
    "HEADER_LOGIN_EMAIL_USERNAME": "E-Mail",
    "HEADER_LOGIN_LAND": "Land",
    "HEADER_LOGIN_PASSWORD": "Passwort",
    "HEADER_LOGIN_PASSWORD_LOST": "Probleme beim Einloggen",
    "HEADER_LOGIN_PHONE": "Handynummer",
    "HEADER_SKIP_NAVIGATION": "Navigation überspringen",
    "JS_REALLY_DELETE": "Wirklich löschen?",
    "LANDINGPAGE_SHARE_LINK_FB": "Auf Facebook teilen",
    "LANDINGPAGE_SHARE_LINK_GOOGLE": "Auf Google als Lesezeichen speichern",
    "LANDINGPAGE_SHARE_LINK_TWITTER": "Auf Twitter teilen",
    "LANDINGPAGE_SHARE_LINK_XING": "Auf XING teilen",
    "LOGIN_NAVIGATION_LOGIN_ERROR_INVALID": "Wir haben Deine Eingabe gerade leider nicht erkannt. Bitte gib Deine Zugangsdaten zur Sicherheit nochmal ein.",
    "MALT_FOOTER_COPYRIGHT_API": "© {siteoperator} | Alle Rechte vorbehalten",
    "META_DESCRIPTION_ALL": "XING ist Dein Begleiter im Beruf. Entdecke spannende Jobs und hol Dir Unterstützung für Dein Job-Leben.",
    "MONTH_NAMES": "Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember",
    "MYXING_LOADING_ALERT_MESSAGE": "Das hat leider nicht geklappt. Bitte aktualisiere diese Seite noch einmal.",
    "MYXING_NAV_ACTIVITIES": "Reaktionen auf Deine Aktivitäten",
    "MYXING_NAV_APPS": "Apps",
    "MYXING_NAV_BETALABS": "XING Beta Labs",
    "MYXING_NAV_COMPANIES": "Unternehmen",
    "MYXING_NAV_CONTACTS": "Kontakt-Anfragen",
    "MYXING_NAV_CONTACTS_X5": "Kontakte",
    "MYXING_NAV_CONTENT": "Branchen-News",
    "MYXING_NAV_EVENTS": "Events",
    "MYXING_NAV_GROUPS": "Gruppen",
    "MYXING_NAV_JOBS": "Jobs",
    "MYXING_NAV_MESSAGES": "Neue Nachrichten",
    "MYXING_NAV_SETTINGS_TOOLTIP": "Einstellungen, Rechnungen & Konten",
    "MYXING_PREMIUM_COCKPIT_LABEL": "Premium-Cockpit",
    "NAVI_MYOBC": "Neuigkeiten",
    "NAVI_PREMIUM_MEMBERSHIP": "Premium-Mitgliedschaft",
    "NAVI_PREMIUM_PROJOBS_ADDON": "Pro<span>Jobs</span>: Einfach Karriere.",
    "NAVI_PROJOBS_MEMBERSHIP": "ProJobs-Zusatzpaket",
    "NETWORKSHTML_SUB2": "Deine Gruppen",
    "NOTIFICATION_CENTER_LINK": "Mitteilungen",
    "NO_JAVASCRIPT_ERROR": "Bitte <a href=\"https://faq.xing.com/de/node/67946\">aktiviere JavaScript</a>, um XING nutzen zu können.",
    "OPTIONS_DELETE": "Ja, bitte löschen.",
    "PREMIUM_HUB_FEATURES_OFFERS_TITLE_SHORT": "Vorteilsprogramm",
    "PREMIUM_NAVIGATION_OVERVIEW": "Übersicht",
    "PREMIUM_NAVIGATION_PREMIUM": "Premium",
    "PREMIUM_POWERSEARCH_HEADLINE": "Mitglieder entdecken",
    "PREMIUM_POWERSEARCH_NETWORK_CHANGES": "Kontakt-Neuigkeiten",
    "PREMIUM_VOMP_MODULE_HEADLINE": "Profilbesuche",
    "PREMIUM_VOMP_STARTPAGE_LISTITEM_04": "Mitgliedschaft",
    "PROFILERAILS_PROJOBS_BTN_NAME": "ProJobs-Einstellungen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE": "Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT": "Ambassador·innen moderieren die offiziellen XING Gruppen und\norganisieren die offiziellen XING Events. Sie haben dabei einen von drei verschiedenen Schwerpunkten:",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE": "Branchen-Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK": "Branchen-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT": "Branchen-Ambassador·innen sind\nengagierte XING Mitglieder mit einer spezielle Lizenz im\nRahmen unseres Ambassador-Programms. \nSie moderieren jeweils eine große Branchen-Gruppe, verfügen\nüber Fachwissen und Anerkennung in ihrem Fachgebiet\nund unterstützten die Aktivitäten der Mitglieder ihrer Gruppe\nsowohl online als auch durch offizielle Events.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE": "Regional-Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK": "Regional-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT": "Regional-Ambassador·innen sind Markenbotschafter·innen und regionaler Anlaufpunkt für XING Mitglieder und Interessierte. Sie moderieren jeweils eine offizielle Regional-Gruppe, veranstalten regelmäßig Events in ihrer\nRegion und unterstützen den Austausch der Gruppen-Mitglieder untereinander.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE": "Themen-Ambassador·innen ",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK": "Themen-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT": "Dies sind Spezialisten für die moderne\nArbeitswelt. In ihren Gruppen begleiten sie Diskussionen rund\num das Thema \"Arbeit der Zukunft\". Sie organisieren\nVeranstaltungen, in denen es um neue Trends, Erkenntnisse\nund Meinungen zur Arbeitswelt von heute und morgen geht.",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC": "Basis",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP": "Premium kennenlernen",
    "PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR": "Branchen-Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR": "Moderator",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM": "Premium",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP": "Premium-Mitglied",
    "PROFILE_BUSINESS_CARD_BADGE_PROCOACH": "<span>Pro</span>Coach",
    "PROFILE_BUSINESS_CARD_BADGE_PROCOACH_TOOLTIP": "ProCoach-Mitglied",
    "PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR": "Themen-Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT": "Xpert",
    "REMEMBER_PASSWORD": "Eingeloggt bleiben",
    "SE_EXTENDED_SEARCH_LIST_DESCRIPTION": "Erweiterte Suche im Bereich ...",
    "SE_LABEL_JOBS": "Jobs",
    "SE_OFFICIAL_XING_GROUPS": "Offizielle XING Gruppen",
    "SE_PREMIUM_FLAG_ALTTEXT": "Nur für Premium-Mitglieder",
    "SE_SELECT_MEMBERS": "Mitglieder",
    "UPGRADE_HEADER_PREMFIX_NEW": "Jetzt Premium-Mitglied werden! <span>Mehr Infos</span>",
    "UPGRADE_HEADER_PREMFIX_PROJOBS": "ProJobs. Dein direkter Draht zum <span>Wunschjob.</span>",
    "UPGRADE_MYXING_LINK_TEXT": "Premium-Vorteile",
    "UPGRADE_MYXING_LINK_TEXT_PROJOBS": "ProJobs-Vorteile",
    "UPGRADE_MYXING_TESTPREMIUM_ONE_DAY_TOOLTIP": "Deine Test-Premium-Mitgliedschaft läuft morgen ab.",
    "UPGRADE_MYXING_TESTPREMIUM_TODAY_TOOLTIP": "Deine Test-Premium-Mitgliedschaft läuft heute ab.",
    "UPGRADE_MYXING_TESTPREMIUM_TOOLTIP": "Deine Test-Premium-Mitgliedschaft läuft in {.REMAINING_PREMIUM_DAYS} Tagen ab.",
    "VERTICAL_NAVIGATION_BASIC": "Basis",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS": "Business-Lösungen",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT": "Business",
    "VERTICAL_NAVIGATION_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_CONTACTS": "Dein Netzwerk",
    "VERTICAL_NAVIGATION_CONTACTS_SHORT": "Netzwerk",
    "VERTICAL_NAVIGATION_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_EVENTS": "Eventmarkt",
    "VERTICAL_NAVIGATION_EXECUTIVES": "Executive",
    "VERTICAL_NAVIGATION_FOOTER_ABOUT_XING": "Über XING",
    "VERTICAL_NAVIGATION_FOOTER_ADVERTISE": "Werben auf XING",
    "VERTICAL_NAVIGATION_FOOTER_AMIANDO": "Ticketing und Eventvermarktung",
    "VERTICAL_NAVIGATION_FOOTER_ANDROID": "Android",
    "VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN": "Anschreiben-Editor",
    "VERTICAL_NAVIGATION_FOOTER_APPS": "Apps",
    "VERTICAL_NAVIGATION_FOOTER_APP_GALLERY": "Mobile & Desktop Apps",
    "VERTICAL_NAVIGATION_FOOTER_BENEFITS_PLUS_MEMBERSHIP": "Benefits Plus",
    "VERTICAL_NAVIGATION_FOOTER_BEWERBUNG": "Bewerbungsratgeber",
    "VERTICAL_NAVIGATION_FOOTER_BLOG": "Blog",
    "VERTICAL_NAVIGATION_FOOTER_BUSINESS_PAGES": "Business Pages",
    "VERTICAL_NAVIGATION_FOOTER_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_FOOTER_CAREER": "Karriere",
    "VERTICAL_NAVIGATION_FOOTER_COACHES": "Coaches + Trainer",
    "VERTICAL_NAVIGATION_FOOTER_COMMUNITY": "Community",
    "VERTICAL_NAVIGATION_FOOTER_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_COMPANY": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_COPYRIGHT_API": "&copy; {SITEOPERATOR} | Alle Rechte vorbehalten",
    "VERTICAL_NAVIGATION_FOOTER_DATA_PROTECTION": "Datenschutz",
    "VERTICAL_NAVIGATION_FOOTER_DEVBLOG": "Devblog",
    "VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL": "Entwickler",
    "VERTICAL_NAVIGATION_FOOTER_DOWNLOAD": "Downloads",
    "VERTICAL_NAVIGATION_FOOTER_EVENTS": "Events",
    "VERTICAL_NAVIGATION_FOOTER_EXECUTIVES_MEMBERSHIP": "Executive Circles",
    "VERTICAL_NAVIGATION_FOOTER_FUTUREME": "FutureMe",
    "VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH": "Gehaltsvergleich",
    "VERTICAL_NAVIGATION_FOOTER_GROUPS": "Gruppen",
    "VERTICAL_NAVIGATION_FOOTER_HELP": "Hilfe & Kontakt",
    "VERTICAL_NAVIGATION_FOOTER_IMPRINT": "Impressum",
    "VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "VERTICAL_NAVIGATION_FOOTER_INVITE_TO_XING": "Zu XING einladen",
    "VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD": "iPhone & iPad",
    "VERTICAL_NAVIGATION_FOOTER_JOBS": "Karriere bei XING",
    "VERTICAL_NAVIGATION_FOOTER_JOB_MARKET": "Jobs",
    "VERTICAL_NAVIGATION_FOOTER_KUNUNU": "Arbeitgeber-Bewertungen",
    "VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF": "Lebenslauf-Editor",
    "VERTICAL_NAVIGATION_FOOTER_LOGINWXING": "Button \"Mit XING einloggen\"",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS": "Mitgliedschaften",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_AND_PARTNER": "Produkte & Angebote",
    "VERTICAL_NAVIGATION_FOOTER_MOBILE": "XING Apps",
    "VERTICAL_NAVIGATION_FOOTER_MY_NETWORK": "Startseite",
    "VERTICAL_NAVIGATION_FOOTER_NEWWORKSE": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY": "Mitgliederverzeichnis",
    "VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_FOOTER_PRESS": "Presse",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY": "Datenschutz bei XING",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY": "Datenschutzerklärung",
    "VERTICAL_NAVIGATION_FOOTER_PROJECTS": "Projekte",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_UPSELL_BTN": "Zu XING ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_FOOTER_RESOURCES": "Ressourcen",
    "VERTICAL_NAVIGATION_FOOTER_SECURITY": "Sicherheit",
    "VERTICAL_NAVIGATION_FOOTER_SERVICES": "Weitere Angebote",
    "VERTICAL_NAVIGATION_FOOTER_SPIELRAUM": "Themenportal \"spielraum\"",
    "VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER": "Personalgewinnung mit XING",
    "VERTICAL_NAVIGATION_FOOTER_TANDC": "AGB",
    "VERTICAL_NAVIGATION_FOOTER_TOP_DEALS": "Vorteilsprogramm",
    "VERTICAL_NAVIGATION_FOOTER_USEFUL": "Apps & Tools",
    "VERTICAL_NAVIGATION_FOOTER_WINDOWS_10": "Windows 10",
    "VERTICAL_NAVIGATION_FOOTER_XAS": "Werbeanzeige erstellen",
    "VERTICAL_NAVIGATION_FOOTER_XING_AG": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_XING_NEWS": "XING News",
    "VERTICAL_NAVIGATION_FOOTER_XING_SEMINARS": "XING Seminare",
    "VERTICAL_NAVIGATION_FOOTER_XING_SHARE": "Button \"Auf XING teilen\"",
    "VERTICAL_NAVIGATION_FOOTER_YOUR_XING": "Hauptbereiche",
    "VERTICAL_NAVIGATION_HEADER_ADD_CONTACTS": "Neue Kontakte finden",
    "VERTICAL_NAVIGATION_HEADER_BETALABS": "Beta Labs",
    "VERTICAL_NAVIGATION_HEADER_CLAIM": "For a better working life",
    "VERTICAL_NAVIGATION_HEADER_HELP": "Hilfe",
    "VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS": "Stellenanzeigen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS": "AdManager",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_BENEFITS_PLUS_MEMBERSHIP": "Benefits Plus",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE": "Coach-Profil",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES": "Rechnungen & Konten",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT": "Ausloggen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_DASHBOARD": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS": "ProJobs-Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SALES": "Sales-Übersicht",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS": "Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS_INVOICES": "Einstellungen, Rechnungen & Konten",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_BENEFITSPLUS": "Benefits Plus - <span> Dein Plus an echten Benefits</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_EVENTS_BLOCKBUSTER": "Premium Event Blockbuster, die Dich <span>weiterbringen</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_EXECUTIVES": "Jetzt Executive-Status sichern! <span>Mehr Infos</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_NEW": "Jetzt Premium-Mitglied werden! <span>Mehr Infos</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROBUSINESS": "ProBusiness – <span>Ihr smarter Netzwerk-Assistent.</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROCOACH": "ProCoach – <span>Ihr Wegbegleiter zu mehr Erfolg</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROJOBS": "ProJobs. Dein direkter Draht <span>zum Wunschjob.</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROTRAINER": "ProTrainer – <span>Ihr Wegbegleiter zu mehr Erfolg</span>",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ADVANCED": "Erweiterte Suche",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ADVANCED_DESCRIPTION": "Erweiterte Suche im Bereich ...",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON": "Suchen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE": "Arbeitgeber",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS": "Events",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_FOR": "Alle Ergebnisse für",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS": "Mitglieder",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS": "Branchen-News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER": "Job, Namen oder Stichwort eingeben",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PREMIUM_FLAG": "PREMIUM",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_QUERY_SUGGESTIONS_JOBS": "Alle \"{keywords}\"-Jobs",
    "VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN": "LizenzManager",
    "VERTICAL_NAVIGATION_HEADER_SLOGAN": "XING – For a better working life",
    "VERTICAL_NAVIGATION_HEADER_XTM": "TalentManager",
    "VERTICAL_NAVIGATION_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_MESSAGES": "Nachrichten",
    "VERTICAL_NAVIGATION_MYPROEXECUTIVES": "Executive",
    "VERTICAL_NAVIGATION_MYPROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_MY_PROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_MY_PROJOBS_SETTINGS": "Einstellungen",
    "VERTICAL_NAVIGATION_NEW": "NEU",
    "VERTICAL_NAVIGATION_OTHER_SERVICES": "Weitere Services",
    "VERTICAL_NAVIGATION_PREMIUM": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_ARAG_SUBLINE": "NEU: XING Arbeitsrechtsschutz",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_ARAG_TOOLTIP": "XING Arbeitsrechtsschutz",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER": "Premium werden",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SUBLINE": "Premium-Mitglied werden!",
    "VERTICAL_NAVIGATION_PREMIUM_HUB": "Premium",
    "VERTICAL_NAVIGATION_PROBUSINESS": "ProBusiness",
    "VERTICAL_NAVIGATION_PROCOACH": "<span>Pro</span>Coach",
    "VERTICAL_NAVIGATION_PROFILE": "Mein Profil",
    "VERTICAL_NAVIGATION_PROJECTS": "Projekte",
    "VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER": "ProJobs werden",
    "VERTICAL_NAVIGATION_STARTPAGE": "Startseite",
    "VIEW_PAGE_IN_CHINESE": "Diese Seite auf Chinesisch anzeigen",
    "VIEW_PAGE_IN_DUTCH": "Diese Seite auf Niederländisch anzeigen",
    "VIEW_PAGE_IN_ENGLISH": "Diese Seite auf Englisch anzeigen",
    "VIEW_PAGE_IN_FINNISH": "Diese Seite auf Finnisch anzeigen",
    "VIEW_PAGE_IN_FRENCH": "Diese Seite auf Französisch anzeigen",
    "VIEW_PAGE_IN_GERMAN": "Diese Seite auf Deutsch anzeigen",
    "VIEW_PAGE_IN_HUNGARIAN": "Diese Seite auf Ungarisch anzeigen",
    "VIEW_PAGE_IN_ITALIAN": "Diese Seite auf Italienisch anzeigen",
    "VIEW_PAGE_IN_JAPANESE": "Diese Seite auf Japanisch anzeigen",
    "VIEW_PAGE_IN_KOREAN": "Diese Seite auf Koreanisch anzeigen",
    "VIEW_PAGE_IN_POLISH": "Diese Seite auf Polnisch anzeigen",
    "VIEW_PAGE_IN_PORTUGUESE": "Diese Seite auf Portugiesisch anzeigen",
    "VIEW_PAGE_IN_RUSSIAN": "Diese Seite auf Russisch anzeigen",
    "VIEW_PAGE_IN_SPANISH": "Diese Seite auf Spanisch anzeigen",
    "VIEW_PAGE_IN_SWEDISH": "Diese Seite auf Schwedisch anzeigen",
    "VIEW_PAGE_IN_TURKISH": "Diese Seite auf Türkisch anzeigen",
    "WELCOME_BOX_LINK_PROFILE": "Profil",
    "XBP_NAVIGATION_ENTRY_LINK": "Business Pages verwalten",
    "XE_404_FIRST_P": "Schau doch einmal in unseren <a href=\"/help/\">Hilfebereich</a> &ndash; dort findest Du alle wichtigen Infos zu den verschiedenen Bereichen auf XING und Antworten auf viele Fragen.",
    "XE_404_H_1": "Diese Seite haben wir leider nicht gefunden.",
    "XE_404_SEARCHTEXT_LOGGED_IN": "Suchst Du Mitglieder, Jobs, Events, Gruppen oder Unternehmen? Dann such einfach hier:",
    "XE_404_SEARCHTEXT_LOGGED_OUT": "Suchst Du Leute aus der Arbeit, Deinem Freundeskreis oder Deinem Geschäftsumfeld? Dann such einfach hier:",
    "XE_404_TITLE": "Unbekannte Seite (404-Fehler)",
    "XE_CALENDAR_BACK_LINK": "zurück",
    "XE_CALENDAR_NEXT_LINK": "vor",
    "XE_CALENDAR_SELECTION": "Auswahl",
    "XE_CALENDAR_TODAY": "Heute",
    "XE_CLOSE_LINK": "Schließen",
    "XE_NEW": "NEU",
    "XE_NOT_A_XING_MEMBER_YET": "Noch kein XING Mitglied?",
    "XE_PAGER_BACK": "Zurück",
    "XE_PAGER_NEXT": "Weiter",
    "XE_SIGN_UP_FOR_FREE": "Jetzt kostenlos registrieren!",
    "XING_SLOGAN": "XING – For a better working life",
    "X_UI_BUTTON_FIND": "Suchen",
    "X_UI_FOOTER_COPYRIGHT_API": "&copy; {-SITEOPERATOR} | Alle Rechte vorbehalten",
    "X_UI_HEADER_ADVANCED_SEARCH": "Erweiterte Suche",
    "X_UI_HEADER_ADVANCED_SEARCH2": "Erweiterte Suche",
    "X_UI_HEADER_DOWNLOAD": "Downloads",
    "X_UI_HEADER_HELP": "Hilfe & Kontakt",
    "X_UI_HEADER_INVITELINK": "Andere zu XING einladen",
    "X_UI_HEADER_LOGOUT": "Ausloggen",
    "X_UI_HEADER_REGISTER": "Registrieren",
    "X_UI_HEADER_SEARCH_HINT": "Name, Firma oder andere Suchwörter",
    "X_UI_HEADER_XING_SHARE": "XING Share-Button",
    "X_UI_NAVIGATION_ADDRESSBOOK": "Kontakte",
    "X_UI_NAVIGATION_ADMASTER": "Werbeanzeigen verwalten",
    "X_UI_NAVIGATION_BOOKMARK": "Lesezeichen",
    "X_UI_NAVIGATION_COMPANIES": "Unternehmen",
    "X_UI_NAVIGATION_COMPANIES_SUB_BEST_OFFERS": "Vorteilsprogramm",
    "X_UI_NAVIGATION_COMPANIES_SUB_CREATE": "Unternehmensprofil anlegen",
    "X_UI_NAVIGATION_COMPANIES_SUB_MY_COMPANIES": "Deine Unternehmen",
    "X_UI_NAVIGATION_COMPANIES_SUB_OVERVIEW": "Übersicht",
    "X_UI_NAVIGATION_CONTENT": "News",
    "X_UI_NAVIGATION_CONTENT_BOOKMARKS": "Merkliste",
    "X_UI_NAVIGATION_CONTENT_OVERVIEW": "Branchen-News",
    "X_UI_NAVIGATION_CONTENT_PAGES": "News-Seiten",
    "X_UI_NAVIGATION_EVENTS": "Events",
    "X_UI_NAVIGATION_EVENTS2": "Events",
    "X_UI_NAVIGATION_EVENTS2_SUB_MY": "Deine Events",
    "X_UI_NAVIGATION_EVENTS2_SUB_NEW": "Event organisieren",
    "X_UI_NAVIGATION_EXPAND_NETWORK": "Netzwerk erweitern",
    "X_UI_NAVIGATION_FIND_EVENTS": "Übersicht",
    "X_UI_NAVIGATION_GROUPS": "Gruppen",
    "X_UI_NAVIGATION_JOBS": "Jobs",
    "X_UI_NAVIGATION_LOGIN_ERROR_CONNECTION": "Leider gibt's Verbindungsprobleme. Versuch's bitte nochmal.",
    "X_UI_NAVIGATION_LOGIN_ERROR_INVALID": "Diese Zugangsdaten sind leider nicht korrekt ... vielleicht vertippt?",
    "X_UI_NAVIGATION_MARKETPLACE_MANAGE": "Stellenanzeigen verwalten",
    "X_UI_NAVIGATION_MARKETPLACE_NEWPOSTING": "Stellenanzeige einstellen",
    "X_UI_NAVIGATION_MARKETPLACE_OVERVIEW": "Übersicht Stellenangebote",
    "X_UI_NAVIGATION_MY_MESSAGES": "Postfach",
    "X_UI_NAVIGATION_MY_NETWORK": "Startseite",
    "X_UI_NAVIGATION_PROJECTS": "Projekte",
    "X_UI_NAVIGATION_RECRUITER_ACCOUNT": "Kandidatenübersicht",
    "X_UI_NAVIGATION_SALES_ACCOUNT": "Sales-Übersicht",
    "X_UI_NAVIGATION_TALENT_MANAGER": "TalentManager",
    "ACTION_BLOCK_USER": "Blockieren",
    "ACTION_BLOCK_USER_DIALOG_DESCRIPTION": "Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.",
    "ACTION_BLOCK_USER_DIALOG_TITLE": "Möchtest Du Dein Profil für dieses Mitglied blockieren?",
    "ACTION_BLOCK_USER_SUCCESS": "Mitglied blockiert",
    "ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT": "Austausch",
    "BREWERY_NOCOOKIES_LINK_TARGET": "https://faq.xing.com/de/sicherheit/was-sind-cookies-und-warum-brauche-ich-sie-beim-einloggen",
    "BREWERY_NOCOOKIES_LINK_TEXT": "Cookies aktivieren",
    "BREWERY_NOCOOKIES_PARAGRAPH": "Denn nur mit aktivierten Cookies funktioniert das Einloggen. Hier erfährst Du, wie's geht: ",
    "BREWERY_NOCOOKIES_TITLE": "Bitte aktiviere die Cookies.",
    "BREWERY_NOJAVASCRIPT_LINK_TARGET": "https://faq.xing.com/de/einstellungen/javascript-meinem-browser-aktivieren",
    "BREWERY_NOJAVASCRIPT_LINK_TEXT": "JavaScript aktivieren",
    "BREWERY_NOJAVASCRIPT_PARAGRAPH": "Aktivier bitte JavaScript, denn nur so siehst Du alle unsere Inhalte. Hier erfährst Du, wie's geht:",
    "BREWERY_NOJAVASCRIPT_TITLE": "Bitte aktiviere JavaScript.",
    "BUTTON_CLOSE": "Schließen",
    "BUTTON_FORWARD": "Weiter",
    "CB_POSTING_ERROR": "Das hat leider nicht geklappt. Bitte versuch es noch einmal.",
    "COMMBOX_ACTOR_SWITCH_CANCEL": "Absender beibehalten",
    "COMMBOX_ACTOR_SWITCH_CONFIRM": "Absender ändern",
    "COMMBOX_ACTOR_SWITCH_HEADLINE": "Wer soll der Absender dieses Beitrags sein?",
    "COMMBOX_ACTOR_SWITCH_HINT": "Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE": "Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO": "Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.",
    "COMMBOX_ACTOR_SWITCH_TYPE_PAGE": "Eine Seite",
    "COMMBOX_ACTOR_SWITCH_TYPE_USER": "Eine Person",
    "COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER": "1 Bild kannst Du noch hinzufügen.",
    "COMMBOX_AUDIENCE_CITY_CONTACTS": "Nur Kontakte in meinem Arbeitsort ({totalCount})",
    "COMMBOX_AUDIENCE_FOLLOWERS": "Nur Follower",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS": "Follower & Kontakte",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC": "Dein Beitrag kann geteilt werden.",
    "COMMBOX_AUDIENCE_FOLLOWERS_DESC": "Dein Beitrag kann geteilt werden.",
    "COMMBOX_AUDIENCE_HEADLINE": "Wer darf das sehen?",
    "COMMBOX_AUDIENCE_PRIVATE": "Privat (nur XING Kontakte)",
    "COMMBOX_AUDIENCE_PRIVATE_DESC": "Dein Beitrag kann nicht geteilt werden.",
    "COMMBOX_AUDIENCE_PRIVATE_SELECTED": "Privat",
    "COMMBOX_AUDIENCE_PUBLIC": "Öffentlich",
    "COMMBOX_AUDIENCE_PUBLIC_DESC": "Jeder kann Deinen Beitrag sehen und teilen.",
    "COMMBOX_BUTTON_ADD_VIDEO_LABEL": "Video hinzufügen",
    "COMMBOX_BUTTON_OPEN_FILES_LABEL": "Dokument hinzufügen",
    "COMMBOX_BUTTON_OPEN_POLL_LABEL": "Umfrage starten",
    "COMMBOX_CANCEL_POSTING_BUTTON_BACK": "Weiter bearbeiten",
    "COMMBOX_CANCEL_POSTING_BUTTON_CANCEL": "Beitrag verwerfen",
    "COMMBOX_CANCEL_POSTING_HEADLINE": "Möchtest Du den Beitrag verwerfen?",
    "COMMBOX_CANCEL_POSTING_TEXT_MESSAGE": "Deine Eingaben gehen dann verloren.",
    "COMMBOX_CHARACTERS_LEFT": "übrig",
    "COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT": "Bilder auswählen",
    "COMMBOX_EMPTY_DROPZONE_TEXT": "JPG, BMG oder PNG (max. {max_size} MB pro Bild)",
    "COMMBOX_EMPTY_DROPZONE_TITLE": "Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.",
    "COMMBOX_EMPTY_TEXT_FIELD": "Teil ein Foto, einen Link oder schreib was …",
    "COMMBOX_EMPTY_TEXT_FIELD_MENTIONS": "Teil ein Foto, einen Link oder einen Gedanken (mit \"@\" andere erwähnen) ...",
    "COMMBOX_ENTRY_POINT_LABEL": "Eingabefeld für Deinen Beitrag",
    "COMMBOX_ENTRY_POINT_TEXT": "Was gibt’s Neues?",
    "COMMBOX_FILLED_DROPZONE_HEADER": "{pictures} Bilder kannst Du noch hinzufügen.",
    "COMMBOX_FULL_FILLED_DROPZONE_HEADER": "Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.",
    "COMMBOX_IMAGE_SIZE_UPLOAD_ERROR": "Bitte wähle ein Bild, das max. 10 MB groß ist.",
    "COMMBOX_IMAGE_TYPE_UPLOAD_ERROR": "Bitte wähle ein Bild im JPG- oder PNG-Format.",
    "COMMBOX_POST": "Teilen",
    "COMMBOX_SUCCESS_ACTION": "Beitrag ansehen",
    "COMMBOX_SUCCESS_DESC": "Dein Beitrag wurde auf XING geteilt.",
    "COMMBOX_SUCCESS_HEADLINE": "Und fertig!",
    "COMMBOX_SUCCESS_SCHEDULED_DESC": "Dein Beitrag wird am {date} um {time} Uhr geteilt.",
    "COMMBOX_UPDATE_BTN": "Speichern",
    "COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED": "Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.",
    "COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE": "Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.",
    "COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR": "Das hat leider nicht geklappt – einfach gleich nochmal versuchen!",
    "COMMBOX_VIEW_POST_BTN": "Beitrag ansehen",
    "COMMENT_BUTTON_LABEL": "Kommentieren",
    "CONTENT_ERROR_404_BUTTON": "Zur XING Startseite",
    "CONTENT_ERROR_404_HEADLINE": "Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.",
    "CONTENT_ERROR_404_SUBLINE": "Aber hier gibt's garantiert etwas zu entdecken:",
    "CONTENT_ERROR_503_HEADLINE": "Sieht so aus, als hätten wir gerade ein kleines Problem.",
    "CONTENT_ERROR_503_SUBLINE": "Bitte hab einen Moment Geduld. Wir arbeiten daran.",
    "CONTENT_ERROR_OFFLINE": "Bitte prüfe Deine Internet-Verbindung. Versuch's dann einfach noch einmal.",
    "CONTENT_FOLLOW": "Folgen",
    "CONTENT_FOLLOWED": "Folgst Du",
    "CONTENT_SWITCHER_MORE": "Mehr",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG": "{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT": "{minutesCount, plural,\n   =1 {Jetzt}\n   other {# Min.}\n}",
    "CONTENT_TIMESTAMP_DAYS": "Tage",
    "CONTENT_TIMESTAMP_DAYS_AGO_LONG": "{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}",
    "CONTENT_TIMESTAMP_DAYS_AGO_SHORT": "{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {# Tage}\n}",
    "CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO": "Gerade eben",
    "CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG": "{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}",
    "CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT": "{hoursCount, plural,\n   =1 {1 Std.}\n   other {# Std.}\n}",
    "CONTENT_TIMESTAMP_TODAY": "Heute",
    "CONTENT_UNFOLLOW": "Nicht mehr folgen",
    "CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER": "Geben Sie hier den Titel Ihres Videos ein.",
    "CONTENT_VIDEO_RECOS_REASON": "Beliebte Videos auf XING",
    "CROSSPOST_SHARE_ERROR": "Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.",
    "DAY_NAMES": "Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag,Sonntag",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM": "Ja, deaktivieren",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE": "@-Erwähnung deaktivieren?",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT": "Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES": "Ein Unternehmen",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS": "Ein Event",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS": "Eine Gruppe",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS": "Einen Job",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS": "Eine Person",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS": "Einen Artikel",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS": "Ein Thema",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS": "Entdecke {keyword}-Jobs.",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT": "{keyword}-Jobs entdecken",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH": "Suchvorschläge",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS": "Was suchst Du?",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION": "Suchvorschläge",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS": "Profile, die Du besucht hast",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES": "Deine letzten Job-Suchen",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION": "Empfehlungen",
    "DUPLICATE_SHARE_ERROR": "Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.",
    "FRAME_NAVIGATION_DISCO": "Entdecken",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE": " Was denkst Du über die neue App?",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Dein Feedback",
    "FRAME_NAVIGATION_JOBS": "Jobs",
    "FRAME_NAVIGATION_ME_HUB": "Deins",
    "FRAME_NAVIGATION_NETWORKING_ICON_TEXT": "Netzwerken",
    "FRAME_NAVIGATION_SUPI": "Start",
    "FRAME_NAVIGATION_UPSELL_HEADLINE": "Angebote für Dich",
    "INSIDER_FOLLOWED_BY": "Abonniert von",
    "INSIDER_FOLLOWED_BY_AND": "und",
    "INSIDER_FOLLOWED_BY_AND_MORE": "weiteren",
    "JOB_SEARCH_ALERTS_ALERT_NAME_ALL": "Alle Jobs",
    "LIKERS_LIST_HEADLINE": "Diesen Mitgliedern gefällt das:",
    "LIKE_BUTTON_LABEL": "Gefällt mir",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE": "Die Datei \"{filesTooBig}\" ist leider zu groß: Bis zu {maxSize} MB sind erlaubt.",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL": "Du kannst Dateien von bis zu {maxSize} MB hochladen. Diese Dateien sind daher leider zu groß: {filesTooBig}",
    "MALT_FILE_UPLOAD_NO_FILE": "Noch keine Datei ausgewählt",
    "MALT_FILE_UPLOAD_NUMBER_OF_FILES": "{numberOfFiles} Dateien",
    "MALT_IMAGE_UPLOAD_BROWSE_BUTTON": "Datei auswählen",
    "MALT_TEST_RUBY_STYLE_TRANSLATION": "Mein Name ist {name}.",
    "MESSENGER_SHARE_COMMENT_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL": "Empfänger:",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER": "Empfänger eingeben",
    "MESSENGER_SHARE_TARGET_LABEL": "Deine Nachricht:",
    "MONTH_NAMES_SHORT": "Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez",
    "NBA_BUTTON_CANCEL": "Abbrechen",
    "NBA_BUTTON_CHANGE_IMAGE": "Bild ändern",
    "NBA_BUTTON_CONTINUE": "Weiter",
    "NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT": "Ein gutes Profilbild unterstreicht Dein professionelles Auftreten und erhöht die Anzahl Deiner Profilbesuche.",
    "NBA_CREATE_PHOTO_CARD_GENERIC_ERROR": "Das hat leider nicht geklappt – kannst Du's nochmal versuchen?",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE": "Bitte wähl eines dieser Bildformate: JPG, PNG oder BMP",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE": "Bitte wähl ein Bild mit weniger als 20 MB Dateigröße.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX": "Max.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN": "Min.",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE": "Profilbild",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES": "Empfohlene Auflösung: 1024 x 1024 px",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES": "JPG, BMP, PNG (max. 20 MB)",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK": "Bild hochladen",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP": "Bild hierhin ziehen",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR": "oder",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT": "Du kannst dieses Bild jederzeit in Deiner Visitenkarte ändern.",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE": "Prima, Du hast nun ein neues Profilbild!",
    "POLLS_TIME_REMAINING_DAYS_WEB.one": "Endet morgen",
    "POLLS_TIME_REMAINING_DAYS_WEB.other": "Endet in {days} Tagen",
    "POLLS_TIME_REMAINING_DAYS_WEB.zero": "Endet heute",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY": "Schau Dir alle Event-Teilnehmenden direkt in ProBusiness an, verfeinere die Liste mit zahlreichen Filtern und speicher relevante Leads gleich ab.",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON": "Teilnahmeliste in ProBusiness ansehen",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE": "Du möchtest Leads aufgabeln?",
    "PROBUSINESS_BANNER_SEARCH_BODY": "Sieh Dir diese Ergebnisse direkt in ProBusiness an, nutz die effizienten Filtermöglichkeiten und speicher gefundene Kontakte gleich als relevante Leads ab.",
    "PROBUSINESS_BANNER_SEARCH_BUTTON": "Ergebnisse in ProBusiness anzeigen",
    "PROBUSINESS_BANNER_SEARCH_HEADLINE": "Vertriebsgeheimnis: Verfeinere Deine Ergebnisse!",
    "PROBUSINESS_DROPDOWN_SHOW_RESULT": "In ProBusiness ansehen",
    "PROBUSINESS_NO_STATUS_AVAILABLE": "Lead-Status derzeit unbekannt",
    "PROBUSINESS_SAVE_AS_LEAD": "Lead merken",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB": "Moderator·innen und ausgewiesene Fachleute ihrer Branche",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB": "Offizieller Event-Veranstalter und Vertrauensperson vor Ort",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB": "Expert·innen für Themen rund um die moderne Arbeitswelt",
    "PROFILE_BADGES_LAYER_MODERATOR_SUB": "Ansprechperson und Konfliktlöser einer Gruppe",
    "PROFILE_BADGES_LAYER_PREMIUM_LINK": "Alle Premium-Vorteile im Überblick",
    "PROFILE_BADGES_LAYER_PREMIUM_SUB": "Hilfreiche Zusatzfunktionen für Beruf, Karriere und Geschäft",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT": "Was ist ein Ambassador?",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT": "Was ist ein Moderator?",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT": "Welche Vorteile hat die<br>Premium-Mitgliedschaft?",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT": "Was ist ein Xpert?",
    "PROGRESS_BAR_LOADING_PERCENTAGE": "{percentage} % hochgeladen",
    "SEARCH_TOPICS_TAB_SEARCH_BUTTON": "Suchen",
    "SEARCH_TOPICS_TAB_TITLE": "Themen",
    "SE_ALL_VIEW_SEARCH_RESULTS": "{max} Ergebnisse (von {total})",
    "SE_FILTER_JOBS_PROJOB_LABEL": "Jobs von Top-Recruitern",
    "SE_JOBS_SUGGESTED_NAME_LOCATION": "Jobs in {location}",
    "SE_LABEL_COMMUNITIES": "Gruppen",
    "SE_LABEL_COMPANIES": "Unternehmen",
    "SE_LABEL_EVENTS": "Events",
    "SE_LABEL_MEMBERS": "Mitglieder",
    "SE_LABEL_NEWS": "News",
    "SE_SHOW_ALL_RESULTS": "Alle Ergebnisse",
    "SHARERS_BACK_TO_POST_LINK": "Zurück",
    "SHARERS_LIST_BACK_LINK": "Zurück",
    "SHARER_LIST_HEADLINE_MEMBERS": "{total} Mitglieder haben dies geteilt.",
    "SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS": "{total} Mitglieder haben dies geteilt.",
    "SHARER_LIST_HEADLINE_ONE_MEMBER": "Ein Mitglied hat dies geteilt.",
    "SHARER_LIST_ITEM_GO_TO_POST_LINK": "Beitrag ansehen",
    "SHARER_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.",
    "SHARE_ACTIONSHEET_HEADER": "Diesen Beitrag teilen",
    "SHARE_BOX_DEFAULT_ERROR_MESSAGE": "Das hat leider nicht geklappt. Bitte versuch es noch einmal.",
    "SHARE_BOX_HEADER": "Auf XING teilen",
    "SHARE_BOX_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "SHARE_BOX_SHARE_SUCCESS": "Vielen Dank fürs Teilen!",
    "SHARE_BOX_SUBMIT_SHARE": "Teilen",
    "SHARE_BUTTON_LABEL": "Teilen",
    "SHARE_CANCEL_BUTTON": "Abbrechen",
    "SHARE_CHAT_CONTACTS": "Kontakt auswählen",
    "SHARE_CHAT_HINT": "Die Empfänger erhalten einzelne Nachrichten.",
    "SHARE_COUNTER_LABEL": "{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}",
    "SHARE_FEEDBACK_GROUPS_BUTTON": "Beitrag ansehen",
    "SHARE_FEEDBACK_GROUPS_MESSAGE": "{item} in der Gruppe {group} geteilt",
    "SHARE_FEEDBACK_INSIDERARTICLE_LABEL": "Artikel",
    "SHARE_FEEDBACK_JOB_LABEL": "Job",
    "SHARE_FEEDBACK_KLARTEXT_LABEL": "Beitrag",
    "SHARE_FEEDBACK_LINK_LABEL": "Link",
    "SHARE_FEEDBACK_MESSENGER_BUTTON": "Nachricht ansehen",
    "SHARE_FEEDBACK_MESSENGER_MESSAGE": "{item} per XING Nachricht geteilt",
    "SHARE_FEEDBACK_NEWS_LABEL": "Artikel",
    "SHARE_FEEDBACK_PICTURE_LABEL": "Bild",
    "SHARE_FEEDBACK_POST_LABEL": "Beitrag",
    "SHARE_FEEDBACK_STARTPAGE_BUTTON": "Beitrag ansehen",
    "SHARE_FEEDBACK_STARTPAGE_MESSAGE": "{item} auf der Startseite geteilt",
    "SHARE_FEEDBACK_VIDEO_LABEL": "Video",
    "SHARE_FETCH_ERROR": "Das hat leider nicht geklappt.",
    "SHARE_FETCH_ERROR_COUNTDOWN": "Wir versuchen's in {countdown} Sekunden noch einmal.",
    "SHARE_FETCH_ERROR_RETRY": "Jetzt erneut versuchen",
    "SHARE_MOST_RECENT_CHATS": "Unterhaltungen",
    "SHARE_PREVIEW_ERROR_HEADLINE": "Wir können gerade leider keine Vorschau zeigen.",
    "SHARE_QUICKSHARE_TO_STARTPAGE": "Direkt auf der Startseite",
    "SHARE_TEXT_BOX_LENGTH_ERROR": "{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}",
    "SHARE_TO_GROUPS": "In einer Gruppe",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS": "Forum",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS": "Gruppe",
    "SHARE_TO_GROUPS_SELECTION_LABEL": "Gruppe auswählen:",
    "SHARE_TO_GROUPS_TEXT_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "SHARE_TO_GROUPS_THREAD_LABEL": "Dein Gruppen-Beitrag:",
    "SHARE_TO_GROUPS_TITLE_PLACEHOLDER": "Beitragstitel",
    "SHARE_TO_MESSENGER": "Als private Nachricht",
    "SHARE_TO_MESSENGER_EMPTY_STATE": "Wir haben leider keinen \"{query}\" gefunden.",
    "SHARE_TO_STARTPAGE": "Mit Anmerkung auf der Startseite",
    "SHARE_USER_SUBTEXT_GROUPS": "In einer Gruppe teilen",
    "SHARE_USER_SUBTEXT_MESSAGE": "Als private Nachricht teilen",
    "SHARE_USER_SUBTEXT_STARTPAGE": "Auf der Startseite teilen",
    "SOCIAL_ADD_CONTACT": "Kontakt-Anfrage senden",
    "SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION": "Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.",
    "SOCIAL_BAR_VIEW_COUNTER_HEADING": "Wie oft wurde Dein Beitrag auf XING gesehen?",
    "SOCIAL_BAR_VIEW_COUNTER_SEEN": "Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.",
    "SOCIAL_BAR_VIEW_COUNTER_TIP": "<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.",
    "SOCIAL_COMMENTS_COUNTER_LABEL": "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    "SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER": "Etwas schreiben (andere mit \"@\" erwähnen) …",
    "SOCIAL_COMMENTS_CREATE_PLACEHOLDER": "Schreibe einen Kommentar …",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL": "Abbrechen",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM": "Löschen",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT": "Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.",
    "SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE": "Kommentar löschen?",
    "SOCIAL_COMMENTS_DELETE_DIALOG_TEXT": "Dies kann nicht mehr rückgängig gemacht werden.",
    "SOCIAL_COMMENTS_DELETE_MENTION_LABEL": "Nicht erwähnt werden",
    "SOCIAL_COMMENTS_FORM_PLACEHOLDER": "Etwas schreiben ( mit \"@\" erwähnen) …",
    "SOCIAL_COMMENTS_LOAD_MORE": "Weitere Kommentare",
    "SOCIAL_COMMENTS_PREVIOUS_COMMENTS": "Vorherige Kommentare ansehen",
    "SOCIAL_COMMENTS_PREVIOUS_REPLIES": "Vorherige Antworten ansehen",
    "SOCIAL_COMMENTS_REPLY_PLACEHOLDER": "Deine Antwort an {authorName}",
    "SOCIAL_COMMENT_BUTTON_LABEL": "Kommentieren",
    "SOCIAL_COMMENT_COUNTER_LABEL": "{amount} Kommentare",
    "SOCIAL_COMMENT_CREATE_BUTTON_LABEL": "Kommentieren",
    "SOCIAL_COMMENT_DELETED_MESSAGE": "Dieser Kommentar wurde gelöscht.",
    "SOCIAL_COMMENT_DELETE_LABEL": "Kommentar löschen",
    "SOCIAL_COMMENT_EDIT_LABEL": "Kommentar bearbeiten",
    "SOCIAL_COMMENT_ERROR_TOO_LARGE": "Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.",
    "SOCIAL_COMMENT_LIST_EMPTY_HEADLINE": "Und was meinst Du dazu?",
    "SOCIAL_COMMENT_LIST_EMPTY_SUBLINE": "Verrate uns Deine Meinung.",
    "SOCIAL_COMMENT_OVERFLOW_ERROR": "{amount} Zeichen",
    "SOCIAL_COMMENT_REPORT_LABEL": "Kommentar melden",
    "SOCIAL_COMMENT_WAS_EDITED": "Bearbeitet",
    "SOCIAL_GENERIC_REPORT": "Melden",
    "SOCIAL_LIKERS_LIST_HEADLINE": "Diesen Mitgliedern gefällt das:",
    "SOCIAL_LIKERS_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle \"Gefällt mir\"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.",
    "SOCIAL_PMBX_COMMENT_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_COMMENT_DATE": "Datum",
    "SOCIAL_PMBX_COMMENT_HEADING": "Deine Kommentare und Antworten",
    "SOCIAL_PMBX_COMMENT_MESSAGE": "Dein Kommentar",
    "SOCIAL_PMBX_COMMENT_ORIGIN": "Wo hast Du kommentiert?",
    "SOCIAL_PMBX_COMMENT_TITLE": "Deine Kommentare und Antworten",
    "SOCIAL_PMBX_COMMENT_USER_AGENT": "System-Info",
    "SOCIAL_PMBX_DESCRIPTION": "Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit \"Gefällt mir\" markiert hast",
    "SOCIAL_PMBX_REACTION_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_REACTION_DATE": "Datum",
    "SOCIAL_PMBX_REACTION_LIKE": "Beiträge, die Dir gefallen.",
    "SOCIAL_PMBX_REACTION_ORIGIN": "Wo hast Du auf den Beitrag reagiert?",
    "SOCIAL_PMBX_REACTION_TITLE": "Beiträge, auf die Du reagiert hast",
    "SOCIAL_PMBX_REACTION_USER_AGENT": "User Agent",
    "SOCIAL_PMBX_SHARE_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_SHARE_DATE": "Datum",
    "SOCIAL_PMBX_SHARE_GROUPS": "Beiträge, die Du in einer Gruppe geteilt hast",
    "SOCIAL_PMBX_SHARE_MESSAGE": "Deine Anmerkung",
    "SOCIAL_PMBX_SHARE_MESSENGER": "Beiträge, die Du als private Nachricht geteilt hast",
    "SOCIAL_PMBX_SHARE_ORIGIN": "Wo hast Du den Beitrag geteilt?",
    "SOCIAL_PMBX_SHARE_STARTPAGE": "Beiträge, die Du auf der XING Startseite geteilt hast",
    "SOCIAL_PMBX_SHARE_TITLE": "Beiträge, die Du geteilt hast",
    "SOCIAL_PMBX_SHARE_USER_AGENT": "User Agent",
    "SOCIAL_PMBX_TITLE": "Interaktionen",
    "SOCIAL_REPLIES_LOAD_MORE": "Weitere Antworten ansehen",
    "SOCIAL_REPLY_BUTTON": "Antworten",
    "SOCIAL_REPLY_DISCARD_MESSAGE": "Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.",
    "SOCIAL_REPLY_LOAD_MORE": "Weitere Antwort ansehen",
    "SOCIAL_REPLY_LOAD_MULTIPLE": "Weitere Kommentare ansehen",
    "SOCIAL_REPLY_POST_BUTTON": "Antworten",
    "SOCIAL_SEND_MESSAGE": "Nachricht schreiben",
    "SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS": "Diese Mitglieder haben das geteilt:",
    "SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK": "Beitrag ansehen",
    "SOCIAL_SHARERS_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.",
    "SOCIAL_SHARE_COUNTER_LABEL": "{amount}-mal geteilt",
    "SOCIAL_SHARE_EXTERNAL_LINK_ERROR": "Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.",
    "SOCIAL_SHOW_MORE": "Weiterlesen",
    "SOCIAL_SOCIAL_PROOF_LABEL": "{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}",
    "SOCIAL_UPDATE_COMMENT_LABEL": "Speichern",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL": "Zurück",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM": "Zurück zu {section}",
    "TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE": "Profil",
    "UNIVERSAL_CAREER_LEVEL_LIST": "1. Student·in / Praktikant·in\n2. Berufseinsteiger·in\n3. Mit Berufserfahrung\n4. Manager (mit und ohne Personalverantwortung)\n5. Direktor·in (z. B. Bereichsleitung, VP, SVP)\n6. Geschäftsführer·in (z. B. GF, CEO)",
    "UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST": "1001. Analyse und Statistik\n1002. Administration, Sachbearbeitung und Verwaltung\n1003. Beratung / Consulting\n4. Controlling und Planung\n1004. Customer Service und Kundenbetreuung\n1005. Einkauf, Materialwirtschaft und Logistik\n1006. Finanzen, Rechnungswesen und Controlling\n1007. Forschung, Lehre und Entwicklung\n1008. Gesundheit, Medizin und Soziales\n1009. Grafik, Design und Architektur\n1010. Ingenieurwesen und technische Berufe\n1011. IT und Softwareentwicklung\n1012. Management und Unternehmensentwicklung\n1013. Marketing und Werbung\n1014. Personalwesen und HR\n1015. PR, Öffentlichkeitsarbeit und Journalismus\n1016. Produktion und Handwerk\n1017. Produktmanagement\n1018. Projektmanagement\n1019. Prozessplanung und Qualitätssicherung\n1020. Recht\n1021. Vertrieb und Handel\n1022. Sonstige Tätigkeitsfelder",
    "UPLOADER_ADD_IMAGE": "Bild hinzufügen",
    "UPLOADER_ADD_VIDEO": "Video hinzufügen",
    "UPLOADER_CANCEL_UPLOAD": "Doch nicht hochladen",
    "UPLOADER_ERROR_BODY": "Können Sie es bitte nochmal versuchen?",
    "UPLOADER_ERROR_HEADLINE": "Das hat leider nicht geklappt.",
    "UPLOADER_IMAGE_LOADING_HEADLINE": "Dein Bild wird hochgeladen ...",
    "UPLOADER_TRY_AGAIN": "Noch einmal versuchen",
    "UPLOADER_VIDEO_LOADED_BODY": "Wir bereiten es nun auf, damit es in bestmöglicher Qualität abgespielt werden kann. Sie können es aber gerne schon veröffentlichen oder teilen.",
    "UPLOADER_VIDEO_LOADED_HEADLINE": "Ihr Video wurde hochgeladen.",
    "UPLOADER_VIDEO_LOADING_HEADLINE": "Video wird hochgeladen ...",
    "USER_FLAG_BUTTON_ARIA_LABEL": "Markierung für XING {type}",
    "USER_FLAG_ERROR": "Diese Info können wir gerade leider nicht zeigen.<br>\nVersuch's bitte später nochmal.",
    "USER_FLAG_ERROR_PARAGRAPH_1": "Diese Info können wir gerade leider nicht zeigen.",
    "USER_FLAG_ERROR_PARAGRAPH_2": "Versuch's bitte später nochmal.",
    "USER_FLAG_LOADING": "Einen Moment bitte ...",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Die neue XING App: Feedback & Hilfe",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT": "Neue App",
    "VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE": "Karriere-Ratgeber",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION": "Mitgliedschaft kündigen",
    "VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE": "Praktikum-Guide",
    "VERTICAL_NAVIGATION_FOOTER_TRACKING": "Tracking",
    "VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR": "BrandManager",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES": "Mitgliedschaften & Rechnungen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS": "Alle Ergebnisse",
    "VERTICAL_NAVIGATION_MORE": "Mehr",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL": "ProJobs entdecken",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT": "ProJobs",
    "VIDEOS_AUTOPLAY": "Automatisch abspielen",
    "VIDEOS_SETTINGS": "Videos automatisch abspielen?",
    "VIDEOS_WATCH_VIDEO": "Video ansehen",
    "VIDEO_ENCODING_HEADLINE": "Ihr Video wird gerade aufbereitet.",
    "VIDEO_ENCODING_MESSAGE": "Wir bereiten gerade Dein Video so auf, dass wir es in der bestmöglichen Qualität anzeigen können. Dies kann ein paar Minuten dauern.",
    "XDS_BACK_TO_TOP_BUTTON": "Nach oben",
    "XDS_FLAG_AMBASSADOR_DIVERSE": "Ambassadx",
    "XDS_FLAG_AMBASSADOR_FEMALE": "Ambassadorin",
    "XDS_FLAG_AMBASSADOR_MALE": "Ambassador",
    "XDS_FLAG_AMBASSADOR_NEUTRAL": "Ambassador",
    "XDS_FLAG_BASIC_DIVERSE": "Basis",
    "XDS_FLAG_BASIC_FEMALE": "Basis",
    "XDS_FLAG_BASIC_MALE": "Basis",
    "XDS_FLAG_BASIC_NEUTRAL": "Basis",
    "XDS_FLAG_BETA_DIVERSE": "Beta",
    "XDS_FLAG_BETA_FEMALE": "Beta",
    "XDS_FLAG_BETA_MALE": "Beta",
    "XDS_FLAG_BETA_NEUTRAL": "Beta",
    "XDS_FLAG_INSIDER_DIVERSE": "Insidx",
    "XDS_FLAG_INSIDER_FEMALE": "Insiderin",
    "XDS_FLAG_INSIDER_MALE": "Insider",
    "XDS_FLAG_INSIDER_NEUTRAL": "Insider",
    "XDS_FLAG_MODERATOR_DIVERSE": "Moderatx",
    "XDS_FLAG_MODERATOR_FEMALE": "Moderatorin",
    "XDS_FLAG_MODERATOR_MALE": "Moderator",
    "XDS_FLAG_MODERATOR_NEUTRAL": "Moderator",
    "XDS_FLAG_NEW_DIVERSE": "Neu",
    "XDS_FLAG_NEW_FEMALE": "Neu",
    "XDS_FLAG_NEW_MALE": "Neu",
    "XDS_FLAG_NEW_NEUTRAL": "Neu",
    "XDS_FLAG_PREMIUM_DIVERSE": "Premium",
    "XDS_FLAG_PREMIUM_FEMALE": "Premium",
    "XDS_FLAG_PREMIUM_MALE": "Premium",
    "XDS_FLAG_PREMIUM_NEUTRAL": "Premium",
    "XDS_FLAG_PROBUSINESS_DIVERSE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_FEMALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_MALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_NEUTRAL": "ProBusiness",
    "XDS_FLAG_PROCOACH_DIVERSE": "ProCoach",
    "XDS_FLAG_PROCOACH_FEMALE": "ProCoach",
    "XDS_FLAG_PROCOACH_MALE": "ProCoach",
    "XDS_FLAG_PROCOACH_NEUTRAL": "ProCoach",
    "XDS_FLAG_PROJOBS_DIVERSE": "ProJobs",
    "XDS_FLAG_PROJOBS_FEMALE": "ProJobs",
    "XDS_FLAG_PROJOBS_MALE": "ProJobs",
    "XDS_FLAG_PROJOBS_NEUTRAL": "ProJobs",
    "XDS_FLAG_PROTRAINER_DIVERSE": "ProTrainx",
    "XDS_FLAG_PROTRAINER_FEMALE": "ProTrainerin",
    "XDS_FLAG_PROTRAINER_MALE": "ProTrainer",
    "XDS_FLAG_PROTRAINER_NEUTRAL": "ProTrainer",
    "XINGID_ADD_LEAD_SUCCESS": "{displayName} als Lead hinzugefügt",
    "XINGID_REMOVE_LEAD_SUCCESS": "{displayName} als Lead entfernt",
    "XING_FAQ_GUIDE_URL": "https://faq.xing.com/de/dein-netzwerk/netzwerken-so-gehts",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS": "Zugriff auf die Video-API für Werbetreibende",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING": "XING Video-API",
    "X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK": "Einloggen",
    "INDUSTRY_10000": "Architektur, Bauwesen",
    "INDUSTRY_100000": "Telekommunikation",
    "INDUSTRY_10100": "Bauingenieurwesen",
    "INDUSTRY_10200": "Baugewerbe",
    "INDUSTRY_10300": "Baustoffe",
    "INDUSTRY_10400": "Architektur",
    "INDUSTRY_10500": "Garten- und Landschaftsbau",
    "INDUSTRY_110000": "Medien, Verlage",
    "INDUSTRY_110100": "Informationsdienste",
    "INDUSTRY_110200": "Rundfunk, Fernsehen",
    "INDUSTRY_110300": "Verlagswesen",
    "INDUSTRY_110400": "Film, Musik",
    "INDUSTRY_110500": "Journalismus",
    "INDUSTRY_110600": "Übersetzen, Dolmetschen",
    "INDUSTRY_110700": "Text, Lektorat",
    "INDUSTRY_120000": "Banken, Finanzdienstleistungen",
    "INDUSTRY_120100": "Finanzdienstleistungen",
    "INDUSTRY_120200": "Bankwesen",
    "INDUSTRY_120300": "Investmentbanken",
    "INDUSTRY_120400": "Risikokapital, Private Equity",
    "INDUSTRY_130000": "Versicherungen",
    "INDUSTRY_140000": "Immobilien",
    "INDUSTRY_140100": "Facility Management",
    "INDUSTRY_140200": "Immobilienverwaltung",
    "INDUSTRY_140300": "Immobilienvermittlung",
    "INDUSTRY_150000": "Wirtschaftsprüfung, Steuern, Recht",
    "INDUSTRY_150100": "Rechtsberatung",
    "INDUSTRY_150200": "Wirtschaftsprüfung",
    "INDUSTRY_150300": "Steuerberatung",
    "INDUSTRY_160000": "Beratung, Consulting",
    "INDUSTRY_170000": "Marketing, PR und Design",
    "INDUSTRY_170100": "Marketing, Werbung",
    "INDUSTRY_170200": "Markt- und Meinungsforschung",
    "INDUSTRY_170300": "Design, Grafik",
    "INDUSTRY_170400": "Messe, Ausstellungen, Kongresse",
    "INDUSTRY_170500": "PR",
    "INDUSTRY_180000": "Personaldienstleistungen",
    "INDUSTRY_180100": "Personaldienstleistungen und -beratung",
    "INDUSTRY_180200": "Outsourcing, Offshoring",
    "INDUSTRY_190000": "Öffentlicher Dienst, Verbände und Einrichtungen",
    "INDUSTRY_190100": "Gemeinnützige Einrichtungen und Vereine",
    "INDUSTRY_190200": "Religiöse Einrichtungen",
    "INDUSTRY_190300": "Öffentliche Verwaltung",
    "INDUSTRY_190400": "Politik, Verbände",
    "INDUSTRY_190500": "Verteidigung, Justiz, Polizei",
    "INDUSTRY_190600": "Internationale Angelegenheiten",
    "INDUSTRY_20000": "Konsumgüter, Handel",
    "INDUSTRY_200000": "Erziehung, Bildung, Wissenschaft",
    "INDUSTRY_200100": "Forschung",
    "INDUSTRY_200200": "Schulen, Kindergärten",
    "INDUSTRY_200300": "Fach- und Hochschulen",
    "INDUSTRY_200400": "Kinderbetreuung",
    "INDUSTRY_200500": "Coaching, Fortbildung",
    "INDUSTRY_200600": "E-Learning",
    "INDUSTRY_20100": "Lebensmittel",
    "INDUSTRY_20200": "Getränke",
    "INDUSTRY_20300": "Tabakwaren",
    "INDUSTRY_20400": "Mode, Textilien",
    "INDUSTRY_20500": "Schmuck, Luxusgüter",
    "INDUSTRY_20600": "Möbel, Holzwaren",
    "INDUSTRY_20700": "Papierwaren",
    "INDUSTRY_20800": "Kosmetik, Körperpflege",
    "INDUSTRY_20900": "Glas, Keramik",
    "INDUSTRY_21000": "Import, Export",
    "INDUSTRY_210000": "Gesundheit, Soziales",
    "INDUSTRY_210100": "Krankenhäuser",
    "INDUSTRY_210200": "Tiermedizin",
    "INDUSTRY_210300": "Arztpraxen",
    "INDUSTRY_210400": "Alternative Medizin",
    "INDUSTRY_210500": "Psychologie, Psychotherapie",
    "INDUSTRY_210600": "Medizinische Dienste",
    "INDUSTRY_210700": "Pflegeberufe",
    "INDUSTRY_210800": "Sozialwesen",
    "INDUSTRY_21100": "Großhandel",
    "INDUSTRY_21200": "Einzelhandel",
    "INDUSTRY_220000": "Kunst, Kultur, Sport",
    "INDUSTRY_220100": "Darstellende Kunst",
    "INDUSTRY_220200": "Fotografie",
    "INDUSTRY_220300": "Musik",
    "INDUSTRY_220400": "Kunst, Kunsthandwerk",
    "INDUSTRY_220500": "Museen, Kultureinrichtungen",
    "INDUSTRY_220600": "Bibliotheken",
    "INDUSTRY_220700": "Fitness-Studios, Sportvereine und -anlagen",
    "INDUSTRY_220800": "Sporttreibende, Veranstalter, Verbände",
    "INDUSTRY_230000": "Sonstige Branchen",
    "INDUSTRY_230100": "Spiel-, Wett- und Lotteriewesen",
    "INDUSTRY_230200": "Landwirtschaft",
    "INDUSTRY_230300": "Forstwirtschaft, Jagd",
    "INDUSTRY_230400": "Fischerei",
    "INDUSTRY_230500": "Sonstige Dienstleistungen",
    "INDUSTRY_230600": "Bergbau, Metalle",
    "INDUSTRY_230700": "Geologie",
    "INDUSTRY_230800": "Sicherheit, Ermittlungen",
    "INDUSTRY_30000": "Automobil- und Fahrzeugbau",
    "INDUSTRY_30100": "Automobile und Zweiräder",
    "INDUSTRY_30200": "Schiffbau",
    "INDUSTRY_30300": "Schienenfahrzeugbau",
    "INDUSTRY_30400": "Verkehrstechnik",
    "INDUSTRY_30500": "Luft- und Raumfahrzeugbau",
    "INDUSTRY_30600": "Fahrzeugvermietung",
    "INDUSTRY_40000": "Industrie und Maschinenbau",
    "INDUSTRY_40100": "Mess-, Steuer- und Regelungstechnik",
    "INDUSTRY_40200": "Halbleiter, elektronische Bauteile",
    "INDUSTRY_40300": "Druckwesen",
    "INDUSTRY_40400": "Verbundwerkstoffe",
    "INDUSTRY_40500": "Chemie",
    "INDUSTRY_40600": "Mineralöl-Verarbeitung",
    "INDUSTRY_40700": "Metallindustrie und -verarbeitung",
    "INDUSTRY_40800": "Bio- und Nanotechnologie",
    "INDUSTRY_40900": "Kunststoff- und Gummiwaren",
    "INDUSTRY_41000": "Rüstung",
    "INDUSTRY_41100": "Maschinenbau, Betriebstechnik",
    "INDUSTRY_41200": "Elektrotechnik",
    "INDUSTRY_41300": "Optische und fotografische Geräte",
    "INDUSTRY_50000": "Pharma, Medizintechnik",
    "INDUSTRY_50100": "Medizintechnik",
    "INDUSTRY_50200": "Pharmazeutische Produkte, Arzneimittel",
    "INDUSTRY_60000": "Energie, Wasser, Umwelt",
    "INDUSTRY_60100": "Erneuerbare Energien",
    "INDUSTRY_60200": "Energiewirtschaft",
    "INDUSTRY_60300": "Wasserversorgung und -entsorgung",
    "INDUSTRY_60400": "Abfälle, Recycling",
    "INDUSTRY_60500": "Umweltschutz",
    "INDUSTRY_70000": "Transport, Logistik",
    "INDUSTRY_70100": "Personenverkehr",
    "INDUSTRY_70200": "Bahnverkehr",
    "INDUSTRY_70300": "Schifffahrt",
    "INDUSTRY_70400": "Luftverkehr",
    "INDUSTRY_70500": "Lagerhaltung",
    "INDUSTRY_70600": "Post, Spedition",
    "INDUSTRY_80000": "Tourismus, Gastronomie",
    "INDUSTRY_80100": "Hotelgewerbe",
    "INDUSTRY_80200": "Gastronomie",
    "INDUSTRY_80300": "Reisebüros und -veranstalter",
    "INDUSTRY_80400": "Freizeiteinrichtungen",
    "INDUSTRY_90000": "Internet, IT",
    "INDUSTRY_90100": "Computer-Software",
    "INDUSTRY_90200": "IT-Dienstleister",
    "INDUSTRY_90300": "IT-Sicherheit",
    "INDUSTRY_90400": "Computernetzwerke",
    "INDUSTRY_90500": "Computer-Hardware",
    "INDUSTRY_90600": "Unterhaltungselektronik",
    "INDUSTRY_90700": "Internet, Onlinemedien",
    "INDUSTRY_90800": "Computerspiele",
    "CONTENT_TIMESTAMP_YESTERDAY": "Gestern",
    "MESSAGESHTML_SEARCH_INBOX": "Suche nach Namen",
    "SOCIAL_PMBX_MENTION_DOCUMENT_URL": "Inhalt",
    "SOCIAL_PMBX_MENTION_HEADING": "Deine Erwähnungen",
    "SOCIAL_PMBX_MENTION_TITLE": "Deine Erwähnungen",
    "CAREER_LEVEL_1": "Student·in / Praktikant·in",
    "CAREER_LEVEL_2": "Berufseinsteiger·in",
    "CAREER_LEVEL_3": "Mit Berufserfahrung",
    "CAREER_LEVEL_4": "Manager (mit und ohne Personalverantwortung)",
    "CAREER_LEVEL_5": "Direktor·in (Bereichsleitung, VP, SVP etc.)",
    "CAREER_LEVEL_6": "Geschäftsführer·in (GF, CEO etc.)",
    "COMPANY_SIZE": "Unternehmensgröße",
    "COMPANY_SIZE_1": "Nur ich",
    "COMPANY_SIZE_2": "1-10 Mitarbeitende",
    "COMPANY_SIZE_3": "11-50 Mitarbeitende",
    "COMPANY_SIZE_4": "51-200 Mitarbeitende",
    "COMPANY_SIZE_5": "201-500 Mitarbeitende",
    "COMPANY_SIZE_6": "501-1.000 Mitarbeitende",
    "COMPANY_SIZE_7": "1.001-5.000 Mitarbeitende",
    "COMPANY_SIZE_8": "5.001-10.000 Mitarbeitende",
    "COMPANY_SIZE_9": "10.001 oder mehr Mitarbeitende",
    "COUNTRY_AD": "Andorra",
    "COUNTRY_AE": "Vereinigte Arabische Emirate",
    "COUNTRY_AF": "Afghanistan",
    "COUNTRY_AG": "Antigua und Barbuda",
    "COUNTRY_AI": "Anguilla",
    "COUNTRY_AL": "Albanien",
    "COUNTRY_AM": "Armenien",
    "COUNTRY_AN": "Niederländische Antillen",
    "COUNTRY_AO": "Angola",
    "COUNTRY_AQ": "Antarktis",
    "COUNTRY_AR": "Argentinien",
    "COUNTRY_AS": "Amerikanisch-Samoa",
    "COUNTRY_AT": "Österreich",
    "COUNTRY_AU": "Australien",
    "COUNTRY_AW": "Aruba",
    "COUNTRY_AX": "Älandinseln",
    "COUNTRY_AZ": "Aserbaidschan",
    "COUNTRY_BA": "Bosnien-Herzegowina",
    "COUNTRY_BB": "Barbados",
    "COUNTRY_BD": "Bangladesch",
    "COUNTRY_BE": "Belgien",
    "COUNTRY_BF": "Burkina Faso",
    "COUNTRY_BG": "Bulgarien",
    "COUNTRY_BH": "Bahrain",
    "COUNTRY_BI": "Burundi",
    "COUNTRY_BJ": "Benin",
    "COUNTRY_BM": "Bermuda",
    "COUNTRY_BN": "Brunei",
    "COUNTRY_BO": "Bolivien",
    "COUNTRY_BR": "Brasilien",
    "COUNTRY_BS": "Bahamas",
    "COUNTRY_BT": "Bhutan",
    "COUNTRY_BV": "Bouvetinsel",
    "COUNTRY_BW": "Botswana",
    "COUNTRY_BY": "Weißrußland",
    "COUNTRY_BZ": "Belize",
    "COUNTRY_CA": "Kanada",
    "COUNTRY_CC": "Kokosinseln",
    "COUNTRY_CD": "Die Demokratische Republik Kongo",
    "COUNTRY_CF": "Zentralafrikanische Republik",
    "COUNTRY_CG": "Kongo",
    "COUNTRY_CH": "Schweiz",
    "COUNTRY_CI": "Côte d'Ivoire",
    "COUNTRY_CK": "Cook-Inseln",
    "COUNTRY_CL": "Chile",
    "COUNTRY_CM": "Kamerun",
    "COUNTRY_CN": "China",
    "COUNTRY_CO": "Kolumbien",
    "COUNTRY_CR": "Costa Rica",
    "COUNTRY_CU": "Kuba",
    "COUNTRY_CV": "Kap Verde",
    "COUNTRY_CX": "Weihnachtsinsel",
    "COUNTRY_CY": "Zypern",
    "COUNTRY_CZ": "Tschechische Republik",
    "COUNTRY_DE": "Deutschland",
    "COUNTRY_DJ": "Dschibuti",
    "COUNTRY_DK": "Dänemark",
    "COUNTRY_DM": "Dominika",
    "COUNTRY_DO": "Dominikanische Republik",
    "COUNTRY_DZ": "Algerien",
    "COUNTRY_EC": "Ecuador",
    "COUNTRY_EE": "Estland",
    "COUNTRY_EG": "Ägypten",
    "COUNTRY_EH": "Westsahara",
    "COUNTRY_ER": "Eritrea",
    "COUNTRY_ES": "Spanien",
    "COUNTRY_ET": "Äthiopien",
    "COUNTRY_FI": "Finnland",
    "COUNTRY_FJ": "Fidschi-Inseln",
    "COUNTRY_FK": "Falklandinseln (Malwinen)",
    "COUNTRY_FM": "Mikronesien",
    "COUNTRY_FO": "Faroer-Inseln",
    "COUNTRY_FR": "Frankreich",
    "COUNTRY_GA": "Gabun",
    "COUNTRY_GB": "Vereinigtes Königreich",
    "COUNTRY_GD": "Grenada",
    "COUNTRY_GE": "Georgien",
    "COUNTRY_GF": "Französisch Guyana",
    "COUNTRY_GG": "Guernsey",
    "COUNTRY_GH": "Ghana",
    "COUNTRY_GI": "Gibraltar",
    "COUNTRY_GL": "Grönland",
    "COUNTRY_GM": "Gambia",
    "COUNTRY_GN": "Guinea",
    "COUNTRY_GP": "Guadeloupe",
    "COUNTRY_GQ": "Äquatorial-Guinea",
    "COUNTRY_GR": "Griechenland",
    "COUNTRY_GS": "Südgeorgien und Südliche Sandwichinseln",
    "COUNTRY_GT": "Guatemala",
    "COUNTRY_GU": "Guam",
    "COUNTRY_GW": "Guinea-Bissau",
    "COUNTRY_GY": "Guyana",
    "COUNTRY_HK": "Hongkong",
    "COUNTRY_HM": "Heard und McDonald-Inseln",
    "COUNTRY_HN": "Honduras",
    "COUNTRY_HR": "Kroatien",
    "COUNTRY_HT": "Haiti",
    "COUNTRY_HU": "Ungarn",
    "COUNTRY_ID": "Indonesien",
    "COUNTRY_IE": "Irland",
    "COUNTRY_IL": "Israel",
    "COUNTRY_IM": "Isle of Man",
    "COUNTRY_IN": "Indien",
    "COUNTRY_IO": "Britisches Territorium im Indischen Ozean",
    "COUNTRY_IQ": "Irak",
    "COUNTRY_IR": "Iran (Islamische Republik )",
    "COUNTRY_IS": "Island",
    "COUNTRY_IT": "Italien",
    "COUNTRY_JE": "Jersey",
    "COUNTRY_JM": "Jamaika",
    "COUNTRY_JO": "Jordanien",
    "COUNTRY_JP": "Japan",
    "COUNTRY_KE": "Kenia",
    "COUNTRY_KG": "Kirgistan",
    "COUNTRY_KH": "Kambodscha",
    "COUNTRY_KI": "Kiribati",
    "COUNTRY_KM": "Komoren",
    "COUNTRY_KN": "Saint Christopher/Kitts",
    "COUNTRY_KP": "Nordkorea",
    "COUNTRY_KR": "Südkorea",
    "COUNTRY_KW": "Kuwait",
    "COUNTRY_KY": "Cayman-Inseln",
    "COUNTRY_KZ": "Kasachstan",
    "COUNTRY_LA": "Laos",
    "COUNTRY_LB": "Libanon",
    "COUNTRY_LC": "Karibische Inseln - Saint Lucia",
    "COUNTRY_LI": "Liechtenstein",
    "COUNTRY_LK": "Sri Lanka",
    "COUNTRY_LR": "Liberia",
    "COUNTRY_LS": "Lesotho",
    "COUNTRY_LT": "Litauen",
    "COUNTRY_LU": "Luxemburg",
    "COUNTRY_LV": "Lettland",
    "COUNTRY_LY": "Libyen",
    "COUNTRY_MA": "Marokko",
    "COUNTRY_MC": "Monaco",
    "COUNTRY_MD": "Moldawien",
    "COUNTRY_ME": "Montenegro",
    "COUNTRY_MG": "Madagaskar",
    "COUNTRY_MH": "Marschall-Inseln",
    "COUNTRY_MK": "Mazedonien",
    "COUNTRY_ML": "Mali",
    "COUNTRY_MM": "Burma",
    "COUNTRY_MN": "Mongolei",
    "COUNTRY_MO": "Macao",
    "COUNTRY_MP": "Nördliche Marianen-Inseln",
    "COUNTRY_MQ": "Martinique",
    "COUNTRY_MR": "Mauretanien",
    "COUNTRY_MS": "Montserrat",
    "COUNTRY_MT": "Malta",
    "COUNTRY_MU": "Mauritius",
    "COUNTRY_MV": "Malediven",
    "COUNTRY_MW": "Malawi",
    "COUNTRY_MX": "Mexiko",
    "COUNTRY_MY": "Malaysia",
    "COUNTRY_MZ": "Mosambik",
    "COUNTRY_NA": "Namibia",
    "COUNTRY_NC": "Neu-Kaledonien",
    "COUNTRY_NE": "Niger",
    "COUNTRY_NF": "Norfolk-Inseln",
    "COUNTRY_NG": "Nigeria",
    "COUNTRY_NI": "Nicaragua",
    "COUNTRY_NL": "Niederlande",
    "COUNTRY_NO": "Norwegen",
    "COUNTRY_NP": "Nepal",
    "COUNTRY_NR": "Nauru",
    "COUNTRY_NU": "Niue-Inseln",
    "COUNTRY_NZ": "Neuseeland",
    "COUNTRY_OM": "Oman",
    "COUNTRY_PA": "Panama",
    "COUNTRY_PE": "Peru",
    "COUNTRY_PF": "Französisch Polynesien",
    "COUNTRY_PG": "Papua-Neuguinea",
    "COUNTRY_PH": "Philippinen",
    "COUNTRY_PK": "Pakistan",
    "COUNTRY_PL": "Polen",
    "COUNTRY_PM": "Saint Pierre et Miquelon",
    "COUNTRY_PN": "Pitcairn",
    "COUNTRY_PR": "Puerto Rico",
    "COUNTRY_PS": "Palästinensisches Gebiet, Besetztes",
    "COUNTRY_PT": "Portugal",
    "COUNTRY_PW": "Palau-Inseln",
    "COUNTRY_PY": "Paraguay",
    "COUNTRY_QA": "Katar",
    "COUNTRY_RE": "Reunion",
    "COUNTRY_RO": "Rumänien",
    "COUNTRY_RS": "Serbien",
    "COUNTRY_RU": "Russische Föderation",
    "COUNTRY_RW": "Ruanda",
    "COUNTRY_SA": "Saudi-Arabien",
    "COUNTRY_SB": "Salomonen",
    "COUNTRY_SC": "Seychellen",
    "COUNTRY_SD": "Sudan",
    "COUNTRY_SE": "Schweden",
    "COUNTRY_SG": "Singapur",
    "COUNTRY_SH": "Sankt Helena",
    "COUNTRY_SI": "Slowenien",
    "COUNTRY_SJ": "Svalbard und Jan Mayen-Inseln",
    "COUNTRY_SK": "Slowakei",
    "COUNTRY_SL": "Sierra Leone",
    "COUNTRY_SM": "San Marino",
    "COUNTRY_SN": "Senegal",
    "COUNTRY_SO": "Somalia",
    "COUNTRY_SR": "Surinam",
    "COUNTRY_ST": "Sao Tome & Principe",
    "COUNTRY_SV": "El Salvador",
    "COUNTRY_SY": "Syrien",
    "COUNTRY_SZ": "Swasiland",
    "COUNTRY_TC": "Turks- und Caicos Inseln",
    "COUNTRY_TD": "Tschad",
    "COUNTRY_TF": "Französische Gebiete im südlichen Indischen Ozean",
    "COUNTRY_TG": "Togo",
    "COUNTRY_TH": "Thailand",
    "COUNTRY_TJ": "Tadschikistan",
    "COUNTRY_TK": "Tokelau",
    "COUNTRY_TL": "Ost-Timor",
    "COUNTRY_TM": "Turkmenistan",
    "COUNTRY_TN": "Tunesien",
    "COUNTRY_TO": "Tonga",
    "COUNTRY_TR": "Türkei",
    "COUNTRY_TT": "Trinidad und Tobago",
    "COUNTRY_TV": "Tuvalu",
    "COUNTRY_TW": "Taiwan",
    "COUNTRY_TZ": "Tansania",
    "COUNTRY_UA": "Ukraine",
    "COUNTRY_UG": "Uganda",
    "COUNTRY_UM": "United States Minor Outlying Islands",
    "COUNTRY_US": "Vereinigte Staaten",
    "COUNTRY_UY": "Uruguay",
    "COUNTRY_UZ": "Usbekistan",
    "COUNTRY_VA": "Vatikanstadt",
    "COUNTRY_VC": "Saint Vincent u. Grenadien",
    "COUNTRY_VE": "Venezuela",
    "COUNTRY_VG": "Jungfern-Inseln (UK)",
    "COUNTRY_VI": "Jungfern-Inseln (USA)",
    "COUNTRY_VN": "Vietnam",
    "COUNTRY_VU": "Vanuatu",
    "COUNTRY_WF": "Wallis und Futuna",
    "COUNTRY_WS": "Samoa-Inseln",
    "COUNTRY_YE": "Jemen",
    "COUNTRY_YT": "Mayotte",
    "COUNTRY_ZA": "Südafrika",
    "COUNTRY_ZM": "Zambia",
    "COUNTRY_ZW": "Zimbabwe",
    "CP_REVIEWS_BENEFITS_1": "Flexible Arbeitszeiten",
    "CP_REVIEWS_BENEFITS_10": "Coaching",
    "CP_REVIEWS_BENEFITS_11": "Parkplatz",
    "CP_REVIEWS_BENEFITS_12": "Günstige Anbindung",
    "CP_REVIEWS_BENEFITS_13": "Spezielle Rabatte",
    "CP_REVIEWS_BENEFITS_14": "Firmenwagen",
    "CP_REVIEWS_BENEFITS_15": "Eigenes Handy",
    "CP_REVIEWS_BENEFITS_16": "Gewinnbeteiligung",
    "CP_REVIEWS_BENEFITS_17": "Interne Events",
    "CP_REVIEWS_BENEFITS_18": "Internetnutzung",
    "CP_REVIEWS_BENEFITS_19": "Hunde willkommen",
    "CP_REVIEWS_BENEFITS_2": "Home-Office",
    "CP_REVIEWS_BENEFITS_3": "Kantine",
    "CP_REVIEWS_BENEFITS_4": "Essenszulagen",
    "CP_REVIEWS_BENEFITS_5": "Kinderbetreuung",
    "CP_REVIEWS_BENEFITS_6": "Betr. Altersversorgung",
    "CP_REVIEWS_BENEFITS_7": "Barrierefreiheit",
    "CP_REVIEWS_BENEFITS_8": "Gesundheitsmaßnahmen",
    "CP_REVIEWS_BENEFITS_9": "Betriebsarzt",
    "DISCIPLINE_1001": "Analyse und Statistik",
    "DISCIPLINE_1002": "Administration, Sachbearbeitung und Verwaltung",
    "DISCIPLINE_1003": "Beratung / Consulting",
    "DISCIPLINE_1004": "Kundenbetreuung",
    "DISCIPLINE_1005": "Einkauf, Materialwirtschaft und Logistik",
    "DISCIPLINE_1006": "Finanzen, Rechnungswesen und Controlling",
    "DISCIPLINE_1007": "Forschung, Lehre und Entwicklung",
    "DISCIPLINE_1008": "Gesundheit, Medizin und Soziales",
    "DISCIPLINE_1009": "Grafik, Design und Architektur",
    "DISCIPLINE_1010": "Ingenieurwesen und technische Berufe",
    "DISCIPLINE_1011": "IT und Softwareentwicklung",
    "DISCIPLINE_1012": "Management und Unternehmensentwicklung",
    "DISCIPLINE_1013": "Marketing und Werbung",
    "DISCIPLINE_1014": "Personalwesen und HR",
    "DISCIPLINE_1015": "PR, Öffentlichkeitsarbeit und Journalismus",
    "DISCIPLINE_1016": "Produktion und Handwerk",
    "DISCIPLINE_1017": "Produktmanagement",
    "DISCIPLINE_1018": "Projektmanagement",
    "DISCIPLINE_1019": "Prozessplanung und Qualitätssicherung",
    "DISCIPLINE_1020": "Recht",
    "DISCIPLINE_1021": "Vertrieb und Handel",
    "DISCIPLINE_1022": "Sonstige Tätigkeitsfelder",
    "EMPLOYMENT_TYPE_CONTRACTOR": "Selbstständig",
    "EMPLOYMENT_TYPE_CONTRACTOR_LOCAL_SERPS": "Freelancer",
    "EMPLOYMENT_TYPE_FULL_TIME": "Vollzeit",
    "EMPLOYMENT_TYPE_INTERN": "Für Studenten",
    "EMPLOYMENT_TYPE_PART_TIME": "Teilzeit",
    "EMPLOYMENT_TYPE_SEASONAL": "Saisonarbeit",
    "EMPLOYMENT_TYPE_TEMPORARY": "Aushilfe",
    "EMPLOYMENT_TYPE_TEMPORARY_LOCAL_SERPS": "Mini",
    "EMPLOYMENT_TYPE_VOLUNTARY": "Ehrenamt",
    "MP_000_RESOURCE_USER_ROLES_EMPLOYEE": "Mitarbeitende des Unternehmens",
    "MP_000_RESOURCE_USER_ROLES_EXECUTIVE": "Geschäftsführer",
    "MP_000_RESOURCE_USER_ROLES_EXTERNAL_RECRUITER": "Personalvermittler",
    "MP_000_RESOURCE_USER_ROLES_HR_CONSULTANT": "Personalberater",
    "MP_000_RESOURCE_USER_ROLES_HR_DEPARTMENT": "Personalabteilung",
    "MP_000_RESOURCE_USER_ROLES_MANAGER": "Direkter Vorgesetzter",
    "MP_000_RESOURCE_USER_ROLES_RECRUITER_CONSULTANT": "Personalberater",
    "PREFSHTML_LANG_OPT_de": "Deutsch",
    "PREFSHTML_LANG_OPT_en": "Englisch",
    "PREFSHTML_LANG_OPT_es": "Spanisch",
    "PREFSHTML_LANG_OPT_fr": "Französisch",
    "PREFSHTML_LANG_OPT_it": "Italienisch",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_10_AM": "10 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_10_PM": "22 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_12_AM": "00 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_12_PM": "12 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_2_PM": "14 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_4_PM": "16 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_6_AM": "06 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_6_PM": "18 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_8_AM": "08 Uhr",
    "PROJOBS_CONTACT_OPTIONS_PHONE_TIME_8_PM": "20 Uhr",
    "PROVINCE_0": "Macau",
    "PROVINCE_1279685": "Autonomes Gebiet Tibet",
    "PROVINCE_1280239": "Qinghai",
    "PROVINCE_1529047": "Autonomes Gebiet Xinjiang",
    "PROVINCE_1784764": "Zhejiang",
    "PROVINCE_1785694": "Yunnan",
    "PROVINCE_1792943": "Tianjin",
    "PROVINCE_1794299": "Sichuan",
    "PROVINCE_1795912": "Shanxi",
    "PROVINCE_1796231": "Shanghai",
    "PROVINCE_1796328": "Shandong",
    "PROVINCE_1796480": "Shaanxi",
    "PROVINCE_1799355": "Autonome Region Ningxia",
    "PROVINCE_1806222": "Jiangxi",
    "PROVINCE_1806260": "Jiangsu",
    "PROVINCE_1806691": "Hunan",
    "PROVINCE_1806949": "Hubei",
    "PROVINCE_1808520": "Henan",
    "PROVINCE_1808773": "Hebei",
    "PROVINCE_1809054": "Hainan",
    "PROVINCE_1809445": "Guizhou",
    "PROVINCE_1809867": "Autonome Region Guangxi",
    "PROVINCE_1809935": "Guangdong",
    "PROVINCE_1810676": "Gansu",
    "PROVINCE_1811017": "Fujian",
    "PROVINCE_1814905": "Chongqing",
    "PROVINCE_1818058": "Anhui",
    "PROVINCE_2035607": "Autonomes Gebiet Innere Mongolei",
    "PROVINCE_2036115": "Liaoning",
    "PROVINCE_2036500": "Jilin",
    "PROVINCE_2036965": "Heilongjiang",
    "PROVINCE_2038349": "Peking",
    "PROVINCE_2513413": "Region Murcia",
    "PROVINCE_2521383": "Balearische Inseln",
    "PROVINCE_2593109": "Andalusien",
    "PROVINCE_2593110": "Kanarische Inseln",
    "PROVINCE_2593111": "Kastilien-La Mancha",
    "PROVINCE_2593112": "Estremadura",
    "PROVINCE_2593113": "Landes Valencia",
    "PROVINCE_2822542": "Thüringen",
    "PROVINCE_2838632": "Schleswig-Holstein",
    "PROVINCE_2842565": "Sachsen-Anhalt",
    "PROVINCE_2842566": "Sachsen",
    "PROVINCE_2842635": "Saarland",
    "PROVINCE_2847618": "Rheinland-Pfalz",
    "PROVINCE_2861876": "Nordrhein-Westfalen",
    "PROVINCE_2862926": "Niedersachsen",
    "PROVINCE_2872567": "Mecklenburg-Vorpommern",
    "PROVINCE_2905330": "Hessen",
    "PROVINCE_2911297": "Hamburg",
    "PROVINCE_2944387": "Bremen",
    "PROVINCE_2945356": "Brandenburg",
    "PROVINCE_2950157": "Berlin",
    "PROVINCE_2951839": "Bayern",
    "PROVINCE_2953481": "Baden-Württemberg",
    "PROVINCE_3042613": "Komitat Zala",
    "PROVINCE_3042925": "Veszprém",
    "PROVINCE_3043047": "Komitat Vas",
    "PROVINCE_3043845": "Tolna",
    "PROVINCE_3045226": "Somogy",
    "PROVINCE_3046431": "Pest",
    "PROVINCE_3047348": "Nógrád",
    "PROVINCE_3049518": "Komitat Komárom-Esztergom",
    "PROVINCE_3051977": "Komitat Győr-Moson-Sopron",
    "PROVINCE_3053028": "Komitat Fejér",
    "PROVINCE_3054638": "Budapest",
    "PROVINCE_3055399": "Branau",
    "PROVINCE_3055744": "Komitat Bács-Kiskun",
    "PROVINCE_3114710": "Asturien",
    "PROVINCE_3115609": "Autonome Region Navarra",
    "PROVINCE_3117732": "Autonome Region Madrid",
    "PROVINCE_3336897": "La Rioja",
    "PROVINCE_3336898": "Kantabrien",
    "PROVINCE_3336899": "Aragonien",
    "PROVINCE_3336900": "Kastilien und León",
    "PROVINCE_3336901": "Katalonien",
    "PROVINCE_3336902": "Galicien",
    "PROVINCE_3336903": "Baskenland",
    "PROVINCE_4099753": "Arkansas",
    "PROVINCE_4138106": "District of Columbia",
    "PROVINCE_4142224": "Delaware",
    "PROVINCE_4155751": "Florida",
    "PROVINCE_4197000": "Georgia",
    "PROVINCE_4273857": "Kansas",
    "PROVINCE_4331987": "Louisiana",
    "PROVINCE_4361885": "Maryland",
    "PROVINCE_4398678": "Missouri",
    "PROVINCE_4436296": "Mississippi",
    "PROVINCE_4482348": "North Carolina",
    "PROVINCE_4544379": "Oklahoma",
    "PROVINCE_4597040": "South Carolina",
    "PROVINCE_4662168": "Tennessee",
    "PROVINCE_4736286": "Texas",
    "PROVINCE_4826850": "West Virginia",
    "PROVINCE_4829764": "Alabama",
    "PROVINCE_4831725": "Connecticut",
    "PROVINCE_4862182": "Iowa",
    "PROVINCE_4896861": "Illinois",
    "PROVINCE_4921868": "Indiana",
    "PROVINCE_4971068": "Maine",
    "PROVINCE_5001836": "Michigan",
    "PROVINCE_5037779": "Minnesota",
    "PROVINCE_5073708": "Nebraska",
    "PROVINCE_5090174": "New Hampshire",
    "PROVINCE_5101760": "New Jersey",
    "PROVINCE_5128638": "New York",
    "PROVINCE_5165418": "Ohio",
    "PROVINCE_5224323": "Rhode Island",
    "PROVINCE_5242283": "Vermont",
    "PROVINCE_5279468": "Wisconsin",
    "PROVINCE_5332921": "Kalifornien",
    "PROVINCE_5417618": "Colorado",
    "PROVINCE_5481136": "New Mexico",
    "PROVINCE_5509151": "Nevada",
    "PROVINCE_5549030": "Utah",
    "PROVINCE_5551752": "Arizona",
    "PROVINCE_5596512": "Idaho",
    "PROVINCE_5667009": "Montana",
    "PROVINCE_5690763": "North Dakota",
    "PROVINCE_5744337": "Oregon",
    "PROVINCE_5769223": "South Dakota",
    "PROVINCE_5815135": "Washington",
    "PROVINCE_5843591": "Wyoming",
    "PROVINCE_5855797": "Hawaii",
    "PROVINCE_5879092": "Alaska",
    "PROVINCE_6254925": "Kentucky",
    "PROVINCE_6254926": "Massachusetts",
    "PROVINCE_6254927": "Pennsylvania",
    "PROVINCE_6254928": "Virginia",
    "PROVINCE_715593": "Komitat Szabolcs-Szatmár-Bereg",
    "PROVINCE_719637": "Komitat Jász-Nagykun-Szolnok",
    "PROVINCE_720002": "Heves",
    "PROVINCE_720293": "Komitat Hajdú-Bihar",
    "PROVINCE_721589": "Csongrád",
    "PROVINCE_722064": "Komitat Borsod-Abaúj-Zemplén",
    "PROVINCE_722433": "Békés",
    "REMOTE_OPTION_FULL_REMOTE": "Im Home-Office",
    "REMOTE_OPTION_NON_REMOTE": "Vor Ort",
    "REMOTE_OPTION_PARTLY_REMOTE": "Home-Office z. T. möglich",
    "WORKEXPERIENCE_STATUS_1": "Angestellt (Vollzeit)",
    "WORKEXPERIENCE_STATUS_10": "Gesellschafter·in",
    "WORKEXPERIENCE_STATUS_11": "Beamtet",
    "WORKEXPERIENCE_STATUS_12": "Personalvermittler·in",
    "WORKEXPERIENCE_STATUS_13": "Freiberuflich",
    "WORKEXPERIENCE_STATUS_14": "Partner·in",
    "WORKEXPERIENCE_STATUS_17": "In einer Ausbildung",
    "WORKEXPERIENCE_STATUS_2": "Angestellt (Teilzeit)",
    "WORKEXPERIENCE_STATUS_3": "Im Praktikum",
    "WORKEXPERIENCE_STATUS_4": "Selbstständig",
    "WORKEXPERIENCE_STATUS_5": "Inhaber·in",
    "WORKEXPERIENCE_STATUS_6": "Partner·in bzw. Gesellschafter·in",
    "WORKEXPERIENCE_STATUS_7": "Vorstandsmitglied",
    "WORKEXPERIENCE_STATUS_8": "Ehrenamtlich tätig",
    "WORKEXPERIENCE_STATUS_9": "Selbstständig",
    "VERTICAL_NAVIGATION_CREATE": "Chat starten",
    "CONTENT_VIDEO_ARTICLE_VIDEO_ADDED": "Video hinzugefügt",
    "VIDEO_DELETE_ERROR": "Leider konnten wir Ihr Video gerade nicht löschen. Können Sie's nochmal probieren?",
    "VIDEO_DIALOG_CANCEL": "Abbrechen",
    "VIDEO_DIALOG_CONFIRM": "Verwerfen",
    "VIDEO_DIALOG_HEADLINE": "Änderungen verwerfen?",
    "VIDEO_DIALOG_TEXT": "Sie gehen dadurch verloren.",
    "VIDEO_SAVE_ERROR": "Leider konnten wir Ihr Video gerade nicht speichern. Können Sie's nochmal probieren?",
    "VIDEO_UPLOADING_ERROR": "Leider konnten wir Ihr Video nicht hochladen – bitte wählen Sie ein Video im Format AVI, MOV oder MP4, mit dem Verhältnis 16:9 und mit max. 5 GB.",
    "VIDEO_UPLOAD_CANCEL": "Doch nicht hochladen",
    "VIDEO_UPLOAD_CROP_CANCEL": "Doch nicht zuschneiden",
    "VIDEO_UPLOAD_CROP_MAX": "Max.",
    "VIDEO_UPLOAD_CROP_MIN": "Mind.",
    "VIDEO_UPLOAD_CROP_SAVE": "Speichern",
    "VIDEO_UPLOAD_DELETE": "Video löschen",
    "VIDEO_UPLOAD_ENCODING_TITLE": "Dein Video wird nun aufbereitet. Sobald es fertig ist, sagen wir Ihnen per E-Mail Bescheid.",
    "VIDEO_UPLOAD_INPROGRESS_DESCRIPTION": "{percentage} % abgeschlossen ",
    "VIDEO_UPLOAD_INPROGRESS_TITLE": "Video wird hochgeladen ...",
    "VIDEO_UPLOAD_PREVIEW_IMAGE_CTA": "Datei auswählen",
    "VIDEO_UPLOAD_PREVIEW_IMAGE_DESCRIPTION": "Sie können hier ein Vorschaubild für das Video hinzufügen (JPG oder PNG,  max. 10 MB). Ansonsten wird ein Bild automatisch generiert.",
    "VIDEO_UPLOAD_PREVIEW_IMAGE_TITLE": "Vorschaubild",
    "VIDEO_UPLOAD_READY_CTA": "Dateien durchsuchen",
    "VIDEO_UPLOAD_READY_DESCRIPTION": "Format: AVI, MOV oder MP4 | Verhältnis: 16:9 | Größe: max. 5 GB",
    "VIDEO_UPLOAD_READY_TITLE": "Datei hierher ziehen oder auswählen",
    "VIDEO_UPLOAD_READY_TITLE_DRAGGING": "Datei jetzt loslassen",
    "VIDEO_UPLOAD_SAVE": "Speichern",
    "VIDEO_UPLOAD_SUBTITLES_CTA": "Datei auswählen",
    "VIDEO_UPLOAD_SUBTITLES_DESCRIPTION": "Sie können Ihrem Video hier Untertitel hinzufügen: als WebVTT- oder SRT-Datei.",
    "VIDEO_UPLOAD_SUBTITLES_LABEL_DE": "Deutsch",
    "VIDEO_UPLOAD_SUBTITLES_LABEL_EN": "Englisch",
    "VIDEO_UPLOAD_SUBTITLES_TITLE": "Untertitel",
    "VIDEO_UPLOAD_TITLE": "Titel des Videos",
    " COMMBOX_SCHEDULING_SUCCESSFULLY_SCHEDULED_TO": "Dein Beitrag wird am {date} um {time} geteilt.",
    "COMMBOX_SCHEDULE": "Fertig",
    "COMMBOX_SCHEDULING_DATE": "Datum",
    "COMMBOX_SCHEDULING_DATE_FUTURE_ERROR": "Bitte wähl ein zukünftiges Datum.",
    "COMMBOX_SCHEDULING_DATE_VALIDITY_ERROR": "Bitte gib das Datum in diesem Format ein: \"20.01.2021\"",
    "COMMBOX_SCHEDULING_FENCING_CTA_BUTTON": "Alle Vorteile entdecken",
    "COMMBOX_SCHEDULING_FENCING_HEADLINE": "Beiträge planen",
    "COMMBOX_SCHEDULING_FENCING_SUBLINE": "Legen Sie gezielt fest, wann Ihr Beitrag mit Ihren Followern geteilt wird. Durch die Planungsfunktion wird er dann automatisch zu dem Zeitpunkt veröffentlicht.",
    "COMMBOX_SCHEDULING_HOUR_RECOS": "Empfohlene Uhrzeiten",
    "COMMBOX_SCHEDULING_IMMEDIATELY": "Sofort",
    "COMMBOX_SCHEDULING_NOW": "Abbrechen",
    "COMMBOX_SCHEDULING_SAVE": "Speichern",
    "COMMBOX_SCHEDULING_SCHEDULE": "Fertig",
    "COMMBOX_SCHEDULING_TIME": "Uhrzeit",
    "COMMBOX_SCHEDULING_TIME_FUTURE_ERROR": "Bitte wähl eine Uhrzeit, die noch nicht vorbei ist. ",
    "COMMBOX_SCHEDULING_TITLE": "Termin festlegen",
    "EVENT_CARD_ATTENDED": "War dabei",
    "EVENT_CARD_ATTENDING": "Zugesagt",
    "EVENT_CARD_REGISTER_SOON": "Anmeldefrist bald vorbei",
    "EVENT_CARD_SEATS_LEFT.one": "Noch ein Platz frei",
    "EVENT_CARD_SEATS_LEFT.other": "Noch {seatsAvailable} Plätze frei",
    "EV_205_LINKED_EVENTS_MORE_OCCURRENCES": "weitere Termine",
    "EV_RSVP_SAVE": "Merken",
    "EV_RSVP_SAVED": " Gemerkt",
    "XE_FREE_TICKET": "KOSTENLOS",
    "XE_ONLINE_EVENT_INFO": "Online-Event",
    "BENEFIT_OVERVIEW_PREMIUM": "Premium",
    "FOOTER_DEVBLOG": "Devblog",
    "FOOTER_SPIELRAUM": "spielraum",
    "MYXING_NAV_FUTURME": "FutureMe",
    "PREMIUM_OFFERS_ARBEITSRECHTSSCHUTZ_PARTNERNAME": "XING Arbeitsrechtsschutz",
    "VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER": "Freelancer verwalten",
    "VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE": "NWX – Neues zur Zukunft der Arbeit"
  }
}